import { useEffect, useRef, useState } from "react";
import HelpButton from "../components/HelpButton";

const emptyInvoiceSettings = {
  numbering_start_date: "2026-01-01",
  numbering_prefix: "2026-",
  numbering_next: 1,
  numbering_padding: 4,
  numbering_pattern: "PREFIXNNNN",

  company_name: "",
  company_address_1: "",
  company_address_2: "",
  company_postcode: "",
  company_city: "",
  company_country: "",
  company_email: "",
  company_website: "",
  company_phone: "",
  company_kvk: "",
  company_vat: "",
  company_iban: "",
company_g_iban: "",

invoice_title: "Factuur",
invoice_contact_person: "",
payment_text: "",
footer_text: "",

offer_title: "Offerte",
offer_contact_person: "",
offer_company_name: "",
offer_company_address_1: "",
offer_company_address_2: "",
offer_company_postcode: "",
offer_company_city: "",
offer_company_country: "",
offer_company_email: "",
offer_company_website: "",
offer_company_phone: "",
offer_company_kvk: "",
offer_company_vat: "",
offer_company_iban: "",
offer_company_g_iban: "",
offer_text: "",
offer_footer_text: "",

logo_url: "",
layout_json: "{}",
};


const emptyMkbInvoiceSettings = {
  document_title: "Factuur",
  contact_person: "",
  company_name: "",
  company_address_1: "",
  company_address_2: "",
  company_postcode: "",
  company_city: "",
  company_country: "",
  company_email: "",
  company_website: "",
  company_phone: "",
  company_kvk: "",
  company_vat: "",
  company_iban: "",
  company_g_iban: "",
  logo_url: "",
  intro_text: "",
  payment_text: "Wij verzoeken u vriendelijk het bovenstaande bedrag vóór de vervaldatum te voldoen onder vermelding van het factuurnummer.",
  footer_text: "",
  email_subject: "Factuur {document_nummer}",
  email_bcc: "",
  email_text: `Geachte {contactpersoon},

Hierbij ontvangt u onze factuur {document_nummer} voor {relatie}.

De factuur is als PDF bijgevoegd.

Met vriendelijke groet,
{verzender_naam}`,
};

const emptyMkbLetterheadSettings = {
  use_own_letterhead: false,
  show_recipient_phone: false,
  show_recipient_email: false,
  letterhead_file_name: "",
  letterhead_mime_type: "",
  letterhead_data_url: "",
};


const emptyMkbOrderSettings = {
  document_title: "Opdrachtbevestiging",
  contact_person: "",
  company_name: "",
  company_address_1: "",
  company_address_2: "",
  company_postcode: "",
  company_city: "",
  company_country: "",
  company_email: "",
  company_website: "",
  company_phone: "",
  company_kvk: "",
  company_vat: "",
  company_iban: "",
  company_g_iban: "",
  logo_url: "",
  intro_text: "Hierbij bevestigen wij de met u gemaakte afspraken voor onderstaande opdracht.",
  footer_text: "",
  email_subject: "Opdrachtbevestiging {referentie}",
  email_text: `Geachte {contactpersoon},

Hierbij ontvangt u onze opdrachtbevestiging {referentie} voor {relatie}.

Met vriendelijke groet,
{verzender_naam}`,
  whatsapp_text: `Beste {contactpersoon},

Wij hebben opdrachtbevestiging {referentie} voor {relatie} klaargezet.

Beknopte inhoud:
{beknopte_inhoud}

U kunt de opdracht bekijken en digitaal akkoord geven via:
{akkoordlink}

Met vriendelijke groet,
{verzender_naam}`,
  approval_text: "Ik ben bevoegd om namens deze organisatie akkoord te geven en ik ga akkoord met deze opdrachtbevestiging.",
  approved_page_text: "Dank u. Uw akkoord op de opdrachtbevestiging is ontvangen en geregistreerd.",
  rejected_page_text: "Uw keuze om niet akkoord te gaan met de opdrachtbevestiging is ontvangen en geregistreerd.",
};

const emptyMkbWorkOrderSettings = {
  document_title: "Werkbon / Oplevering",
  company_name: "",
  company_address_1: "",
  company_address_2: "",
  company_postcode: "",
  company_city: "",
  company_country: "",
  company_email: "",
  company_website: "",
  company_phone: "",
  company_kvk: "",
  company_vat: "",
  company_iban: "",
  company_g_iban: "",
  logo_url: "",
  intro_text: "",
  execution_title: "Uitvoering",
  completion_title: "Oplevering",
  work_title: "Opdrachtwerkzaamheden",
  extra_work_title: "Extra materialen / werkzaamheden",
  approval_block_text: "Voor akkoord / oplevering",
  footer_text: "Werkbon automatisch gegenereerd vanuit StaffIQ.",
  email_subject: "Werkbon / Oplevering {document_nummer}",
  email_text: `Geachte {contactpersoon},

Hierbij ontvangt u de werkbon / oplevering {document_nummer} voor {relatie}.

De werkbon is als PDF bijgevoegd.

Met vriendelijke groet,
{verzender_naam}`,
  whatsapp_text: `Beste {contactpersoon},

Wij hebben de werkbon / oplevering {document_nummer} voor {relatie} klaargezet.

Beknopte inhoud:
{beknopte_inhoud}

U kunt de werkbon / oplevering bekijken en digitaal akkoord geven via:
{akkoordlink}

Met vriendelijke groet,
{verzender_naam}`,
  approval_text: "Ik ben bevoegd om namens deze organisatie akkoord te geven en ik ga akkoord met deze werkbon / oplevering.",
  approved_page_text: "Dank u. Uw akkoord op de werkbon / oplevering is ontvangen en geregistreerd.",
  rejected_page_text: "Uw keuze om niet akkoord te gaan met de werkbon / oplevering is ontvangen en geregistreerd.",
};

const emptyMkbOfferSettings = {
  offer_title: "Offerte",
  offer_contact_person: "",
  offer_company_name: "",
  offer_company_address_1: "",
  offer_company_address_2: "",
  offer_company_postcode: "",
  offer_company_city: "",
  offer_company_country: "",
  offer_company_email: "",
  offer_company_website: "",
  offer_company_phone: "",
  offer_company_kvk: "",
  offer_company_vat: "",
  offer_company_iban: "",
  offer_company_g_iban: "",
  logo_url: "",
  offer_text: "",
  offer_footer_text: "",
  validity_days: 14,
  email_subject: "Offerte {referentie}",
  email_text: `Geachte {contactpersoon},

Hierbij ontvangt u onze offerte {referentie}.

Met vriendelijke groet,
{verzender_naam}`,
  whatsapp_text: `Beste {contactpersoon},

Wij hebben offerte {referentie} voor {relatie} klaargezet.

U kunt de offerte bekijken en digitaal akkoord geven via:
{akkoordlink}

Met vriendelijke groet,
{verzender_naam}`,
  approval_text: "Ik ben bevoegd om namens deze organisatie akkoord te geven en ik ga akkoord met dit document.",
  approved_page_text: "Dank u. Uw akkoord is ontvangen en geregistreerd.",
  rejected_page_text: "Uw keuze om niet akkoord te gaan is ontvangen en geregistreerd.",
};



const emptyHrmVacancySettings = {
  show_relation: true,
  show_contact: true,
  show_function: true,
  show_vacancy_title: true,
  show_number_requested: true,
  show_period: true,
  show_notice_period: true,
  show_hours_per_week: true,
  show_weekends: true,
  show_schedule: true,
  show_location: true,
  show_location_contact: true,
  show_registration_procedure: true,
  show_work_description: true,
  show_requirements: true,
  show_offer: true,
  show_education: true,
  show_experience: true,
  show_certificates: true,
  show_driving_license: true,
  show_transport: true,
  show_employment_types: true,
  show_languages: true,
  show_cao: true,
  show_rate_indication: true,
  show_priority: true,
  show_external_text: true,
  show_external_note: true,
  show_factor: false,
  show_min_rate: false,
  show_invoice_agreement: false,
  show_internal_description: false,
  show_internal_note: false,
  document_title: "Vacature",
  company_name: "",
  company_address_1: "",
  company_address_2: "",
  company_postcode: "",
  company_city: "",
  company_country: "",
  company_email: "",
  company_website: "",
  company_phone: "",
  company_kvk: "",
  company_vat: "",
  company_iban: "",
  company_g_iban: "",
  logo_url: "",
  intro_text: "Hierbij ontvangt u de gegevens van onze vacature.",
  footer_text: "Vacature automatisch gegenereerd vanuit StaffIQ.",
  email_subject: "Vacature {document_nummer}",
  email_text: `Geachte {contactpersoon},

Hierbij ontvangt u vacature {document_nummer} voor {relatie}.

Met vriendelijke groet,
{verzender_naam}`,
  whatsapp_text: `Beste {contactpersoon},

Hierbij ontvangt u de gegevens van vacature {document_nummer} voor {relatie}.

Met vriendelijke groet,
{verzender_naam}`,
};

const emptyHrmPlacementCustomerSettings = {
  document_title: "Plaatsingsbevestiging klant",
  company_name: "",
  company_address_1: "",
  company_address_2: "",
  company_postcode: "",
  company_city: "",
  company_country: "",
  company_email: "",
  company_website: "",
  company_phone: "",
  company_kvk: "",
  company_vat: "",
  company_iban: "",
  company_g_iban: "",
  logo_url: "",
  intro_text: "Hierbij bevestigen wij de plaatsing van {kandidaat} bij {relatie}.",
  footer_text: "Plaatsingsbevestiging automatisch gegenereerd vanuit StaffIQ.",
  email_subject: "Plaatsingsbevestiging {document_nummer} ter akkoord",
  email_text: `Geachte {contactpersoon},

Hierbij ontvangt u de plaatsingsbevestiging {document_nummer} voor {relatie}.

Beknopte inhoud:
{beknopte_inhoud}

U kunt het document bekijken en digitaal akkoord geven via onderstaande link:
{akkoordlink}

Met vriendelijke groet,
{verzender_naam}`,
  whatsapp_text: `Beste {contactpersoon},

Wij hebben de plaatsingsbevestiging voor {relatie} klaargezet.

Beknopte inhoud:
{beknopte_inhoud}

U kunt de plaatsingsbevestiging bekijken en digitaal akkoord geven via:
{akkoordlink}

Met vriendelijke groet,
{verzender_naam}`,
  approval_text: "Ik ben bevoegd om namens deze organisatie akkoord te geven en ik ga akkoord met deze plaatsingsbevestiging.",
  approved_page_text: "Dank u. Uw akkoord op de plaatsingsbevestiging is ontvangen en geregistreerd.",
  rejected_page_text: "Uw keuze om niet akkoord te gaan met de plaatsingsbevestiging is ontvangen en geregistreerd.",

  // Documentinhoud plaatsingsbevestiging klant
  show_function: true,
  show_relation: true,
  show_contact: true,
  show_candidate: true,
  show_start_date: true,
  show_end_date: true,
  show_notice_period: true,
  show_hours_per_week: true,
  show_weekends: true,
  show_schedule: true,
  show_location: true,
  show_location_contact: true,
  show_registration_procedure: true,
  show_employment_type: false,
  show_cao: true,
  show_wage_period: false,
  show_hourly_wage: false,
  show_invoice_period: true,
  show_sales_rate: true,
  show_factor: false,
  show_transport: true,
  show_customer_travel_costs: true,
  show_travel_costs: true,
  show_allowances: true,
  show_invoice_agreement: true,
  show_external_note: true,
};

const emptyHrmPlacementCandidateSettings = {
  document_title: "Plaatsingsbevestiging kandidaat",
  company_name: "",
  company_address_1: "",
  company_address_2: "",
  company_postcode: "",
  company_city: "",
  company_country: "",
  company_email: "",
  company_website: "",
  company_phone: "",
  company_kvk: "",
  company_vat: "",
  company_iban: "",
  company_g_iban: "",
  logo_url: "",
  intro_text: "Hierbij bevestigen wij jouw plaatsing bij {relatie}.",
  footer_text: "Plaatsingsbevestiging automatisch gegenereerd vanuit StaffIQ.",
  email_subject: "Plaatsingsbevestiging {document_nummer} ter akkoord",
  email_text: `Beste {contactpersoon},

Hierbij ontvang je jouw plaatsingsbevestiging {document_nummer}.

Beknopte inhoud:
{beknopte_inhoud}

Je kunt het document bekijken en digitaal akkoord geven via onderstaande link:
{akkoordlink}

Met vriendelijke groet,
{verzender_naam}`,
  whatsapp_text: `Beste {contactpersoon},

Wij hebben jouw plaatsingsbevestiging klaargezet.

Beknopte inhoud:
{beknopte_inhoud}

Je kunt de plaatsingsbevestiging bekijken en digitaal akkoord geven via:
{akkoordlink}

Met vriendelijke groet,
{verzender_naam}`,
  approval_text: "Ik ga akkoord met deze plaatsingsbevestiging.",
  approved_page_text: "Dank je. Jouw akkoord op de plaatsingsbevestiging is ontvangen en geregistreerd.",
  rejected_page_text: "Jouw keuze om niet akkoord te gaan met de plaatsingsbevestiging is ontvangen en geregistreerd.",

  // Documentinhoud plaatsingsbevestiging kandidaat
  show_function: true,
  show_relation: true,
  show_contact: true,
  show_candidate: true,
  show_start_date: true,
  show_end_date: true,
  show_notice_period: true,
  show_hours_per_week: true,
  show_weekends: true,
  show_schedule: true,
  show_location: true,
  show_location_contact: true,
  show_registration_procedure: true,
  show_employment_type: false,
  show_cao: true,
  show_wage_period: true,
  show_hourly_wage: true,
  show_transport: true,
  show_travel_costs: true,
  show_allowances: true,
  show_external_note: true,
};

const emptyHrmMatchingPersonnelInternalSettings = {
  show_search_name: true,
  show_name: true,
  show_status: true,
  show_function: true,
  show_gender: true,
  show_birth_date: true,
  show_phone: true,
  show_mobile: true,
  show_email: true,
  show_website: true,
  show_visit_address: true,
  show_driving_license: true,
  show_own_transport: true,
  show_zzp: true,
  show_hourly_wage: true,
  show_sales_rate: true,
  show_monthly_wage: true,
  show_experience: true,
  show_id_document: true,
  show_note: true,
  show_photo: true,
  show_matching: true,
};

const emptyHrmMatchingPersonnelExternalSettings = {
  show_search_name: false,
  show_name: true,
  show_status: false,
  show_function: true,
  show_gender: true,
  show_birth_date: true,
  show_phone: false,
  show_mobile: false,
  show_email: false,
  show_website: false,
  show_visit_address: false,
  show_driving_license: true,
  show_own_transport: true,
  show_zzp: true,
  show_hourly_wage: false,
  show_sales_rate: false,
  show_monthly_wage: false,
  show_experience: true,
  show_id_document: false,
  show_note: true,
  show_photo: false,
  show_matching: true,
};

const emptyHrmMatchingRelationsInternalSettings = {
  show_search_name: true,
  show_relation_form: true,
  show_name: true,
  show_first_name: true,
  show_initials: true,
  show_name_prefix: true,
  show_last_name: true,
  show_gender: true,
  show_birth_date: true,
  show_relation_type: true,
  show_administration: true,
  show_first_contact_date: true,
  show_phone: true,
  show_mobile: true,
  show_email: true,
  show_website: true,
  show_visit_address: true,
  show_correspondence_address: true,
  show_kvk: true,
  show_vat_number: true,
  show_payment_term: true,
  show_payment_method: true,
  show_active: true,
  show_note: true,
  show_matching: true,
};

const emptyHrmMatchingRelationsExternalSettings = {
  show_search_name: false,
  show_relation_form: true,
  show_name: true,
  show_first_name: false,
  show_initials: false,
  show_name_prefix: false,
  show_last_name: false,
  show_gender: true,
  show_birth_date: false,
  show_relation_type: true,
  show_administration: true,
  show_first_contact_date: false,
  show_phone: false,
  show_mobile: false,
  show_email: false,
  show_website: true,
  show_visit_address: false,
  show_correspondence_address: false,
  show_kvk: false,
  show_vat_number: false,
  show_payment_term: false,
  show_payment_method: false,
  show_active: true,
  show_note: false,
  show_matching: true,
};

const emptyCrmMessageSettings = {
  email_subject: "Bericht van {bedrijfsnaam}",
  email_text: `Geachte {contactpersoon},

{bericht}

Met vriendelijke groet,
{verzender_naam}`,
  whatsapp_text: `Beste {contactpersoon},

{bericht}

Met vriendelijke groet,
{verzender_naam}`,
  task_assigned_subject: "Nieuwe taak toegewezen: {taak_titel}",
  task_assigned_text: `Beste {uitvoerder},

Er is een nieuwe taak aan je toegewezen.

Relatie: {relatie}
Contactpersoon: {contactpersoon}
Vervaldatum: {vervaldatum} {vervaltijd}
Titel: {taak_titel}
Tekst: {taak_tekst}

Open StaffIQ om de taak te bekijken.`,
  task_reminder_subject: "Herinnering taak: {taak_titel}",
  task_reminder_text: `Beste {ontvanger},

Dit is een herinnering voor een openstaande taak.

Relatie: {relatie}
Contactpersoon: {contactpersoon}
Personeel: {personeel}
Uitvoerder: {uitvoerder}
Aangemaakt door: {aanmaker}
Vervaldatum: {vervaldatum} {vervaltijd}
Titel: {taak_titel}
Tekst: {taak_tekst}

Open StaffIQ om de taak te bekijken.`,
  task_completed_subject: "Taak afgerond: {taak_titel}",
  task_completed_text: `Beste {aanmaker},

De taak die je hebt aangemaakt is afgerond.

Relatie: {relatie}
Contactpersoon: {contactpersoon}
Personeel: {personeel}
Uitvoerder: {uitvoerder}
Vervaldatum: {vervaldatum} {vervaltijd}
Titel: {taak_titel}
Tekst: {taak_tekst}

Open StaffIQ om de taak te bekijken.`,
};

// vINS-079: beveiligde SMTP-afzender per tenant; het SMTP-wachtwoord komt nooit terug uit de API.
const emptyEmailSenderSettings = {
  email_method: "central", // central | smtp | graph
  use_custom_smtp: false,
  from_name: "",
  from_email: "",
  reply_to: "",
  smtp_host: "",
  smtp_port: 587,
  smtp_secure: false,
  smtp_user: "",
  has_password: false,
  graph_tenant_id: "",
  graph_client_id: "",
  graph_mailbox: "",
  graph_certificate_ready: false,
};

const emptyCommunicationSettings = {
  email_enabled: true,
  whatsapp_enabled: true,
  sms_enabled: false,
  default_country_code: "+31",
  messagebird_api_key: "",
  bird_workspace_id: "",
  bird_sms_channel_id: "",
  messagebird_originator: "",
  default_sms_text: "",
  default_whatsapp_text: "",
};

const emptyApprovalTextSettings = {
  approval_whatsapp_offer_text: `Beste {contactpersoon},

Wij hebben offerte {referentie} voor {relatie} klaargezet.

Beknopte inhoud:
{beknopte_inhoud}

U kunt de offerte bekijken en digitaal akkoord geven via:
{akkoordlink}

Met vriendelijke groet,
{verzender_naam}`,
  approval_whatsapp_order_text: `Beste {contactpersoon},

Wij hebben opdracht {referentie} voor {relatie} klaargezet.

Beknopte inhoud:
{beknopte_inhoud}

U kunt de opdracht bekijken en digitaal akkoord geven via:
{akkoordlink}

Met vriendelijke groet,
{verzender_naam}`,
  approval_email_offer_subject: "Offerte {referentie} ter akkoord",
  approval_email_offer_text: `Geachte {contactpersoon},

Hierbij ontvangt u onze offerte {referentie} voor {relatie}.

Beknopte inhoud:
{beknopte_inhoud}

U kunt het document bekijken en digitaal akkoord geven via onderstaande knop:

{akkoordlink}

Het document is ook als PDF-bijlage toegevoegd.`,
  approval_email_order_subject: "Opdracht {referentie} ter akkoord",
  approval_email_order_text: `Geachte {contactpersoon},

Hierbij ontvangt u onze opdracht {referentie} voor {relatie}.

Beknopte inhoud:
{beknopte_inhoud}

U kunt het document bekijken en digitaal akkoord geven via onderstaande knop:

{akkoordlink}

Het document is ook als PDF-bijlage toegevoegd.`,

  approval_whatsapp_placement_customer_text: `Beste {contactpersoon},

Wij hebben de plaatsingsbevestiging voor {relatie} klaargezet.

Beknopte inhoud:
{beknopte_inhoud}

U kunt de plaatsingsbevestiging bekijken en digitaal akkoord geven via:
{akkoordlink}

Met vriendelijke groet,
{verzender_naam}`,
  approval_whatsapp_placement_candidate_text: `Beste {contactpersoon},

Wij hebben jouw plaatsingsbevestiging klaargezet.

Beknopte inhoud:
{beknopte_inhoud}

Je kunt de plaatsingsbevestiging bekijken en digitaal akkoord geven via:
{akkoordlink}

Met vriendelijke groet,
{verzender_naam}`,
  approval_email_placement_customer_subject: "Plaatsingsbevestiging {document_nummer} ter akkoord",
  approval_email_placement_customer_text: `Geachte {contactpersoon},

Hierbij ontvangt u de plaatsingsbevestiging {document_nummer} voor {relatie}.

Beknopte inhoud:
{beknopte_inhoud}

U kunt het document bekijken en digitaal akkoord geven via onderstaande knop:

{akkoordlink}

Het document is ook als PDF-bijlage toegevoegd.`,
  approval_email_placement_candidate_subject: "Plaatsingsbevestiging {document_nummer} ter akkoord",
  approval_email_placement_candidate_text: `Beste {contactpersoon},

Hierbij ontvang je jouw plaatsingsbevestiging {document_nummer}.

Beknopte inhoud:
{beknopte_inhoud}

Je kunt het document bekijken en digitaal akkoord geven via onderstaande knop:

{akkoordlink}

Het document is ook als PDF-bijlage toegevoegd.`,

  approval_confirm_approved_subject: "{document_soort} {document_nummer} akkoord ontvangen",
  approval_confirm_approved_text: `Het digitale akkoord is ontvangen.

Document: {document_soort} {document_nummer}
Relatie: {relatie}
Akkoord door: {akkoord_naam} ({akkoord_email})
Opmerking: {opmerking}`,
  approval_confirm_rejected_subject: "{document_soort} {document_nummer} niet akkoord ontvangen",
  approval_confirm_rejected_text: `Er is digitaal niet akkoord gegeven.

Document: {document_soort} {document_nummer}
Relatie: {relatie}
Niet akkoord door: {akkoord_naam} ({akkoord_email})
Opmerking: {opmerking}`,
};

const emptyInvoiceTemplate = {
  id: null,
  name: "",
  subject: "",
  intro_text: "Hierbij ontvangt u onze factuur voor de uitgevoerde werkzaamheden.",
  payment_text: "Wij verzoeken u het factuurbedrag binnen 14 dagen te voldoen onder vermelding van het factuurnummer.",
  footer_text: "Voor vragen over deze factuur kunt u contact opnemen per e-mail of telefoon.",
  active: true,
};

const emptyOfferTemplate = {
  id: null,
  name: "",
  template_type: "offer",
  subject: "",
  show_subject: true,
  salutation: "{aanhef}",
  show_salutation: true,
  intro_text: "",
  show_intro_text: true,
  body_text: "",
  show_body_text: true,
  conditions_text: "",
  show_conditions_text: true,
  payment_text: "",
  show_payment_text: true,
  planning_text: "",
  show_planning_text: true,
  remark_text: "",
  show_remark_text: true,
  warranty_text: "",
  show_warranty_text: true,
  closing_text: "",
  show_closing_text: true,
  show_agreement_block: true,
  agreement_text: "Naam:________________________________________\nDatum:_______________________________________",
  active: true,
};

const RELATION_CHOICE_CATEGORIES = [
  { key: "administration_type", label: "Administratietypen" },
  { key: "payment_terms", label: "Betalingscondities" },
  { key: "payment_term_days", label: "Betaaltermijnen" },
  { key: "payment_method", label: "Betaalwijzen" },
  { key: "vat_rate", label: "BTW-tarieven" },
  { key: "country", label: "Landen" },
  { key: "region", label: "Regio's" },
  { key: "relation_type", label: "Relatiesoorten" },
].sort((a, b) => a.label.localeCompare(b.label, "nl"));

const emptyRelationChoice = {
  id: null,
  list_key: RELATION_CHOICE_CATEGORIES[0]?.key || "administration_type",
  value: "",
  active: true,
};



const emptyDocumentType = {
  id: null,
  name: "",
  category: "",
  applies_to: "both",
  monitor_validity: false,
  use_valid_from: false,
  use_valid_until: false,
  use_document_number: false,
  default_validity_months: "",
  active: true,
  sort_order: 0,
};

const emptyDocumentSet = {
  id: null,
  name: "",
  description: "",
  source_type: "personnel",
  active: true,
  sort_order: 0,
  items: [],
};

const DOCUMENT_CATEGORIES = [
  "Identiteit",
  "Certificaat",
  "Contract",
  "Financieel",
  "Personeelsdossier",
  "Overig",
];

const RICH_TEXT_ALLOWED_FONTS = [
  "Calibri",
  "Arial",
  "Verdana",
  "Times New Roman",
];

function escapeRichTextHtml(value = "") {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function normalizeRichTextHtml(value = "") {
  const raw = String(value || "")
    // Oude editorcodes voor spaties mogen niet als tekst zichtbaar worden.
    .replace(/&(?:amp;)+nbsp;|&nbsp;|&#160;|&#x[aA]0;/gi, " ")
    .replace(/\u00a0/g, " ");
  // vINS-079 - Communicatie: eigen SMTP-afzender per tenant met beveiligd wachtwoord en testmail; centrale servermail blijft standaard.
 // vINS-078: bewaar opzettelijke lege beginregels, ook na verlaten van het tekstveld.
  if (!raw.trim()) return "";

  const looksLikeHtml = /<\/?(?:b|strong|i|em|u|br|div|p|span|font|ul|ol|li)\b/i.test(raw);
  if (!looksLikeHtml) {
    return escapeRichTextHtml(raw).replace(/\r?\n/g, "<br>");
  }

  if (typeof window === "undefined" || typeof DOMParser === "undefined") {
    return raw;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${raw}</div>`, "text/html");
  const root = doc.body.firstElementChild;

  const allowedTags = new Set([
    "B", "STRONG", "I", "EM", "U", "BR", "DIV", "P", "SPAN", "FONT", "UL", "OL", "LI", "UL", "OL", "LI",
  ]);

  function cleanNode(node) {
    [...node.childNodes].forEach((child) => {
      if (child.nodeType === Node.COMMENT_NODE) {
        child.remove();
        return;
      }

      if (child.nodeType !== Node.ELEMENT_NODE) return;

      if (!allowedTags.has(child.tagName)) {
        child.replaceWith(...child.childNodes);
        return;
      }

      // Legacy HTML <font size="3"> is browserstandaard circa 12 pt,
      // terwijl de StaffIQ-toolbar dit als 11 pt aanduidt.
      // Zet uitsluitend deze oude FONT-tag om; expliciete CSS-opmaak blijft behouden.
      if (child.tagName === "FONT") {
        const legacyFace = String(child.getAttribute("face") || "").replace(/["']/g, "").trim();
        const legacySize = String(child.getAttribute("size") || "").trim();
        const legacySizePt = {
          "1": "8pt", "2": "10pt", "3": "11pt", "4": "14pt",
          "5": "18pt", "6": "24pt", "7": "36pt",
        }[legacySize] || "";
        const span = doc.createElement("span");
        if (RICH_TEXT_ALLOWED_FONTS.includes(legacyFace)) span.style.fontFamily = legacyFace;
        if (legacySizePt) span.style.fontSize = legacySizePt;
        while (child.firstChild) span.appendChild(child.firstChild);
        child.replaceWith(span);
        cleanNode(span);
        return;
      }

      [...child.attributes].forEach((attr) => {
        const name = attr.name.toLowerCase();

        if (child.tagName === "FONT" && (name === "face" || name === "size")) {
          if (name === "face" && !RICH_TEXT_ALLOWED_FONTS.includes(attr.value)) {
            child.removeAttribute(attr.name);
          }
          if (name === "size" && !/^[1-7]$/.test(attr.value)) {
            child.removeAttribute(attr.name);
          }
          return;
        }

        if (["SPAN", "DIV", "P", "LI"].includes(child.tagName) && name === "style") {
          const safeRules = String(attr.value || "")
            .split(";")
            .map((rule) => rule.trim())
            .filter(Boolean)
            .filter((rule) => {
              const lower = rule.toLowerCase();
              return (
                lower.startsWith("font-family:") ||
                lower.startsWith("font-size:") ||
                lower.startsWith("font-weight:") ||
                lower.startsWith("font-style:") ||
                lower.startsWith("text-decoration:") ||
                lower.startsWith("line-height:")
              );
            })
            .join("; ");

          if (safeRules) child.setAttribute("style", safeRules);
          else child.removeAttribute("style");
          return;
        }

        child.removeAttribute(attr.name);
      });

      cleanNode(child);
    });
  }

  cleanNode(root);
  // vINS-078: geen automatische verwijdering van de eerste lege alinea.
  // <br>, <div><br></div> en <p><br></p> worden bewust bewaard.
  return root.innerHTML;
}

function isRichTextHtml(value = "") {
  return /<\/?(?:b|strong|i|em|u|br|div|p|span|font|ul|ol|li)\b/i.test(
    String(value || "")
  );
}

function richTextPlainText(value = "") {
  const html = normalizeRichTextHtml(value);

  if (typeof document === "undefined") {
    return String(html || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
  }

  const div = document.createElement("div");
  div.innerHTML = html;
  return String(div.innerText || div.textContent || "").trim();
}

function RichTextToolbar({ editorRef, disabled = false, compact = false, onContentChange = null }) {
  const [activeFont, setActiveFont] = useState("");
  const [activeSize, setActiveSize] = useState("");
  const [activeLineHeight, setActiveLineHeight] = useState("");
  const [activeBold, setActiveBold] = useState(false);
  const [activeItalic, setActiveItalic] = useState(false);
  const [activeUnderline, setActiveUnderline] = useState(false);
  const [hasSelection, setHasSelection] = useState(false);
  const [editorIsEmpty, setEditorIsEmpty] = useState(false);
  const [pendingFont, setPendingFont] = useState("Calibri");
  const [pendingSize, setPendingSize] = useState("3");
  const [pendingLineHeight, setPendingLineHeight] = useState("1.15");
  const [pendingBold, setPendingBold] = useState(false);
  const [pendingItalic, setPendingItalic] = useState(false);
  const [pendingUnderline, setPendingUnderline] = useState(false);
  const savedRangeRef = useRef(null);

  function selectionIsInsideEditor(range) {
    const editor = editorRef?.current;
    if (!editor || !range) return false;

    const node = range.commonAncestorContainer;
    const element = node?.nodeType === Node.ELEMENT_NODE ? node : node?.parentElement;
    return !!element && (element === editor || editor.contains(element));
  }

  function selectionHasText(range) {
    return !!range && !range.collapsed && String(range.toString() || "").length > 0;
  }

  function rememberEditorSelection() {
    try {
      const selection = window.getSelection();
      if (!selection || selection.rangeCount === 0) return;

      const range = selection.getRangeAt(0);
      if (selectionIsInsideEditor(range)) {
        savedRangeRef.current = range.cloneRange();
      }
    } catch {}
  }

  function restoreEditorSelection() {
    try {
      const range = savedRangeRef.current;
      if (!range) return;

      const selection = window.getSelection();
      if (!selection) return;

      selection.removeAllRanges();
      selection.addRange(range);
    } catch {}
  }

  function normalizeActiveFont(raw) {
    const value = String(raw || "")
      .replace(/["']/g, "")
      .trim()
      .toLowerCase();

    if (!value) return "";

    return (
      RICH_TEXT_ALLOWED_FONTS.find((font) => {
        const wanted = font.toLowerCase();
        return value === wanted || value.startsWith(`${wanted},`) || value.includes(wanted);
      }) || ""
    );
  }

  function fontSizeToCommandValue(raw) {
    const px = parseFloat(String(raw || ""));
    if (!Number.isFinite(px)) return "";
    if (px <= 13.6) return "2";   // ca. 10 pt
    if (px <= 16.6) return "3";   // ca. 11 pt
    if (px <= 21.5) return "4";   // ca. 14 pt
    return "5";                   // ca. 18 pt
  }

  function normalizeLineHeight(raw, element) {
    let value = parseFloat(String(raw || ""));
    if (!Number.isFinite(value) || value <= 0) return "";

    // getComputedStyle geeft line-height vaak in pixels terug.
    if (value > 4) {
      const fontSize = parseFloat(window.getComputedStyle(element).fontSize || "");
      if (Number.isFinite(fontSize) && fontSize > 0) value /= fontSize;
    }

    const allowed = [1, 1.15, 1.5, 2];
    let best = allowed[0];
    let diff = Math.abs(value - best);
    for (const candidate of allowed.slice(1)) {
      const d = Math.abs(value - candidate);
      if (d < diff) {
        best = candidate;
        diff = d;
      }
    }
    return diff <= 0.18 ? String(best) : "";
  }

  function collectSelectionElements(range) {
    const editor = editorRef?.current;
    if (!editor || !range || !selectionIsInsideEditor(range)) return [];

    const elements = new Set();

    const addElement = (node) => {
      const el = node?.nodeType === Node.ELEMENT_NODE ? node : node?.parentElement;
      if (el && (el === editor || editor.contains(el))) elements.add(el);
    };

    addElement(range.startContainer);
    addElement(range.endContainer);

    const walker = document.createTreeWalker(editor, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue) continue;
      try {
        if (range.intersectsNode(node)) addElement(node);
      } catch {}
    }

    return [...elements];
  }

  function commonValue(values) {
    const clean = values.filter((v) => v !== null && v !== undefined && v !== "");
    if (!clean.length) return "";
    const first = String(clean[0]);
    return clean.every((v) => String(v) === first) ? first : "";
  }

  function updateActiveFormatting() {
    try {
      const editor = editorRef?.current;
      const selection = window.getSelection();
      if (!editor || !selection || selection.rangeCount === 0) return;

      const range = selection.getRangeAt(0);
      if (!selectionIsInsideEditor(range)) return;

      savedRangeRef.current = range.cloneRange();
      const selected = selectionHasText(range);
      const empty = String(editor.innerText || editor.textContent || "").replace(/\u200B/g, "").trim() === "";
      setHasSelection(selected);
      setEditorIsEmpty(empty);

      // Zonder selectie: alleen tonen wat voor het HELE blok gelijk is.
      // Met selectie: alleen tonen wat binnen de SELECTIE gelijk is.
      let elements = [];
      if (selected) {
        elements = collectSelectionElements(range);
      } else {
        const walker = document.createTreeWalker(editor, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if (String(node.nodeValue || "").length > 0) {
            const el = node.parentElement || editor;
            elements.push(el);
          }
        }
        if (!elements.length) elements = [editor];
      }

      const fonts = elements.map((el) =>
        normalizeActiveFont(window.getComputedStyle(el).fontFamily)
      );
      const sizes = elements.map((el) =>
        fontSizeToCommandValue(window.getComputedStyle(el).fontSize)
      );
      const lines = elements.map((el) =>
        normalizeLineHeight(window.getComputedStyle(el).lineHeight, el)
      );

      if (!empty) {
        setActiveFont(commonValue(fonts));
        setActiveSize(commonValue(sizes));
        setActiveLineHeight(commonValue(lines));
      }

      if (selected) {
        setActiveBold(document.queryCommandState("bold") === true);
        setActiveItalic(document.queryCommandState("italic") === true);
        setActiveUnderline(document.queryCommandState("underline") === true);
      } else {
        setActiveBold(false);
        setActiveItalic(false);
        setActiveUnderline(false);
      }
    } catch {}
  }

  useEffect(() => {
    const handleSelectionChange = () => updateActiveFormatting();

    document.addEventListener("selectionchange", handleSelectionChange);
    const timer = setTimeout(handleSelectionChange, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("selectionchange", handleSelectionChange);
    };
  }, [editorRef]);

  function getSelectedRangeForChange() {
    restoreEditorSelection();

    const editor = editorRef?.current;
    const selection = window.getSelection();
    if (!editor || !selection || selection.rangeCount === 0) return null;

    const range = selection.getRangeAt(0);
    if (!selectionIsInsideEditor(range)) return null;

    // Bestaande tekst: alleen een echte selectie mag worden gewijzigd.
    if (selectionHasText(range)) return range;

    // Leeg tekstveld: de cursor mag wel de opmaak voor nieuw te typen tekst bepalen.
    const empty = String(editor.innerText || editor.textContent || "").replace(/\u200B/g, "").trim() === "";
    if (range.collapsed && empty) return range;

    return null;
  }

  function prepareEmptyEditorTypingFormat(next = {}) {
    const editor = editorRef?.current;
    if (!editor || disabled) return false;

    const empty = String(editor.innerText || editor.textContent || "").replace(/\u200B/g, "").trim() === "";
    if (!empty) return false;

    const font = next.font ?? pendingFont ?? "Calibri";
    const size = next.size ?? pendingSize ?? "3";
    const lineHeight = next.lineHeight ?? pendingLineHeight ?? "1.15";
    const bold = next.bold ?? pendingBold;
    const italic = next.italic ?? pendingItalic;
    const underline = next.underline ?? pendingUnderline;

    setPendingFont(font);
    setPendingSize(size);
    setPendingLineHeight(lineHeight);
    setPendingBold(!!bold);
    setPendingItalic(!!italic);
    setPendingUnderline(!!underline);

    const sizePx = { "2": "13.333px", "3": "14.667px", "4": "18.667px", "5": "24px" }[String(size)] || "14.667px";

    editor.innerHTML = "";
    const span = document.createElement("span");
    span.style.fontFamily = font;
    span.style.fontSize = sizePx;
    span.style.lineHeight = lineHeight;
    span.style.fontWeight = bold ? "700" : "400";
    span.style.fontStyle = italic ? "italic" : "normal";
    span.style.textDecoration = underline ? "underline" : "none";

    const textNode = document.createTextNode("\u200B");
    span.appendChild(textNode);
    editor.appendChild(span);

    const range = document.createRange();
    range.setStart(textNode, 1);
    range.collapse(true);

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    savedRangeRef.current = range.cloneRange();

    editor.focus();
    setEditorIsEmpty(true);
    setHasSelection(false);
    setActiveFont(font);
    setActiveSize(String(size));
    setActiveLineHeight(String(lineHeight));

    return true;
  }

  function applyLineHeight(value) {
    if (disabled) return;

    try {
      const range = getSelectedRangeForChange();
      if (!range) return;

      const editor = editorRef?.current;

      // In een leeg veld geldt de gekozen regelhoogte voor de tekst die hierna wordt getypt.
      if (range.collapsed && editorIsEmpty) {
        prepareEmptyEditorTypingFormat({ lineHeight: value });
        return;
      }

      const touched = new Set();

      const addBlock = (node) => {
        let el = node?.nodeType === Node.ELEMENT_NODE ? node : node?.parentElement;
        while (el && el !== editor) {
          if (["DIV", "P", "LI"].includes(el.tagName)) {
            touched.add(el);
            return;
          }
          el = el.parentElement;
        }
      };

      addBlock(range.startContainer);
      addBlock(range.endContainer);

      const walker = document.createTreeWalker(editor, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        try {
          if (range.intersectsNode(node)) addBlock(node);
        } catch {}
      }

      // Geen blok-element aanwezig: omwikkel uitsluitend de selectie.
      if (!touched.size) {
        const span = document.createElement("span");
        span.style.lineHeight = value;
        try {
          range.surroundContents(span);
        } catch {
          const fragment = range.extractContents();
          span.appendChild(fragment);
          range.insertNode(span);
        }
      } else {
        touched.forEach((el) => {
          el.style.lineHeight = value;
        });
      }

      setActiveLineHeight(String(value || ""));
      if (editor && typeof onContentChange === "function") {
        onContentChange(normalizeRichTextHtml(editor.innerHTML));
      }

      rememberEditorSelection();
      setTimeout(updateActiveFormatting, 0);
    } catch {}
  }

  function exec(command, value = null) {
    if (disabled) return;

    try {
      const range = getSelectedRangeForChange();
      if (!range) return;

      if (range.collapsed && editorIsEmpty) {
        if (command === "fontName") {
          prepareEmptyEditorTypingFormat({ font: value });
          return;
        }
        if (command === "fontSize") {
          prepareEmptyEditorTypingFormat({ size: value });
          return;
        }
        if (command === "bold") {
          prepareEmptyEditorTypingFormat({ bold: !pendingBold });
          return;
        }
        if (command === "italic") {
          prepareEmptyEditorTypingFormat({ italic: !pendingItalic });
          return;
        }
        if (command === "underline") {
          prepareEmptyEditorTypingFormat({ underline: !pendingUnderline });
          return;
        }
      }

      editorRef?.current?.focus?.();
      restoreEditorSelection();
      document.execCommand(command, false, value);

      const editor = editorRef?.current;
      if (editor && typeof onContentChange === "function") {
        onContentChange(normalizeRichTextHtml(editor.innerHTML));
      }

      rememberEditorSelection();
      setTimeout(updateActiveFormatting, 0);
    } catch {}
  }

  const canFormat = hasSelection || editorIsEmpty;
  const selectionDisabled = disabled || !canFormat;

  const buttonStyle = {
    minWidth: 32,
    height: 30,
    padding: "0 8px",
    border: "1px solid #cfd8e3",
    borderRadius: 5,
    background: "#fff",
    cursor: selectionDisabled ? "not-allowed" : "pointer",
    opacity: selectionDisabled ? 0.5 : 1,
    fontSize: 13,
    fontWeight: 700,
  };

  return (
    <div
      className="rich-text-toolbar"
      style={{
        display: "flex",
        gap: 6,
        flexWrap: "wrap",
        alignItems: "center",
        marginBottom: compact ? 5 : 7,
      }}
    >
      <select
        value={editorIsEmpty ? pendingFont : activeFont}
        disabled={selectionDisabled}
        onMouseDown={(e) => {
          e.stopPropagation();
          rememberEditorSelection();
        }}
        onChange={(e) => {
          const value = e.target.value;
          if (value) exec("fontName", value);
        }}
        style={{
          height: 30,
          minWidth: 120,
          border: "1px solid #cfd8e3",
          borderRadius: 5,
          background: "#fff",
        }}
        title={hasSelection ? "Lettertype van selectie" : editorIsEmpty ? "Lettertype voor nieuwe tekst" : "Selecteer eerst tekst om het lettertype te wijzigen"}
      >
        <option value="">—</option>
        {RICH_TEXT_ALLOWED_FONTS.map((font) => (
          <option key={font} value={font}>{font}</option>
        ))}
      </select>

      <select
        value={editorIsEmpty ? pendingSize : activeSize}
        disabled={selectionDisabled}
        onMouseDown={(e) => {
          e.stopPropagation();
          rememberEditorSelection();
        }}
        onChange={(e) => {
          const value = e.target.value;
          if (value) exec("fontSize", value);
        }}
        style={{
          height: 30,
          minWidth: 100,
          border: "1px solid #cfd8e3",
          borderRadius: 5,
          background: "#fff",
        }}
        title={hasSelection ? "Tekstgrootte van selectie" : editorIsEmpty ? "Tekstgrootte voor nieuwe tekst" : "Selecteer eerst tekst om de tekstgrootte te wijzigen"}
      >
        <option value="">—</option>
        <option value="2">10</option>
        <option value="3">11</option>
        <option value="4">14</option>
        <option value="5">18</option>
      </select>

      <select
        value={editorIsEmpty ? pendingLineHeight : activeLineHeight}
        disabled={selectionDisabled}
        onMouseDown={(e) => { e.stopPropagation(); rememberEditorSelection(); }}
        onChange={(e) => {
          const value = e.target.value;
          if (value) applyLineHeight(value);
        }}
        style={{ height: 30, minWidth: 125, border: "1px solid #cfd8e3", borderRadius: 5, background: "#fff" }}
        title={hasSelection ? "Regelhoogte van selectie" : editorIsEmpty ? "Regelhoogte voor nieuwe tekst" : "Selecteer eerst tekst om de regelhoogte te wijzigen"}
      >
        <option value="">—</option>
        <option value="1">Regel 1,0</option>
        <option value="1.15">Regel 1,15</option>
        <option value="1.5">Regel 1,5</option>
        <option value="2">Regel 2,0</option>
      </select>

      <button
        type="button"
        disabled={selectionDisabled}
        style={{
          ...buttonStyle,
          background: (hasSelection && activeBold) || (editorIsEmpty && pendingBold) ? "#dbeafe" : "#fff",
          borderColor: (hasSelection && activeBold) || (editorIsEmpty && pendingBold) ? "#2f7dd1" : "#cfd8e3",
          color: (hasSelection && activeBold) || (editorIsEmpty && pendingBold) ? "#0b4f7a" : "#111",
          boxShadow: (hasSelection && activeBold) || (editorIsEmpty && pendingBold) ? "inset 0 0 0 1px #2f7dd1" : "none",
        }}
        onMouseDown={(e) => { e.preventDefault(); rememberEditorSelection(); exec("bold"); }}
        title={hasSelection ? (activeBold ? "Vet is actief" : "Vet") : "Selecteer eerst tekst"}
        aria-pressed={(hasSelection && activeBold) || (editorIsEmpty && pendingBold)}
      >
        B
      </button>

      <button
        type="button"
        disabled={selectionDisabled}
        style={{
          ...buttonStyle,
          fontStyle: "italic",
          background: (hasSelection && activeItalic) || (editorIsEmpty && pendingItalic) ? "#dbeafe" : "#fff",
          borderColor: (hasSelection && activeItalic) || (editorIsEmpty && pendingItalic) ? "#2f7dd1" : "#cfd8e3",
          color: (hasSelection && activeItalic) || (editorIsEmpty && pendingItalic) ? "#0b4f7a" : "#111",
          boxShadow: (hasSelection && activeItalic) || (editorIsEmpty && pendingItalic) ? "inset 0 0 0 1px #2f7dd1" : "none",
        }}
        onMouseDown={(e) => { e.preventDefault(); rememberEditorSelection(); exec("italic"); }}
        title={hasSelection ? (activeItalic ? "Cursief is actief" : "Cursief") : "Selecteer eerst tekst"}
        aria-pressed={(hasSelection && activeItalic) || (editorIsEmpty && pendingItalic)}
      >
        I
      </button>

      <button
        type="button"
        disabled={selectionDisabled}
        style={{
          ...buttonStyle,
          textDecoration: "underline",
          background: (hasSelection && activeUnderline) || (editorIsEmpty && pendingUnderline) ? "#dbeafe" : "#fff",
          borderColor: (hasSelection && activeUnderline) || (editorIsEmpty && pendingUnderline) ? "#2f7dd1" : "#cfd8e3",
          color: (hasSelection && activeUnderline) || (editorIsEmpty && pendingUnderline) ? "#0b4f7a" : "#111",
          boxShadow: (hasSelection && activeUnderline) || (editorIsEmpty && pendingUnderline) ? "inset 0 0 0 1px #2f7dd1" : "none",
        }}
        onMouseDown={(e) => { e.preventDefault(); rememberEditorSelection(); exec("underline"); }}
        title={hasSelection ? (activeUnderline ? "Onderstrepen is actief" : "Onderstrepen") : "Selecteer eerst tekst"}
        aria-pressed={(hasSelection && activeUnderline) || (editorIsEmpty && pendingUnderline)}
      >
        U
      </button>

      <button
        type="button"
        disabled={selectionDisabled}
        style={{ ...buttonStyle, minWidth: 42 }}
        onMouseDown={(e) => { e.preventDefault(); rememberEditorSelection(); exec("insertUnorderedList"); }}
        title={hasSelection ? "Opsomming met bullets" : "Selecteer eerst tekst"}
      >
        •
      </button>

      <button
        type="button"
        disabled={selectionDisabled}
        style={{ ...buttonStyle, minWidth: 42 }}
        onMouseDown={(e) => { e.preventDefault(); rememberEditorSelection(); exec("insertOrderedList"); }}
        title={hasSelection ? "Genummerde lijst" : "Selecteer eerst tekst"}
      >
        1.
      </button>
    </div>
  );
}

// vINS-081: Word-/Office-opmaak komt bij plakken NIET mee in rich-text sjablonen.
// Alleen echte letters, leestekens, inspringing en regeleinden blijven over.
function cleanWordClipboardText(value = "") {
  return String(value || "")
    .replace(/\r\n?/g, "\n")
    .replace(/[\u0085\u2028\u2029]/g, "\n")
    .replace(/[\u00a0\u2000-\u200a\u202f\u205f\u3000]/g, " ")
    // Verborgen Word-tekens (o.a. zachte afbreking, zero-width en schrijfrichting).
    .replace(/[\u00ad\u034f\u061c\u180e\u200b-\u200f\u202a-\u202e\u2060-\u206f\ufeff]/g, "")
    .replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f-\u009f]/g, "");
}

// Houd tekst tegen de bovenrand; standaard <p>-marges geven anders een schijnbare lege regel.
const STAFFIQ_RICH_TEXT_TOP_CSS = `.staffiq-rich-text-surface > :first-child { margin-top: 0 !important; }
.staffiq-rich-text-surface > :last-child { margin-bottom: 0 !important; }`;
function RichTextEditor({
  value,
  onChange,
  disabled = false,
  minHeight = 110,
  placeholder = "",
  toolbarVisible = true,
  onActivate = null,
  externalRef = null,
}) {
  const editorRef = useRef(null);

  function setEditorRefs(el) {
    editorRef.current = el;
    if (externalRef && typeof externalRef === "object") {
      externalRef.current = el;
    }
  }

  useEffect(() => {
    if (!editorRef.current) return;

    // Tijdens typen beheert contentEditable zelf de DOM en cursor.
    // React mag de inhoud dan NIET opnieuw invullen na iedere toetsaanslag.
    // Dit is dezelfde werkende oplossing als in Offertes vOFF-125.
    if (document.activeElement === editorRef.current) return;

    const normalized = normalizeRichTextHtml(value);
    if (editorRef.current.innerHTML !== normalized) {
      editorRef.current.innerHTML = normalized;
    }
  }, [value]);

  return (
    <div>
      <style>{STAFFIQ_RICH_TEXT_TOP_CSS}</style>
      {toolbarVisible && (
        <RichTextToolbar editorRef={editorRef} disabled={disabled} onContentChange={onChange} />
      )}
      <div
        ref={setEditorRefs}
        className="staffiq-rich-text-surface"
        contentEditable={!disabled}
        suppressContentEditableWarning
        spellCheck
        data-placeholder={placeholder}
        onPaste={(e) => {
          if (disabled) return;
          // vINS-081: tekst uit Word/Outlook altijd zonder HTML, fonts en Word-stijlen invoegen.
          e.preventDefault();
          const pasted = cleanWordClipboardText(e.clipboardData?.getData("text/plain") || "");
          if (!pasted) return;

          const editor = e.currentTarget;
          editor.focus();
          // insertText volgt de cursor/selectie en behoudt de bestaande StaffIQ-opmaak.
          // Een veilige HTML-terugval bewaart ook meerdere lege regels.
          const done = document.execCommand("insertText", false, pasted);
          if (!done) {
            document.execCommand("insertHTML", false, escapeRichTextHtml(pasted).replace(/\n/g, "<br>"));
          }
          onChange(editor.innerHTML);
        }}
        onMouseDown={() => onActivate?.()}
        onFocus={() => onActivate?.()}
        onInput={(e) => {
          const el = e.currentTarget;

          // Zero-width marker alleen verwijderen zodra echte tekst aanwezig is.
          if (String(el.innerText || el.textContent || "").replace(/\u200B/g, "").length > 0) {
            const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
            let node;
            while ((node = walker.nextNode())) {
              if (node.nodeValue?.includes("\u200B")) {
                node.nodeValue = node.nodeValue.replace(/\u200B/g, "");
              }
            }
          }

          // Tijdens invoer browser-HTML rechtstreeks bewaren.
          // Normaliseren pas bij verlaten van het veld.
          onChange(el.innerHTML);
        }}
        onBlur={(e) => {
          const cleaned = normalizeRichTextHtml(e.currentTarget.innerHTML).replace(/\u200B/g, "");
          if (e.currentTarget.innerHTML !== cleaned) {
            e.currentTarget.innerHTML = cleaned;
          }
          onChange(cleaned);
        }}
        style={{
          minHeight,
          padding: "9px 10px",
          border: "1px solid #d9d9d9",
          borderRadius: 5,
          background: disabled ? "#f7f7f7" : "#fff",
          boxSizing: "border-box",
          fontFamily: "Calibri, Carlito, Arial, sans-serif",
          fontSize: "11pt",
          lineHeight: 1.15,
          whiteSpace: "normal",
          overflowWrap: "anywhere",
          cursor: disabled ? "not-allowed" : "text",
        }}
      />
    </div>
  );
}




// vINS-082: omzetting is uitsluitend voor MKB Offerte/Opdrachtcommunicatie.
// De overige, zelf aangepaste sjabloontekst blijft letterlijk behouden.
function mkbReferenceVariable(text = "") {
  return String(text ?? "").replace(/\{document_nummer\}/gi, "{referentie}");
}
function mkbReferenceTemplates(settings = {}) {
  return {
    ...settings,
    email_subject: mkbReferenceVariable(settings.email_subject),
    email_text: mkbReferenceVariable(settings.email_text),
    whatsapp_text: mkbReferenceVariable(settings.whatsapp_text),
  };
}
function approvalReferenceTemplates(settings = {}) {
  const out = { ...settings };
  for (const key of [
    "approval_whatsapp_offer_text", "approval_whatsapp_order_text",
    "approval_email_offer_subject", "approval_email_offer_text",
    "approval_email_order_subject", "approval_email_order_text",
  ]) {
    if (out[key] != null) out[key] = mkbReferenceVariable(out[key]);
  }
  return out;
}

// vINS-086 - Legacy FONT size=3 consequent als 11 pt normaliseren; bestaande sjabloonopmaak behouden.
// vINS-085 - Documenteditor blijft standaard Calibri 11 pt / 1,15; expliciete opmaak behouden.
export default function Instellingen() {

// vINS-084
// - MKB Opdrachten: één Opslaan-knop bewaart zowel opdrachtgegevens en briefpapier
//   als de tenantbrede instelling Werkbonnen. Dubbele opslagknop verwijderd.
// - Bestaande afzonderlijke pagina Werkbonnen, instellingen en API's ongewijzigd.
// vINS-083
// - E-mailafzender: centrale SMTP, eigen SMTP of Microsoft Graph per klant kiezen; Graph zonder wachtwoord, certificaat blijft op server.
// - Testmail meldt Graph-acceptatie; bestaande CRM/MKB/HRM-instellingen ongewijzigd.
// vINS-082
// - Offertes/Opdrachten: variabele {referentie} uit het vrije Referentieveld i.p.v. intern {document_nummer}; bestaande sjabloonteksten automatisch omzetten zonder overige inhoud te wijzigen.
// vINS-081
// - Plakken in rich-text sjablonen: Word-/Office-HTML en verborgen tekens verwijderen; gewone tekst en blanco regels behouden.
// - Bestaande sjabloonopmaak, opslag en overige instellingen ongewijzigd.
// vINS-080
// - E-mailafzender: voorbeelden en uitleg generiek gemaakt (StaffIQ i.p.v. klantnaam Bartels); werking ongewijzigd.
// vINS-078
// - Rich-text sjablonen: zelf ingevoerde lege eerste regels blijven bij wijzigen, opslaan en heropenen bewaard.
// - Alleen de normalisatie aangepast; overige sjabloon- en instellingenfuncties onveranderd.
// vINS-077
// - MKB Offertes/Opdrachten: per bedrijfscode mobiel/telefoon en e-mail van klant optioneel op documentkop (standaard uit).
// - Bestaande briefpapier- en sjablooninstellingen blijven behouden; geen databasekolommen toegevoegd.
// vINS-076
// - Offerte-/opdrachtsjablonen: Onderwerp heeft nu dezelfde lettertype-/opmaakopties als de andere rubrieken.
// - Calibri 11 pt is de standaard voor nieuwe tekst; expliciet gekozen bestaande opmaak behouden.
// vINS-075
// - Blanco Aanhef wordt automatisch {aanhef}; invoercode met uitleg bij Offertesjablonen.
// vINS-074
// - Offertesjablonen: {aanhef} uit Relaties als dynamische variabele verduidelijkt.
// - Rich-text: HTML-spaties en onbedoelde lege eerste regels genormaliseerd; opmaak behouden.
// vINS-073
// Briefpapier-upload verduidelijkt en beperkt tot PNG, zodat dezelfde stabiele A4-achtergrond wordt gebruikt in MKB-documenten.
// vINS-072
// UI: iets meer ruimte toegevoegd tussen label Briefpapier upload en de knop Bestand kiezen.
// MKB: gedeeld eigen briefpapier per bedrijfscode toegevoegd voor Offertes, Opdrachten, Werkbonnen en Facturen.
// Facturen: instelbaar BCC e-mailadres toegevoegd; server gebruikt dit automatisch bij factuurmail.
// Offerte-/opdrachtsjablonen: per rubriek een vinkje 'Tonen'; standaard aan.
// FIX tekstinvoer: spatie en Backspace blijven normaal werken tijdens rich-text invoer.
// Rich-text selectiegedrag gelijk aan Projectbeheer vPRJ-054.
// Leeg veld: vooraf gekozen opmaak blijft actief tijdens typen.
// Bestaande tekst: alleen geselecteerde tekst kan worden opgemaakt; zonder selectie niets wijzigen.
// Rich-text opmaak gelijkgetrokken met Offertes/Projectbeheer:
// Historisch Arial 11; vanaf vINS-076 standaard Calibri 11, regelhoogte 1,15; opmaakkeuze zichtbaar
// en actieve Vet/Cursief/Onderstrepen-knoppen duidelijk gemarkeerd.
const VERSION = "vINS-086";
const API_BASE = "";

function getStoredUserForHeaders() {
  try {
    return JSON.parse(
      sessionStorage.getItem("user") ||
      localStorage.getItem("user") ||
      "{}"
    );
  } catch {
    return {};
  }
}

function authHeaders(extra = {}) {
  const token =
    sessionStorage.getItem("token") ||
    localStorage.getItem("token") ||
    "";

  const tenant =
    sessionStorage.getItem("tenant") ||
    localStorage.getItem("tenant") ||
    "demo";

  const user = getStoredUserForHeaders();
  const companyCodeIds =
    sessionStorage.getItem("staffiq_company_code_ids") ||
    localStorage.getItem("staffiq_company_code_ids") ||
    "";

  const headers = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    "x-tenant": tenant,
    "x-role": user?.role || "user",
    // v083: beheeracties vereisen de server-uitgegeven actieve sessie, niet alleen gebruikersheaders.
    ...(user?.session_key ? { "x-session-key": String(user.session_key) } : {}),
    ...(user?.id ? { "x-staffiq-user-id": String(user.id) } : {}),
    ...(user?.email ? { "x-staffiq-user-email": String(user.email) } : {}),
    ...(user?.display_name || user?.name
      ? { "x-staffiq-user-name": String(user.display_name || user.name) }
      : {}),
    ...(companyCodeIds ? { "x-company-code-ids": companyCodeIds } : {}),
    ...extra,
  };

  Object.keys(headers).forEach((key) => {
    if (headers[key] === undefined || headers[key] === null || headers[key] === "") {
      delete headers[key];
    }
  });

  return headers;
}

function authOnlyHeaders(extra = {}) {
  const headers = authHeaders(extra);
  delete headers["Content-Type"];
  return headers;
}

const rawUser =
  sessionStorage.getItem("user") ||
  localStorage.getItem("user") ||
  "";

function getIsAdmin() {
  try {
    const raw =
      sessionStorage.getItem("user") ||
      localStorage.getItem("user") ||
      "";

    if (!raw) return false;

    const user = JSON.parse(raw);

    const roleName = String(user?.role || "").toLowerCase().trim();
    const roleId = String(user?.role_id || "").trim();

    // 🔒 ALLEEN ADMIN IS ADMIN
    if (roleName === "admin" || roleId === "1") {
      return true;
    }

    return false;
  } catch (e) {
    console.log("Fout bij bepalen admin:", e);
    return false;
  }
}

const isAdmin = getIsAdmin();

  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selected, setSelected] = useState(null);

const [view, setView] = useState("general"); // algemene, CRM-, MKB-, HRM-, bedrijfs- en gebruikersinstellingen

  const [flash, setFlash] = useState("");
  const [invoiceFlash, setInvoiceFlash] = useState("");
  const [showPassword, setShowPassword] = useState(false);

const [generalSettings, setGeneralSettings] = useState({
  use_organisations: true,
  use_particulieren: false,
  staffiq_profile: "ALL",
  offer_prices_include_vat: false,
});

const [orderSettings, setOrderSettings] = useState({
  use_work_orders: false,
});
const loadedWorkOrdersRef = useRef(null);

const [invoiceSettings, setInvoiceSettings] = useState(emptyInvoiceSettings);
  const [mkbInvoiceSettings, setMkbInvoiceSettings] = useState(emptyMkbInvoiceSettings);
  const [mkbInvoiceSettingsLoading, setMkbInvoiceSettingsLoading] = useState(false);
  const [mkbLetterheadSettings, setMkbLetterheadSettings] = useState(emptyMkbLetterheadSettings);
  const [mkbLetterheadSettingsLoading, setMkbLetterheadSettingsLoading] = useState(false);
  const [mkbOfferSettings, setMkbOfferSettings] = useState(emptyMkbOfferSettings);
  const [mkbOfferSettingsLoading, setMkbOfferSettingsLoading] = useState(false);
  const [mkbOrderSettings, setMkbOrderSettings] = useState(emptyMkbOrderSettings);
  const [mkbOrderSettingsLoading, setMkbOrderSettingsLoading] = useState(false);
  const [mkbOrderFlash, setMkbOrderFlash] = useState("");
  const [mkbWorkOrderSettings, setMkbWorkOrderSettings] = useState(emptyMkbWorkOrderSettings);
  const [mkbWorkOrderSettingsLoading, setMkbWorkOrderSettingsLoading] = useState(false);
  const [mkbWorkOrderFlash, setMkbWorkOrderFlash] = useState("");
  const [hrmVacancySettings, setHrmVacancySettings] = useState(emptyHrmVacancySettings);
  const [hrmVacancySettingsLoading, setHrmVacancySettingsLoading] = useState(false);
  const [hrmVacancyFlash, setHrmVacancyFlash] = useState("");
  const [hrmPlacementCustomerSettings, setHrmPlacementCustomerSettings] = useState(emptyHrmPlacementCustomerSettings);
  const [hrmPlacementCustomerSettingsLoading, setHrmPlacementCustomerSettingsLoading] = useState(false);
  const [hrmPlacementCustomerFlash, setHrmPlacementCustomerFlash] = useState("");
  const [hrmPlacementCandidateSettings, setHrmPlacementCandidateSettings] = useState(emptyHrmPlacementCandidateSettings);
  const [hrmPlacementCandidateSettingsLoading, setHrmPlacementCandidateSettingsLoading] = useState(false);
  const [hrmPlacementCandidateFlash, setHrmPlacementCandidateFlash] = useState("");
  const [hrmMatchingPersonnelInternalSettings, setHrmMatchingPersonnelInternalSettings] = useState(emptyHrmMatchingPersonnelInternalSettings);
  const [hrmMatchingPersonnelInternalLoading, setHrmMatchingPersonnelInternalLoading] = useState(false);
  const [hrmMatchingPersonnelInternalFlash, setHrmMatchingPersonnelInternalFlash] = useState("");
  const [hrmMatchingPersonnelExternalSettings, setHrmMatchingPersonnelExternalSettings] = useState(emptyHrmMatchingPersonnelExternalSettings);
  const [hrmMatchingPersonnelExternalLoading, setHrmMatchingPersonnelExternalLoading] = useState(false);
  const [hrmMatchingPersonnelExternalFlash, setHrmMatchingPersonnelExternalFlash] = useState("");
  const [hrmMatchingRelationsInternalSettings, setHrmMatchingRelationsInternalSettings] = useState(emptyHrmMatchingRelationsInternalSettings);
  const [hrmMatchingRelationsInternalLoading, setHrmMatchingRelationsInternalLoading] = useState(false);
  const [hrmMatchingRelationsInternalFlash, setHrmMatchingRelationsInternalFlash] = useState("");
  const [hrmMatchingRelationsExternalSettings, setHrmMatchingRelationsExternalSettings] = useState(emptyHrmMatchingRelationsExternalSettings);
  const [hrmMatchingRelationsExternalLoading, setHrmMatchingRelationsExternalLoading] = useState(false);
  const [hrmMatchingRelationsExternalFlash, setHrmMatchingRelationsExternalFlash] = useState("");
  const [documentLocation, setDocumentLocation] = useState("C:/StaffIQ/Documenten");
  const [documentMasterTab, setDocumentMasterTab] = useState("types");
  const [documentTypes, setDocumentTypes] = useState([]);
  const [selectedDocumentType, setSelectedDocumentType] = useState({ ...emptyDocumentType });
  const [documentTypeFlash, setDocumentTypeFlash] = useState("");
  const [documentSets, setDocumentSets] = useState([]);
  const [selectedDocumentSet, setSelectedDocumentSet] = useState({ ...emptyDocumentSet });
  const [documentSetFlash, setDocumentSetFlash] = useState("");

  const [crmMessageSettings, setCrmMessageSettings] = useState(emptyCrmMessageSettings);
  const [crmMessageSettingsLoading, setCrmMessageSettingsLoading] = useState(false);
  const [crmMessageFlash, setCrmMessageFlash] = useState("");
  const [communicationSettings, setCommunicationSettings] = useState(emptyCommunicationSettings);
  const [emailSenderSettings, setEmailSenderSettings] = useState(emptyEmailSenderSettings);
  const [emailSenderLoading, setEmailSenderLoading] = useState(false);
  const [emailSenderSaving, setEmailSenderSaving] = useState(false);
  const [emailSenderFlash, setEmailSenderFlash] = useState("");
  const [emailSenderPassword, setEmailSenderPassword] = useState("");
  const [emailSenderTestTo, setEmailSenderTestTo] = useState("");
  const [emailSenderTesting, setEmailSenderTesting] = useState(false);
  const [communicationFlash, setCommunicationFlash] = useState("");
  const [approvalTextSettings, setApprovalTextSettings] = useState(emptyApprovalTextSettings);
  const [approvalTextFlash, setApprovalTextFlash] = useState("");
  const [offerTemplates, setOfferTemplates] = useState([]);
  const [selectedOfferTemplate, setSelectedOfferTemplate] = useState(emptyOfferTemplate);
  const [invoiceTemplates, setInvoiceTemplates] = useState([]);
  const [selectedInvoiceTemplate, setSelectedInvoiceTemplate] = useState(emptyInvoiceTemplate);
  const [templateFlash, setTemplateFlash] = useState("");
  const [invoiceTemplateFlash, setInvoiceTemplateFlash] = useState("");
  const [saveSuccess, setSaveSuccess] = useState(false);

  // Centrale keuzelijsten voor Relaties
  const [relationChoices, setRelationChoices] = useState([]);
  const [selectedRelationChoiceCategory, setSelectedRelationChoiceCategory] = useState(
    RELATION_CHOICE_CATEGORIES[0]?.key || "administration_type"
  );
  const [selectedRelationChoice, setSelectedRelationChoice] = useState({
    ...emptyRelationChoice,
  });
  const [relationChoiceFlash, setRelationChoiceFlash] = useState("");

  // Bedrijfscodes
  const [companyCodes, setCompanyCodes] = useState([]);
  const [selectedCompanyCode, setSelectedCompanyCode] = useState({
    id: null,
    code: "",
    name: "",
    active: true,
  });
  const [companyCodeFlash, setCompanyCodeFlash] = useState("");
  const [settingsCompanyCodeBySection, setSettingsCompanyCodeBySection] = useState({});
  const [userCompanyCodes, setUserCompanyCodes] = useState([]);
  const [userCompanyCodesFlash, setUserCompanyCodesFlash] = useState("");

  // Gebruikerslogboek
  const [activityLog, setActivityLog] = useState([]);
  const [activitySessions, setActivitySessions] = useState([]);
  const [activityLoading, setActivityLoading] = useState(false);
  const [activityTab, setActivityTab] = useState("log"); // log | sessions
  const [activitySearch, setActivitySearch] = useState("");
  const [activityModule, setActivityModule] = useState("");
  const [activityStatus, setActivityStatus] = useState("");
  const [activityDateFrom, setActivityDateFrom] = useState("");
  const [activityDateTo, setActivityDateTo] = useState("");
  const [showTechnicalActivity, setShowTechnicalActivity] = useState(false);
  const [cleanupMode, setCleanupMode] = useState("technical_30_days");
  const [cleanupBusy, setCleanupBusy] = useState(false);
  const isMobile = window.innerWidth <= 768;

  const normalizedSettingsProfile = String(
    generalSettings.staffiq_profile || "ALL"
  ).trim().toUpperCase();

  const showCrmSettings = ["CRM", "MKB", "HRM", "ALL"].includes(
    normalizedSettingsProfile
  );
  const showMkbSettings = ["MKB", "ALL"].includes(normalizedSettingsProfile);
  const showHrmSettings = ["HRM", "ALL"].includes(normalizedSettingsProfile);

  function settingsMenuButton(viewName, label, description = "") {
    return (
      <>
        <button
          type="button"
          onClick={() => {
            setView(viewName);
            scrollToDetailMobile();
          }}
          style={{
            width: "100%",
            textAlign: "left",
            padding: "10px 12px",
            background: view === viewName ? "#e6f0ff" : "white",
            color: "#111",
            border: "1px solid #d9e2ec",
            borderRadius: 6,
            cursor: "pointer",
            marginTop: 6,
          }}
        >
          {label}
        </button>

        {description ? (
          <div
            style={{
              marginTop: 5,
              marginBottom: 4,
              fontSize: 12,
              opacity: 0.72,
              lineHeight: 1.45,
            }}
          >
            {description}
          </div>
        ) : null}
      </>
    );
  }

  function settingsGroupTitle(title) {
    return (
      <h3
        style={{
          margin: "16px 0 6px 0",
          paddingBottom: 6,
          borderBottom: "2px solid #d9e2ec",
          color: "#17384d",
        }}
      >
        {title}
      </h3>
    );
  }

  function selectedSettingsCompanyCodeId(sectionKey) {
    return String(settingsCompanyCodeBySection?.[sectionKey] || "");
  }

  function setSelectedSettingsCompanyCodeId(sectionKey, value) {
    setSettingsCompanyCodeBySection((prev) => ({
      ...(prev || {}),
      [sectionKey]: String(value || ""),
    }));
  }

  function renderSettingsCompanyCodeSelector(sectionKey) {
    const selectedId = selectedSettingsCompanyCodeId(sectionKey);
    const selectedCode = (companyCodes || []).find(
      (code) => String(code.id) === selectedId
    );

    return (
      <div
        style={{
          margin: "0 0 18px 0",
          padding: 14,
          border: "1px solid #cfdbe6",
          borderRadius: 8,
          background: "#f7fbff",
          maxWidth: 900,
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "220px minmax(260px, 440px)",
            gap: 10,
            alignItems: "center",
          }}
        >
          <label style={{ fontWeight: 700 }}>Instellingen voor</label>

          <select
            value={selectedId}
            onChange={(e) => {
              const nextValue = e.target.value;
              setSelectedSettingsCompanyCodeId(sectionKey, nextValue);
              if (sectionKey === "crm_messages") {
                loadCrmMessageSettings(nextValue);
              }
              if (sectionKey === "mkb_offers") {
                loadMkbOfferSettings(nextValue);
                loadOfferTemplates(nextValue);
              }
              if (sectionKey === "mkb_orders") {
                loadMkbOrderSettings(nextValue);
              }
              if (sectionKey === "mkb_work_orders") {
                loadMkbWorkOrderSettings(nextValue);
              }
              if (sectionKey === "mkb_invoices") {
                loadMkbInvoiceSettings(nextValue);
              }
              if (["mkb_offers", "mkb_orders", "mkb_work_orders", "mkb_invoices"].includes(sectionKey)) {
                loadMkbLetterheadSettings(nextValue);
              }
              if (sectionKey === "hrm_vacancies") {
                loadHrmVacancySettings(nextValue);
              }
              if (sectionKey === "hrm_placement_customer") {
                loadHrmPlacementCustomerSettings(nextValue);
              }
              if (sectionKey === "hrm_placement_candidate") {
                loadHrmPlacementCandidateSettings(nextValue);
              }
              if (sectionKey === "hrm_matching_personnel_internal") {
                loadHrmMatchingPersonnelInternalSettings(nextValue);
              }
              if (sectionKey === "hrm_matching_personnel_external") {
                loadHrmMatchingPersonnelExternalSettings(nextValue);
              }
              if (sectionKey === "hrm_matching_relations_internal") {
                loadHrmMatchingRelationsInternalSettings(nextValue);
              }
              if (sectionKey === "hrm_matching_relations_external") {
                loadHrmMatchingRelationsExternalSettings(nextValue);
              }
            }}
            disabled={!isAdmin}
          >
            <option value="">Standaard voor alle bedrijfscodes</option>
            {(companyCodes || [])
              .filter((code) => code?.active !== false)
              .map((code) => (
                <option key={code.id} value={String(code.id)}>
                  {code.name || code.code}
                </option>
              ))}
          </select>
        </div>

        <div
          style={{
            marginTop: 9,
            fontSize: 12,
            color: "#5d6b78",
            lineHeight: 1.5,
          }}
        >
          {selectedCode ? (
            <>
              Je wijzigt straks alleen de instellingen van <b>{selectedCode.name || selectedCode.code}</b>.
            </>
          ) : (
            <>
              Deze standaardinstellingen worden bij opslaan automatisch ingevuld bij alle actieve bedrijfscodes.
              Daarna kunnen per bedrijfscode alleen de gewenste afwijkingen worden aangepast.
            </>
          )}
        </div>
      </div>
    );
  }

  const settingsTopRef = useRef(null);
  const detailRef = useRef(null);
  const offerTemplatesSectionRef = useRef(null);

  function scrollToDetailMobile() {
    setTimeout(() => {
      try {
        const detail = detailRef.current;
        if (!detail) return;

        detail.scrollIntoView?.({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });

        if (typeof detail.scrollTo === "function") {
          detail.scrollTo({ top: 0, behavior: "smooth" });
        }
      } catch {}
    }, 120);
  }

  function positionSettingsTop() {
    setTimeout(() => {
      try {
        settingsTopRef.current?.scrollIntoView?.({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      } catch {}

      try {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      } catch {}

      try {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      } catch {}

      try {
        const detail = detailRef.current;
        if (detail && typeof detail.scrollTo === "function") {
          detail.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
      } catch {}

      try {
        let parent = detailRef.current?.parentElement;
        while (parent) {
          const style = window.getComputedStyle(parent);
          const canScroll =
            /(auto|scroll)/.test(style.overflowY || "") &&
            parent.scrollHeight > parent.clientHeight;

          if (canScroll && typeof parent.scrollTo === "function") {
            parent.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          }

          parent = parent.parentElement;
        }
      } catch {}
    }, 150);
  }

  function positionOfferTemplatesTop() {
    setTimeout(() => {
      try {
        offerTemplatesSectionRef.current?.scrollIntoView?.({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      } catch {}
    }, 120);
  }

useEffect(() => {
    loadRoles();
    loadUsers();
    loadGeneralSettings();
    loadRelationChoices();
    loadOrderSettings();
    loadInvoiceSettings();
    loadMkbInvoiceSettings("");
    loadMkbOfferSettings("");
    loadMkbOrderSettings("");
    loadMkbWorkOrderSettings("");
    loadHrmVacancySettings("");
    loadHrmPlacementCustomerSettings("");
    loadHrmPlacementCandidateSettings("");
    loadHrmMatchingPersonnelInternalSettings("");
    loadHrmMatchingPersonnelExternalSettings("");
    loadHrmMatchingRelationsInternalSettings("");
    loadHrmMatchingRelationsExternalSettings("");
    loadDocumentSettings();
    loadDocumentTypes();
    loadDocumentSets();
    loadCommunicationSettings();
    if (isAdmin) loadEmailSenderSettings();
    loadCrmMessageSettings("");
    loadApprovalTextSettings();
    loadCompanyCodes();
    loadOfferTemplates();
    loadInvoiceTemplates();
  }, []);

  useEffect(() => {
    let sectionKey = "";

    if (view === "offers") sectionKey = "mkb_offers";
    if (view === "order_settings") sectionKey = "mkb_orders";
    if (view === "mkb_work_orders") sectionKey = "mkb_work_orders";
    if (view === "invoice") sectionKey = "mkb_invoices";

    if (!sectionKey) return;

    loadMkbLetterheadSettings(selectedSettingsCompanyCodeId(sectionKey));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view, settingsCompanyCodeBySection]);

async function loadRoles() {
  const r = await fetch(`${API_BASE}/api/roles`, {
    headers: authHeaders(),
  });

  const data = await r.json().catch(() => []);

  if (!r.ok) {
    console.log("Fout bij laden roles:", data);
    setRoles([]);
    return;
  }

  setRoles(Array.isArray(data) ? data : []);
}

async function loadUsers() {
  try {
    const res = await fetch(`${API_BASE}/api/users`, {
      headers: authHeaders(),
    });

    const data = await res.json().catch(() => []);

    if (!res.ok) {
      console.log("Fout bij laden users:", data);
      setUsers([]);
      setSelected((prev) => {
        if (!prev) return null;
        return null;
      });
      alert(data?.error || "Fout bij laden users");
      return;
    }

    if (Array.isArray(data)) {
      setUsers(data);

      setSelected((prev) => {
        if (!prev) return null;

        // Nieuwe gebruiker open laten staan
        if (!prev.id) return prev;

        const stillExists = data.find(
          (u) => String(u.id) === String(prev.id)
        );

        if (!stillExists) {
          return null;
        }

        return { ...stillExists, password: "" };
      });
    } else {
      console.log("API /api/users gaf geen array terug:", data);
      setUsers([]);
      setSelected((prev) => {
        if (!prev) return null;
        return null;
      });
      alert("Users konden niet goed worden geladen.");
    }
  } catch (err) {
    console.log("Fout bij laden users:", err);
    setUsers([]);
    setSelected((prev) => {
      if (!prev) return null;
      return null;
    });
    alert("Fout bij laden users");
  }
}

  async function loadInvoiceSettings() {
    try {
const r = await fetch(`${API_BASE}/api/invoice-settings`, {
  headers: authHeaders(),
});
      const data = await r.json();

      setInvoiceSettings({
        ...emptyInvoiceSettings,
        ...(data || {}),
      });
    } catch (err) {
      console.log("Fout bij laden factuurinstellingen:", err);
      alert("Factuurinstellingen konden niet worden geladen.");
    }
  }

async function loadDocumentSettings() {
    try {
const r = await fetch(`${API_BASE}/api/document-settings`, {
  headers: authHeaders(),
});
      const data = await r.json();

      setDocumentLocation(String(data?.document_base_path || "C:/StaffIQ/Documenten"));
    } catch (err) {
      console.log("Fout bij laden documentlocatie:", err);
      alert("Documentlocatie kon niet worden geladen.");
    }
  }

async function loadCrmMessageSettings(companyCodeId = selectedSettingsCompanyCodeId("crm_messages")) {
  try {
    setCrmMessageSettingsLoading(true);
    const qs = companyCodeId
      ? `?company_code_id=${encodeURIComponent(companyCodeId)}`
      : "";

    const res = await fetch(`${API_BASE}/api/company-section-settings/crm_messages${qs}`, {
      headers: authHeaders(),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || "CRM-teksten konden niet worden geladen.");

    setCrmMessageSettings({
      ...emptyCrmMessageSettings,
      ...(data?.settings || {}),
    });
  } catch (err) {
    console.log("Fout bij laden CRM-teksten:", err);
    setCrmMessageSettings(emptyCrmMessageSettings);
  } finally {
    setCrmMessageSettingsLoading(false);
  }
}

async function saveCrmMessageSettings() {
  if (!isAdmin) {
    alert("Alleen de administrator mag CRM-teksten wijzigen.");
    return;
  }

  try {
    const companyCodeId = selectedSettingsCompanyCodeId("crm_messages");
    const res = await fetch(`${API_BASE}/api/company-section-settings/crm_messages`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify({
        company_code_id: companyCodeId ? Number(companyCodeId) : null,
        settings: crmMessageSettings,
      }),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || "CRM-teksten opslaan mislukt.");

    positionSettingsTop();
    setCrmMessageFlash(
      companyCodeId
        ? "✅ CRM-teksten voor bedrijfscode opgeslagen"
        : `✅ Standaard opgeslagen en ingevuld bij ${data?.copied_to_company_codes || 0} bedrijfscode(s)`
    );
    setTimeout(() => setCrmMessageFlash(""), 2200);
  } catch (err) {
    alert(err?.message || "CRM-teksten opslaan mislukt.");
  }
}

async function loadCommunicationSettings() {
    try {
      const r = await fetch(`${API_BASE}/api/communication-settings`, {
        headers: authHeaders(),
      });

      const data = await r.json().catch(() => ({}));

      if (!r.ok) {
        console.log("Fout bij laden communicatie-instellingen:", data);
        setCommunicationSettings(emptyCommunicationSettings);
        return;
      }

      setCommunicationSettings({
        ...emptyCommunicationSettings,
        ...(data || {}),
        email_enabled: data?.email_enabled !== false,
        whatsapp_enabled: data?.whatsapp_enabled !== false,
        sms_enabled: data?.sms_enabled === true,
        default_country_code: data?.default_country_code || "+31",
        messagebird_api_key: data?.messagebird_api_key || "",
        bird_workspace_id: data?.bird_workspace_id || "",
        bird_sms_channel_id: data?.bird_sms_channel_id || "",
        messagebird_originator: data?.messagebird_originator || "",
        default_sms_text: data?.default_sms_text || "",
        default_whatsapp_text: data?.default_whatsapp_text || "",
      });
    } catch (err) {
      console.log("Fout bij laden communicatie-instellingen:", err);
      setCommunicationSettings(emptyCommunicationSettings);
    }
  }

async function saveCommunicationSettings() {
    if (!isAdmin) {
      alert("Alleen de administrator mag communicatie-instellingen wijzigen.");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/api/communication-settings`, {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify(communicationSettings),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        console.log("Opslaan communicatie-instellingen mislukt:", data);
        alert(data?.error || data?.message || "Opslaan communicatie-instellingen mislukt.");
        return;
      }

      setCommunicationSettings({
        ...emptyCommunicationSettings,
        ...(data || {}),
        email_enabled: data?.email_enabled !== false,
        whatsapp_enabled: data?.whatsapp_enabled !== false,
        sms_enabled: data?.sms_enabled === true,
        default_country_code: data?.default_country_code || "+31",
        messagebird_api_key: data?.messagebird_api_key || "",
        bird_workspace_id: data?.bird_workspace_id || "",
        bird_sms_channel_id: data?.bird_sms_channel_id || "",
        messagebird_originator: data?.messagebird_originator || "",
        default_sms_text: data?.default_sms_text || "",
        default_whatsapp_text: data?.default_whatsapp_text || "",
      });

      setCommunicationFlash("Communicatie-instellingen opgeslagen ✅");
      positionSettingsTop();
      setTimeout(() => setCommunicationFlash(""), 1800);
    } catch (err) {
      console.log("Fout bij opslaan communicatie-instellingen:", err);
      alert("Opslaan communicatie-instellingen mislukt.");
    }
  }


// vINS-079: geen SMTP-wachtwoord teruglezen of opnieuw tonen in het scherm.
async function loadEmailSenderSettings() {
  if (!isAdmin) return;
  setEmailSenderLoading(true);
  try {
    const r = await fetch(`${API_BASE}/api/email-sender-settings`, { headers: authHeaders() });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data?.error || "E-mailafzender laden mislukt.");
    setEmailSenderSettings({ ...emptyEmailSenderSettings, ...data });
    setEmailSenderPassword("");
  } catch (err) {
    setEmailSenderFlash(`E-mailafzender laden mislukt: ${err?.message || err}`);
  } finally {
    setEmailSenderLoading(false);
  }
}

async function saveEmailSenderSettings() {
  if (!isAdmin) return;
  setEmailSenderSaving(true);
  setEmailSenderFlash("");
  try {
    const r = await fetch(`${API_BASE}/api/email-sender-settings`, {
      method: "PUT", headers: authHeaders(),
      body: JSON.stringify({ ...emailSenderSettings, smtp_password: emailSenderPassword }),
    });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data?.error || "Opslaan van e-mailafzender mislukt.");
    setEmailSenderSettings({ ...emptyEmailSenderSettings, ...data });
    setEmailSenderPassword("");
    setEmailSenderFlash("E-mailinstellingen opgeslagen. Verstuur nu een testmail.");
  } catch (err) {
    setEmailSenderFlash(`Fout: ${err?.message || err}`);
  } finally {
    setEmailSenderSaving(false);
  }
}

async function testEmailSender() {
  if (!isAdmin || !emailSenderTestTo.trim()) {
    setEmailSenderFlash("Vul eerst het e-mailadres in waarop je de testmail wilt ontvangen.");
    return;
  }
  setEmailSenderTesting(true);
  setEmailSenderFlash("");
  try {
    const r = await fetch(`${API_BASE}/api/email-sender-settings/test`, {
      method: "POST", headers: authHeaders(), body: JSON.stringify({ to: emailSenderTestTo.trim() }),
    });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data?.error || "Testmail versturen mislukt.");
    if (!(data.accepted || []).length) throw new Error("Geen ontvanger door de mailserver geaccepteerd.");
    const isGraph = emailSenderSettings.email_method === "graph";
    setEmailSenderFlash(`Testmail vanaf ${data.from_email || "de ingestelde afzender"} door ${isGraph ? "Microsoft Graph (HTTP 202)" : "de mailserver"} geaccepteerd. Controleer de werkelijke ontvangst in je inbox (en spammap).`);
  } catch (err) {
    setEmailSenderFlash(`Testmail mislukt: ${err?.message || err}`);
  } finally {
    setEmailSenderTesting(false);
  }
}

async function loadApprovalTextSettings() {
  try {
    const r = await fetch(`${API_BASE}/api/approval-text-settings`, {
      headers: authHeaders(),
    });

    const data = await r.json().catch(() => ({}));

    if (!r.ok) {
      console.log("Fout bij laden akkoordteksten:", data);
      setApprovalTextSettings(emptyApprovalTextSettings);
      return;
    }

    setApprovalTextSettings(approvalReferenceTemplates({
      ...emptyApprovalTextSettings,
      ...(data || {}),
    }));
  } catch (err) {
    console.log("Fout bij laden akkoordteksten:", err);
    setApprovalTextSettings(emptyApprovalTextSettings);
  }
}

async function saveApprovalTextSettings() {
  if (!isAdmin) {
    alert("Alleen de administrator mag akkoordteksten wijzigen.");
    return;
  }

  try {
    const res = await fetch(`${API_BASE}/api/approval-text-settings`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify(approvalReferenceTemplates(approvalTextSettings)),
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      console.log("Opslaan akkoordteksten mislukt:", data);
      alert(data?.error || data?.message || "Opslaan akkoordteksten mislukt.");
      return;
    }

    setApprovalTextSettings(approvalReferenceTemplates({
      ...emptyApprovalTextSettings,
      ...(data || {}),
    }));

    setApprovalTextFlash("Akkoordteksten opgeslagen ✅");
    setTimeout(() => setApprovalTextFlash(""), 1800);
  } catch (err) {
    console.log("Fout bij opslaan akkoordteksten:", err);
    alert("Opslaan akkoordteksten mislukt.");
  }
}

async function loadGeneralSettings() {
    try {
const r = await fetch(`${API_BASE}/api/general-settings`, {
  headers: authHeaders(),
});
      const data = await r.json().catch(() => ({}));

      setGeneralSettings({
        use_organisations: data?.use_organisations !== false,
        use_particulieren: data?.use_particulieren === true,
        staffiq_profile: String(data?.staffiq_profile || "ALL").toUpperCase(),
        offer_prices_include_vat: data?.offer_prices_include_vat === true,
      });
    } catch (err) {
      console.log("Fout bij laden algemene instellingen:", err);
      setGeneralSettings({
        use_organisations: true,
        use_particulieren: false,
        staffiq_profile: "ALL",
        offer_prices_include_vat: false,
      });
    }
  }

async function saveGeneralSettings() {
    if (!isAdmin) {
      alert("Alleen de administrator mag instellingen wijzigen.");
      return;
    }

    if (!generalSettings.use_organisations && !generalSettings.use_particulieren) {
      alert("Kies minimaal Organisaties of Particulieren.");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/api/general-settings`, {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify(generalSettings),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        alert(data?.error || "Opslaan StaffIQ-profiel en Relatie-instellingen mislukt.");
        return;
      }

      setGeneralSettings({
        use_organisations: data?.use_organisations !== false,
        use_particulieren: data?.use_particulieren === true,
        staffiq_profile: String(data?.staffiq_profile || "ALL").toUpperCase(),
        offer_prices_include_vat: data?.offer_prices_include_vat === true,
      });

      setFlash("Algemene instellingen opgeslagen ✅");
      positionSettingsTop();
      setTimeout(() => setFlash(""), 1500);
    } catch (err) {
      console.log("Fout bij opslaan algemene instellingen:", err);
      alert("Opslaan algemene instellingen mislukt.");
    }
  }

async function loadGeneralSettings() {
    try {
const r = await fetch(`${API_BASE}/api/general-settings`, {
  headers: authHeaders(),
});
      const data = await r.json().catch(() => ({}));

      setGeneralSettings({
        use_organisations: data?.use_organisations !== false,
        use_particulieren: data?.use_particulieren === true,
        staffiq_profile: String(data?.staffiq_profile || "ALL").toUpperCase(),
        offer_prices_include_vat: data?.offer_prices_include_vat === true,
      });
    } catch (err) {
      console.log("Fout bij laden algemene instellingen:", err);
      setGeneralSettings({
        use_organisations: true,
        use_particulieren: false,
        staffiq_profile: "ALL",
        offer_prices_include_vat: false,
      });
    }
  }

async function saveGeneralSettings() {
    if (!isAdmin) {
      alert("Alleen de administrator mag instellingen wijzigen.");
      return;
    }

    if (!generalSettings.use_organisations && !generalSettings.use_particulieren) {
      alert("Kies minimaal Organisaties of Particulieren.");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/api/general-settings`, {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify(generalSettings),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        alert(data?.error || "Opslaan algemene instellingen mislukt.");
        return;
      }

      setGeneralSettings({
        use_organisations: data?.use_organisations !== false,
        use_particulieren: data?.use_particulieren === true,
        staffiq_profile: String(data?.staffiq_profile || "ALL").toUpperCase(),
        offer_prices_include_vat: data?.offer_prices_include_vat === true,
      });

      setFlash("Algemene instellingen opgeslagen ✅");
      positionSettingsTop();
      setTimeout(() => setFlash(""), 1500);
    } catch (err) {
      console.log("Fout bij opslaan algemene instellingen:", err);
      alert("Opslaan algemene instellingen mislukt.");
    }
  }


async function loadOrderSettings() {
  try {
    const r = await fetch(`${API_BASE}/api/order-settings`, {
      headers: authHeaders(),
    });

    const data = await r.json().catch(() => ({}));

    if (!r.ok) {
      console.log("Fout bij laden opdrachtinstellingen:", data);
      loadedWorkOrdersRef.current = null;
      setOrderSettings({ use_work_orders: false });
      return;
    }

    loadedWorkOrdersRef.current = data?.use_work_orders === true;
    setOrderSettings({
      use_work_orders: data?.use_work_orders === true,
    });
  } catch (err) {
    console.log("Fout bij laden opdrachtinstellingen:", err);
    loadedWorkOrdersRef.current = null;
    setOrderSettings({ use_work_orders: false });
  }
}




async function loadRelationChoices() {
  try {
    const res = await fetch(`${API_BASE}/api/relation-choice-options`, {
      headers: authHeaders(),
    });

    const data = await res.json().catch(() => []);

    if (!res.ok) {
      console.log("Fout bij laden relatiekeuzelijsten:", data);
      setRelationChoices([]);
      return;
    }

    const list = Array.isArray(data)
      ? data.slice().sort((a, b) =>
          String(a.value || "").localeCompare(String(b.value || ""), "nl")
        )
      : [];

    setRelationChoices(list);

    setSelectedRelationChoice((prev) => {
      if (
        prev?.id &&
        list.some((x) => String(x.id) === String(prev.id))
      ) {
        return prev;
      }

      return {
        ...emptyRelationChoice,
        list_key: selectedRelationChoiceCategory,
      };
    });
  } catch (err) {
    console.log("Fout bij laden relatiekeuzelijsten:", err);
    setRelationChoices([]);
  }
}

function relationChoiceCategoryLabel(key) {
  return (
    RELATION_CHOICE_CATEGORIES.find((x) => x.key === key)?.label ||
    key
  );
}

function visibleRelationChoices() {
  return (relationChoices || [])
    .filter((row) => row.list_key === selectedRelationChoiceCategory)
    .slice()
    .sort((a, b) =>
      String(a.value || "").localeCompare(String(b.value || ""), "nl")
    );
}

function selectRelationChoiceCategory(listKey) {
  setSelectedRelationChoiceCategory(listKey);
  setSelectedRelationChoice({
    ...emptyRelationChoice,
    list_key: listKey,
  });
  setRelationChoiceFlash("");
  scrollToDetailMobile();
}

function newRelationChoice() {
  setSelectedRelationChoice({
    ...emptyRelationChoice,
    list_key: selectedRelationChoiceCategory,
  });
  setRelationChoiceFlash("");
}

async function saveRelationChoice() {
  if (!isAdmin) {
    alert("Alleen de administrator mag keuzelijsten wijzigen.");
    return;
  }

  const value = String(selectedRelationChoice?.value || "").trim();
  if (!value) {
    alert("Vul eerst een waarde in.");
    return;
  }

  const isUpdate = !!selectedRelationChoice?.id;

  try {
    const res = await fetch(
      isUpdate
        ? `${API_BASE}/api/relation-choice-options/${selectedRelationChoice.id}`
        : `${API_BASE}/api/relation-choice-options`,
      {
        method: isUpdate ? "PUT" : "POST",
        headers: authHeaders(),
        body: JSON.stringify({
          ...selectedRelationChoice,
          list_key: selectedRelationChoiceCategory,
          value,
        }),
      }
    );

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      alert(data?.error || data?.message || "Opslaan van keuzelijstwaarde mislukt.");
      return;
    }

    await loadRelationChoices();

    setSelectedRelationChoice({
      ...emptyRelationChoice,
      list_key: selectedRelationChoiceCategory,
    });

    setRelationChoiceFlash("Keuzelijstwaarde opgeslagen ✅");
    positionSettingsTop();
    setTimeout(() => setRelationChoiceFlash(""), 1600);
  } catch (err) {
    console.log("Fout bij opslaan relatiekeuzelijst:", err);
    alert("Opslaan van keuzelijstwaarde mislukt.");
  }
}

async function deleteRelationChoice() {
  if (!isAdmin || !selectedRelationChoice?.id) return;

  const value = selectedRelationChoice.value || "deze waarde";
  if (!window.confirm(`Waarde '${value}' verwijderen?`)) return;

  try {
    const res = await fetch(
      `${API_BASE}/api/relation-choice-options/${selectedRelationChoice.id}`,
      {
        method: "DELETE",
        headers: authOnlyHeaders(),
      }
    );

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      alert(data?.error || data?.message || "Verwijderen van keuzelijstwaarde mislukt.");
      return;
    }

    await loadRelationChoices();

    setSelectedRelationChoice({
      ...emptyRelationChoice,
      list_key: selectedRelationChoiceCategory,
    });

    setRelationChoiceFlash("Keuzelijstwaarde verwijderd ✅");
    setTimeout(() => setRelationChoiceFlash(""), 1600);
  } catch (err) {
    console.log("Fout bij verwijderen relatiekeuzelijst:", err);
    alert("Verwijderen van keuzelijstwaarde mislukt.");
  }
}

async function loadCompanyCodes() {
  try {
    const res = await fetch(`${API_BASE}/api/company-codes/admin`, {
      headers: authHeaders(),
    });

    const data = await res.json().catch(() => []);

    if (!res.ok) {
      console.log("Fout bij laden bedrijfscodes:", data);
      setCompanyCodes([]);
      return;
    }

    const list = Array.isArray(data) ? data : [];
    setCompanyCodes(list);

    setSelectedCompanyCode((prev) => {
      if (prev?.id && list.some((x) => String(x.id) === String(prev.id))) return prev;
      return list[0] || { id: null, code: "", name: "", active: true };
    });
  } catch (err) {
    console.log("Fout bij laden bedrijfscodes:", err);
    setCompanyCodes([]);
  }
}

function newCompanyCode() {
  setView("companycodes");
  setSelectedCompanyCode({
    id: null,
    code: "",
    name: "",
    active: true,
  });
  setCompanyCodeFlash("");
  scrollToDetailMobile();
}

async function saveCompanyCode() {
  if (!isAdmin) {
    alert("Alleen de administrator mag bedrijfscodes wijzigen.");
    return;
  }

  const isNew = !selectedCompanyCode.id;

  const res = await fetch(
    isNew
      ? `${API_BASE}/api/company-codes`
      : `${API_BASE}/api/company-codes/${selectedCompanyCode.id}`,
    {
      method: isNew ? "POST" : "PUT",
      headers: authHeaders(),
      body: JSON.stringify(selectedCompanyCode),
    }
  );

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    alert(data?.error || "Opslaan bedrijfscode mislukt.");
    return;
  }

  setSelectedCompanyCode(data || selectedCompanyCode);
  await loadCompanyCodes();

  setCompanyCodeFlash("Bedrijfscode opgeslagen ✅");
  positionSettingsTop();
  setTimeout(() => setCompanyCodeFlash(""), 1600);
}


async function deleteCompanyCode() {
  if (!isAdmin || !selectedCompanyCode?.id) return;

  const naam = selectedCompanyCode?.name || selectedCompanyCode?.code || "deze bedrijfscode";

  if (!window.confirm(`Bedrijfscode '${naam}' verwijderen?\n\nDit kan alleen als de bedrijfscode nog niet wordt gebruikt.`)) {
    return;
  }

  try {
    const res = await fetch(`${API_BASE}/api/company-codes/${selectedCompanyCode.id}`, {
      method: "DELETE",
      headers: authOnlyHeaders(),
    });

    const rawText = await res.text();
    let data = {};

    try {
      data = rawText ? JSON.parse(rawText) : {};
    } catch {
      data = { error: rawText || "" };
    }

    if (!res.ok) {
      const message =
        data?.error ||
        data?.message ||
        rawText ||
        `Verwijderen bedrijfscode mislukt (${res.status}).`;

      alert(message);
      return;
    }

    await loadCompanyCodes();
    setSelectedCompanyCode({ id: null, code: "", name: "", active: true });
    setCompanyCodeFlash("Bedrijfscode verwijderd ✅");
    setTimeout(() => setCompanyCodeFlash(""), 1600);
  } catch (err) {
    console.log("Fout bij verwijderen bedrijfscode:", err);
    alert(`Verwijderen bedrijfscode mislukt.\n\n${err?.message || err}`);
  }
}

async function loadUserCompanyCodes(userId) {
  if (!userId) {
    setUserCompanyCodes([]);
    return;
  }

  try {
    const res = await fetch(`${API_BASE}/api/users/${userId}/company-codes`, {
      headers: authHeaders(),
    });

    const data = await res.json().catch(() => []);

    if (!res.ok) {
      console.log("Fout bij laden bedrijfscode-rechten:", data);
      setUserCompanyCodes([]);
      return;
    }

    setUserCompanyCodes(Array.isArray(data) ? data : []);
  } catch (err) {
    console.log("Fout bij laden bedrijfscode-rechten:", err);
    setUserCompanyCodes([]);
  }
}

function updateUserCompanyCodeRow(companyCodeId, patch) {
  setUserCompanyCodes((prev) =>
    (prev || []).map((row) =>
      String(row.id) === String(companyCodeId)
        ? { ...row, ...patch }
        : row
    )
  );
}

async function saveUserCompanyCodes() {
  if (!isAdmin || !selected?.id) return;

  try {
    const res = await fetch(`${API_BASE}/api/users/${selected.id}/company-codes`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify({
        company_codes: userCompanyCodes.map((row) => ({
          company_code_id: row.id,
          allowed: row.allowed === true,
          role: row.role || "user",
        })),
      }),
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      alert(data?.error || "Opslaan bedrijfscode-rechten mislukt.");
      return;
    }

    setUserCompanyCodesFlash("Bedrijfscode-rechten opgeslagen ✅");
    positionSettingsTop();
    setTimeout(() => setUserCompanyCodesFlash(""), 1600);
    await loadUserCompanyCodes(selected.id);
  } catch (err) {
    console.log("Fout bij opslaan bedrijfscode-rechten:", err);
    alert("Opslaan bedrijfscode-rechten mislukt.");
  }
}

  function newUser() {
    setView("user");
    setSelected({
      id: null,
      display_name: "",
      email: "",
      password: "",
      is_active: true,
      role_id: roles[0]?.id || "",
      role: "",
    });
    setShowPassword(false);
    setUserCompanyCodes([]);
  }

  async function saveUser() {
    const isNew = !selected.id;

const saveRes = await fetch(
  isNew
    ? `${API_BASE}/api/users`
    : `${API_BASE}/api/users/${selected.id}`,
  {
    method: isNew ? "POST" : "PUT",
    headers: authHeaders(),
    body: JSON.stringify(selected),
  }
);

const saveData = await saveRes.json().catch(() => ({}));

if (!saveRes.ok) {
  alert(saveData?.error || "Opslaan gebruiker mislukt");
  return;
}

    setFlash("Opgeslagen ✅");
    positionSettingsTop();
    setTimeout(() => setFlash(""), 1200);

const res = await fetch(`${API_BASE}/api/users`, {
  headers: authHeaders(),
});
const data = await res.json().catch(() => []);

    if (Array.isArray(data)) {
      setUsers(data);

      const updated = data.find((u) => String(u.id) === String(selected.id));
      if (updated) {
        setSelected({ ...updated, password: "" });
      } else if (isNew) {
        const byEmail = data.find(
          (u) =>
            String(u.email || "").toLowerCase() ===
            String(selected.email || "").toLowerCase()
        );
        if (byEmail) {
          setSelected({ ...byEmail, password: "" });
          loadUserCompanyCodes(byEmail.id);
        }
      }

      if (updated) {
        loadUserCompanyCodes(updated.id);
      }
    } else {
      console.log("API /api/users gaf na opslaan geen array terug:", data);
      setUsers([]);
      alert("Users opnieuw laden ging niet goed.");
    }
  }

function legacyInvoiceSettingsAsMkbDefaults() {
  return {
    ...emptyMkbInvoiceSettings,
    document_title: invoiceSettings.invoice_title || "Factuur",
    contact_person: invoiceSettings.invoice_contact_person || "",
    company_name: invoiceSettings.company_name || "",
    company_address_1: invoiceSettings.company_address_1 || "",
    company_address_2: invoiceSettings.company_address_2 || "",
    company_postcode: invoiceSettings.company_postcode || "",
    company_city: invoiceSettings.company_city || "",
    company_country: invoiceSettings.company_country || "",
    company_email: invoiceSettings.company_email || "",
    company_website: invoiceSettings.company_website || "",
    company_phone: invoiceSettings.company_phone || "",
    company_kvk: invoiceSettings.company_kvk || "",
    company_vat: invoiceSettings.company_vat || "",
    company_iban: invoiceSettings.company_iban || "",
    logo_url: invoiceSettings.logo_url || "",
    payment_text: invoiceSettings.payment_text || emptyMkbInvoiceSettings.payment_text,
    footer_text: invoiceSettings.footer_text || "",
  };
}

async function loadMkbLetterheadSettings(companyCodeId = "") {
  try {
    setMkbLetterheadSettingsLoading(true);
    const qs = companyCodeId
      ? `?company_code_id=${encodeURIComponent(companyCodeId)}`
      : "";

    const res = await fetch(`${API_BASE}/api/company-section-settings/mkb_letterhead${qs}`, {
      headers: authHeaders(),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || "Briefpapierinstellingen konden niet worden geladen.");

    setMkbLetterheadSettings({
      ...emptyMkbLetterheadSettings,
      ...(data?.settings || {}),
      use_own_letterhead: data?.settings?.use_own_letterhead === true,
    });
  } catch (err) {
    console.log("Fout bij laden MKB-briefpapier:", err);
    setMkbLetterheadSettings(emptyMkbLetterheadSettings);
  } finally {
    setMkbLetterheadSettingsLoading(false);
  }
}

async function saveMkbLetterheadSettings(sectionKey) {
  if (!isAdmin) return null;

  const companyCodeId = selectedSettingsCompanyCodeId(sectionKey);

  const res = await fetch(`${API_BASE}/api/company-section-settings/mkb_letterhead`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify({
      company_code_id: companyCodeId ? Number(companyCodeId) : null,
      settings: {
        ...mkbLetterheadSettings,
        use_own_letterhead: mkbLetterheadSettings.use_own_letterhead === true,
      },
    }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || "Briefpapierinstellingen opslaan mislukt.");
  }

  return data;
}

function handleMkbLetterheadUpload(e) {
  const file = e.target.files?.[0];
  if (!file) return;

  const allowedMimeTypes = [
    "image/png",
  ];

  if (!allowedMimeTypes.includes(file.type)) {
    alert("Kies een PNG-bestand voor het briefpapier.");
    e.target.value = "";
    return;
  }

  if (file.size > 8 * 1024 * 1024) {
    alert("Het briefpapierbestand is te groot. Kies een bestand van maximaal 8 MB.");
    e.target.value = "";
    return;
  }

  const reader = new FileReader();
  reader.onload = () => {
    setMkbLetterheadSettings((prev) => ({
      ...prev,
      letterhead_file_name: file.name || "",
      letterhead_mime_type: file.type || "",
      letterhead_data_url: String(reader.result || ""),
    }));
  };
  reader.onerror = () => alert("Briefpapier kon niet worden gelezen.");
  reader.readAsDataURL(file);
}

function renderMkbLetterheadSettings(sectionKey) {
  return (
    <div
      data-settings-section={sectionKey}
      style={{
        maxWidth: 900,
        margin: "0 0 18px 0",
        padding: 14,
        border: "1px solid #cfdbe6",
        borderRadius: 8,
        background: "#fafcff",
        boxSizing: "border-box",
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 10 }}>Briefpapier</div>

      {mkbLetterheadSettingsLoading ? (
        <div style={{ marginBottom: 10, fontSize: 13 }}>Briefpapier laden...</div>
      ) : null}

      <label style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <input
          type="checkbox"
          checked={mkbLetterheadSettings.use_own_letterhead === true}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbLetterheadSettings((prev) => ({
              ...prev,
              use_own_letterhead: e.target.checked,
            }))
          }
        />
        <span>Eigen briefpapier gebruiken</span>
      </label>

      {(["mkb_offers", "mkb_orders"].includes(sectionKey)) && (
        <div style={{ marginBottom: 14, padding: "10px 12px", background: "#fff", border: "1px solid #e4e9ef", borderRadius: 6 }}>
          <div style={{ fontWeight: 700, marginBottom: 8, fontSize: 13 }}>Klantgegevens op offerte / opdracht</div>
          <label style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, fontSize: 13 }}>
            <input
              type="checkbox"
              checked={mkbLetterheadSettings.show_recipient_phone === true}
              disabled={!isAdmin}
              onChange={(e) => setMkbLetterheadSettings((prev) => ({ ...prev, show_recipient_phone: e.target.checked }))}
            />
            Mobiel nummer (anders telefoon) onder het adres tonen
          </label>
          <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13 }}>
            <input
              type="checkbox"
              checked={mkbLetterheadSettings.show_recipient_email === true}
              disabled={!isAdmin}
              onChange={(e) => setMkbLetterheadSettings((prev) => ({ ...prev, show_recipient_email: e.target.checked }))}
            />
            E-mailadres onder het adres tonen
          </label>
          <div style={{ fontSize: 12, color: "#5d6b78", marginTop: 8 }}>
            Geldt voor offertes én opdrachten binnen de gekozen bedrijfscode; standaard staan beide uit.
          </div>
        </div>
      )}

      <label style={{ marginRight: 12 }}>Briefpapier upload</label>
      <input
        type="file"
        accept=".png,image/png"
        disabled={!isAdmin}
        onChange={handleMkbLetterheadUpload}
      />

      <div style={{ marginTop: 6, fontSize: 12, color: "#5d6b78", lineHeight: 1.5 }}>
        Het briefpapier moet als PNG-bestand in A4-verhouding worden aangeleverd.
        Bij eigen briefpapier worden logo en voorgedrukte bedrijfsgegevens niet dubbel op het document afgedrukt.
      </div>

      {mkbLetterheadSettings.letterhead_file_name ? (
        <div style={{ marginTop: 10, display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
          <span style={{ fontSize: 13 }}>
            Bestand: <b>{mkbLetterheadSettings.letterhead_file_name}</b>
          </span>
          <button
            type="button"
            disabled={!isAdmin}
            onClick={() =>
              setMkbLetterheadSettings((prev) => ({
                ...prev,
                letterhead_file_name: "",
                letterhead_mime_type: "",
                letterhead_data_url: "",
                use_own_letterhead: false,
              }))
            }
            style={{
              padding: "7px 10px",
              background: "#b02a37",
              color: "white",
              border: "none",
              borderRadius: 6,
              cursor: isAdmin ? "pointer" : "not-allowed",
              opacity: isAdmin ? 1 : 0.5,
            }}
          >
            Briefpapier verwijderen
          </button>
        </div>
      ) : (
        <div style={{ marginTop: 8, fontSize: 12, opacity: 0.7 }}>
          Nog geen briefpapier gekozen.
        </div>
      )}

      {mkbLetterheadSettings.use_own_letterhead === true ? (
        <div style={{ marginTop: 10, fontSize: 12, color: "#5d6b78", lineHeight: 1.5 }}>
          De bedrijfsgegevens en het logo in de rubrieken hieronder hoeven voor de afdruk niet te worden gebruikt.
          We laten bestaande waarden bewust staan, zodat niets verloren gaat als eigen briefpapier later weer wordt uitgezet.
        </div>
      ) : null}
    </div>
  );
}


async function loadMkbInvoiceSettings(companyCodeId = selectedSettingsCompanyCodeId("mkb_invoices")) {
  try {
    setMkbInvoiceSettingsLoading(true);
    const qs = companyCodeId
      ? `?company_code_id=${encodeURIComponent(companyCodeId)}`
      : "";

    const res = await fetch(`${API_BASE}/api/company-section-settings/mkb_invoices${qs}`, {
      headers: authHeaders(),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || "Factuurdocument-instellingen konden niet worden geladen.");

    setMkbInvoiceSettings({
      ...legacyInvoiceSettingsAsMkbDefaults(),
      ...(data?.settings || {}),
    });
  } catch (err) {
    console.log("Fout bij laden MKB-factuurinstellingen:", err);
    setMkbInvoiceSettings(legacyInvoiceSettingsAsMkbDefaults());
  } finally {
    setMkbInvoiceSettingsLoading(false);
  }
}

async function saveMkbInvoiceSettings() {
  if (!isAdmin) return;

  try {
    await saveMkbLetterheadSettings("mkb_invoices");
    const companyCodeId = selectedSettingsCompanyCodeId("mkb_invoices");
    const res = await fetch(`${API_BASE}/api/company-section-settings/mkb_invoices`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify({
        company_code_id: companyCodeId ? Number(companyCodeId) : null,
        settings: mkbInvoiceSettings,
      }),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || "Factuurdocument-instellingen opslaan mislukt.");

    positionSettingsTop();
    setInvoiceFlash(
      companyCodeId
        ? "✅ Factuurinstellingen voor bedrijfscode opgeslagen"
        : `✅ Standaard opgeslagen en ingevuld bij ${data?.copied_to_company_codes || 0} bedrijfscode(s)`
    );
    setTimeout(() => setInvoiceFlash(""), 2200);
  } catch (err) {
    alert(err?.message || "Factuurdocument-instellingen opslaan mislukt.");
  }
}

function handleMkbInvoiceLogoUpload(e) {
  const file = e.target.files?.[0];
  if (!file) return;
  if (!file.type?.startsWith("image/")) {
    alert("Kies een afbeeldingsbestand.");
    return;
  }

  const reader = new FileReader();
  reader.onload = () => setMkbInvoiceSettings((prev) => ({
    ...prev,
    logo_url: String(reader.result || ""),
  }));
  reader.onerror = () => alert("Logo kon niet worden gelezen.");
  reader.readAsDataURL(file);
}

function handleLogoUpload(e) {
  const file = e.target.files?.[0];
  if (!file) return;

  const isImage = file.type && file.type.startsWith("image/");
  if (!isImage) {
    alert("Kies een afbeeldingsbestand, bijvoorbeeld png, jpg of svg.");
    return;
  }

  const reader = new FileReader();

  reader.onload = () => {
    const result = String(reader.result || "");
    setInvoiceSettings((prev) => ({
      ...prev,
      logo_url: result,
    }));
  };

  reader.onerror = () => {
    alert("Logo kon niet worden gelezen.");
  };

  reader.readAsDataURL(file);
}

async function saveDocumentSettings() {
    if (!isAdmin) {
      alert("Alleen de administrator mag documentinstellingen wijzigen.");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/api/document-settings`, {
        method: "PUT",
headers: authHeaders(),
        body: JSON.stringify({
          document_base_path: documentLocation,
        }),
      });

      const data = await res.json();

      setDocumentLocation(String(data?.document_base_path || documentLocation));
      setFlash("Documentlocatie opgeslagen ✅");
      positionSettingsTop();
      setTimeout(() => setFlash(""), 1500);
    } catch (err) {
      console.log("Fout bij opslaan documentlocatie:", err);
      alert("Opslaan van documentlocatie is mislukt.");
    }
  }


async function loadDocumentTypes() {
  try {
    const res = await fetch(`${API_BASE}/api/document-types`, {
      headers: authHeaders(),
    });

    const data = await res.json().catch(() => []);
    if (!res.ok) throw new Error(data?.error || "Documentsoorten laden mislukt.");

    const list = Array.isArray(data) ? data : [];
    setDocumentTypes(list);

    setSelectedDocumentType((prev) => {
      if (prev?.id) {
        const found = list.find((x) => String(x.id) === String(prev.id));
        if (found) return { ...emptyDocumentType, ...found };
      }
      return { ...emptyDocumentType };
    });
  } catch (err) {
    console.log("Fout bij laden documentsoorten:", err);
    setDocumentTypes([]);
  }
}

function newDocumentType() {
  setSelectedDocumentType({ ...emptyDocumentType });
  setDocumentTypeFlash("");
}

async function saveDocumentType() {
  if (!isAdmin) return;

  const name = String(selectedDocumentType?.name || "").trim();
  if (!name) {
    alert("Vul eerst een naam voor de documentsoort in.");
    return;
  }

  try {
    const isUpdate = !!selectedDocumentType?.id;
    const res = await fetch(
      isUpdate
        ? `${API_BASE}/api/document-types/${selectedDocumentType.id}`
        : `${API_BASE}/api/document-types`,
      {
        method: isUpdate ? "PUT" : "POST",
        headers: authHeaders(),
        body: JSON.stringify({
          ...selectedDocumentType,
          name,
          default_validity_months:
            selectedDocumentType.default_validity_months === ""
              ? null
              : Number(selectedDocumentType.default_validity_months),
        }),
      }
    );

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || "Documentsoort opslaan mislukt.");

    await loadDocumentTypes();

    // Na opslaan altijd terug naar een leeg invoerscherm.
    setSelectedDocumentType({ ...emptyDocumentType });

    setDocumentTypeFlash("Opgeslagen ✅");
    setTimeout(() => setDocumentTypeFlash(""), 1200);
  } catch (err) {
    alert(err?.message || "Documentsoort opslaan mislukt.");
  }
}

async function deleteDocumentType() {
  if (!isAdmin || !selectedDocumentType?.id) return;

  if (
    !window.confirm(
      `Documentsoort '${selectedDocumentType.name || ""}' verwijderen?`
    )
  ) {
    return;
  }

  try {
    const res = await fetch(
      `${API_BASE}/api/document-types/${selectedDocumentType.id}`,
      {
        method: "DELETE",
        headers: authOnlyHeaders(),
      }
    );

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || "Documentsoort verwijderen mislukt.");

    setSelectedDocumentType({ ...emptyDocumentType });
    await loadDocumentTypes();
    await loadDocumentSets();
    setDocumentTypeFlash("Verwijderd ✅");
    setTimeout(() => setDocumentTypeFlash(""), 1200);
  } catch (err) {
    alert(err?.message || "Documentsoort verwijderen mislukt.");
  }
}

async function loadDocumentSets() {
  try {
    const res = await fetch(`${API_BASE}/api/document-sets`, {
      headers: authHeaders(),
    });

    const data = await res.json().catch(() => []);
    if (!res.ok) throw new Error(data?.error || "Documentsets laden mislukt.");

    const list = Array.isArray(data) ? data : [];
    setDocumentSets(list);

    setSelectedDocumentSet((prev) => {
      if (prev?.id) {
        const found = list.find((x) => String(x.id) === String(prev.id));
        if (found) return { ...emptyDocumentSet, ...found, items: found.items || [] };
      }
      return { ...emptyDocumentSet };
    });
  } catch (err) {
    console.log("Fout bij laden documentsets:", err);
    setDocumentSets([]);
  }
}

function newDocumentSet() {
  setSelectedDocumentSet({ ...emptyDocumentSet });
  setDocumentSetFlash("");

  // Nieuwe documentset: cursor direct op Naam set.
  setTimeout(() => {
    try {
      document.getElementById("staffiq-document-set-name")?.focus?.();
    } catch {}
  }, 80);
}

function addDocumentSetItem() {
  setSelectedDocumentSet((prev) => ({
    ...prev,
    items: [
      ...(prev.items || []),
      {
        id: null,
        document_type_id: "",
        title: "",
        description: "",
        required: false,
        document_required: false,
        signature_required: false,
        lookup_scope: "",
        sort_order: (prev.items || []).length + 1,
      },
    ],
  }));

  // Na toevoegen direct naar het nieuwe onderdeel springen.
  setTimeout(() => {
    try {
      const items = document.querySelectorAll('[data-document-set-item="true"]');
      const lastItem = items[items.length - 1];
      lastItem?.scrollIntoView?.({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    } catch {}
  }, 80);
}

function updateDocumentSetItem(index, patch) {
  setSelectedDocumentSet((prev) => ({
    ...prev,
    items: (prev.items || []).map((item, i) =>
      i === index ? { ...item, ...patch } : item
    ),
  }));
}

function removeDocumentSetItem(index) {
  setSelectedDocumentSet((prev) => ({
    ...prev,
    items: (prev.items || [])
      .filter((_, i) => i !== index)
      .map((item, i) => ({ ...item, sort_order: i + 1 })),
  }));
}

async function saveDocumentSet() {
  if (!isAdmin) return;

  const name = String(selectedDocumentSet?.name || "").trim();
  if (!name) {
    alert("Vul eerst een naam voor de documentset in.");
    return;
  }

  const items = (selectedDocumentSet.items || []).filter(
    (item) => Number(item.document_type_id) > 0
  );

  if (!items.length) {
    alert("Voeg minimaal één documentsoort aan de set toe.");
    return;
  }

  try {
    const isUpdate = !!selectedDocumentSet?.id;
    const res = await fetch(
      isUpdate
        ? `${API_BASE}/api/document-sets/${selectedDocumentSet.id}`
        : `${API_BASE}/api/document-sets`,
      {
        method: isUpdate ? "PUT" : "POST",
        headers: authHeaders(),
        body: JSON.stringify({
          ...selectedDocumentSet,
          name,
          items,
        }),
      }
    );

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || "Documentset opslaan mislukt.");

    setSelectedDocumentSet({
      ...emptyDocumentSet,
      ...(data || {}),
      items: data?.items || [],
    });

    await loadDocumentSets();
    setDocumentSetFlash("Opgeslagen ✅");
    setTimeout(() => setDocumentSetFlash(""), 1200);
  } catch (err) {
    alert(err?.message || "Documentset opslaan mislukt.");
  }
}

async function deleteDocumentSet() {
  if (!isAdmin || !selectedDocumentSet?.id) return;

  if (
    !window.confirm(
      `Documentset '${selectedDocumentSet.name || ""}' verwijderen?`
    )
  ) {
    return;
  }

  try {
    const res = await fetch(
      `${API_BASE}/api/document-sets/${selectedDocumentSet.id}`,
      {
        method: "DELETE",
        headers: authOnlyHeaders(),
      }
    );

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || "Documentset verwijderen mislukt.");

    setSelectedDocumentSet({ ...emptyDocumentSet });
    await loadDocumentSets();
    setDocumentSetFlash("Verwijderd ✅");
    setTimeout(() => setDocumentSetFlash(""), 1200);
  } catch (err) {
    alert(err?.message || "Documentset verwijderen mislukt.");
  }
}


function legacyOfferSettingsAsMkbDefaults() {
  return {
    ...emptyMkbOfferSettings,
    offer_title: invoiceSettings.offer_title || "Offerte",
    offer_contact_person: invoiceSettings.offer_contact_person || "",
    offer_company_name: invoiceSettings.offer_company_name || "",
    offer_company_address_1: invoiceSettings.offer_company_address_1 || "",
    offer_company_address_2: invoiceSettings.offer_company_address_2 || "",
    offer_company_postcode: invoiceSettings.offer_company_postcode || "",
    offer_company_city: invoiceSettings.offer_company_city || "",
    offer_company_country: invoiceSettings.offer_company_country || "",
    offer_company_email: invoiceSettings.offer_company_email || "",
    offer_company_website: invoiceSettings.offer_company_website || "",
    offer_company_phone: invoiceSettings.offer_company_phone || "",
    offer_company_kvk: invoiceSettings.offer_company_kvk || "",
    offer_company_vat: invoiceSettings.offer_company_vat || "",
    offer_company_iban: invoiceSettings.offer_company_iban || "",
    logo_url: invoiceSettings.logo_url || "",
    offer_text: invoiceSettings.offer_text || "",
    offer_footer_text: invoiceSettings.offer_footer_text || "",
    email_subject: approvalTextSettings.approval_email_offer_subject || emptyMkbOfferSettings.email_subject,
    email_text: approvalTextSettings.approval_email_offer_text || emptyMkbOfferSettings.email_text,
    whatsapp_text: approvalTextSettings.approval_whatsapp_offer_text || emptyMkbOfferSettings.whatsapp_text,
  };
}

async function loadMkbOfferSettings(companyCodeId = selectedSettingsCompanyCodeId("mkb_offers")) {
  try {
    setMkbOfferSettingsLoading(true);
    const qs = companyCodeId
      ? `?company_code_id=${encodeURIComponent(companyCodeId)}`
      : "";

    const res = await fetch(`${API_BASE}/api/company-section-settings/mkb_offers${qs}`, {
      headers: authHeaders(),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || "Offerte-instellingen konden niet worden geladen.");

    setMkbOfferSettings(mkbReferenceTemplates({
      ...legacyOfferSettingsAsMkbDefaults(),
      ...(data?.settings || {}),
    }));
  } catch (err) {
    console.log("Fout bij laden MKB-offerte-instellingen:", err);
    setMkbOfferSettings(mkbReferenceTemplates(legacyOfferSettingsAsMkbDefaults()));
  } finally {
    setMkbOfferSettingsLoading(false);
  }
}

async function saveMkbOfferSettings() {
  if (!isAdmin) return;

  try {
    await saveMkbLetterheadSettings("mkb_offers");
    const companyCodeId = selectedSettingsCompanyCodeId("mkb_offers");
    const res = await fetch(`${API_BASE}/api/company-section-settings/mkb_offers`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify({
        company_code_id: companyCodeId ? Number(companyCodeId) : null,
        settings: mkbReferenceTemplates(mkbOfferSettings),
      }),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || "Offerte-instellingen opslaan mislukt.");

    positionSettingsTop();
    setInvoiceFlash(
      companyCodeId
        ? "✅ Offerte-instellingen voor bedrijfscode opgeslagen"
        : `✅ Standaard opgeslagen en ingevuld bij ${data?.copied_to_company_codes || 0} bedrijfscode(s)`
    );
    setTimeout(() => setInvoiceFlash(""), 2200);
  } catch (err) {
    alert(err?.message || "Offerte-instellingen opslaan mislukt.");
  }
}

function handleMkbOfferLogoUpload(e) {
  const file = e.target.files?.[0];
  if (!file) return;
  if (!file.type?.startsWith("image/")) {
    alert("Kies een afbeeldingsbestand.");
    return;
  }

  const reader = new FileReader();
  reader.onload = () => setMkbOfferSettings((prev) => ({
    ...prev,
    logo_url: String(reader.result || ""),
  }));
  reader.onerror = () => alert("Logo kon niet worden gelezen.");
  reader.readAsDataURL(file);
}

function legacyOrderSettingsAsDefaults() {
  return {
    ...emptyMkbOrderSettings,
    contact_person: mkbOfferSettings.offer_contact_person || invoiceSettings.offer_contact_person || "",
    company_name: mkbOfferSettings.offer_company_name || invoiceSettings.offer_company_name || "",
    company_address_1: mkbOfferSettings.offer_company_address_1 || invoiceSettings.offer_company_address_1 || "",
    company_address_2: mkbOfferSettings.offer_company_address_2 || invoiceSettings.offer_company_address_2 || "",
    company_postcode: mkbOfferSettings.offer_company_postcode || invoiceSettings.offer_company_postcode || "",
    company_city: mkbOfferSettings.offer_company_city || invoiceSettings.offer_company_city || "",
    company_country: mkbOfferSettings.offer_company_country || invoiceSettings.offer_company_country || "",
    company_email: mkbOfferSettings.offer_company_email || invoiceSettings.offer_company_email || "",
    company_website: mkbOfferSettings.offer_company_website || invoiceSettings.offer_company_website || "",
    company_phone: mkbOfferSettings.offer_company_phone || invoiceSettings.offer_company_phone || "",
    company_kvk: mkbOfferSettings.offer_company_kvk || invoiceSettings.offer_company_kvk || "",
    company_vat: mkbOfferSettings.offer_company_vat || invoiceSettings.offer_company_vat || "",
    company_iban: mkbOfferSettings.offer_company_iban || invoiceSettings.offer_company_iban || "",
    logo_url: mkbOfferSettings.logo_url || invoiceSettings.logo_url || "",
    email_subject: approvalTextSettings.approval_email_order_subject || emptyMkbOrderSettings.email_subject,
    email_text: approvalTextSettings.approval_email_order_text || emptyMkbOrderSettings.email_text,
    whatsapp_text: approvalTextSettings.approval_whatsapp_order_text || emptyMkbOrderSettings.whatsapp_text,
  };
}

async function loadMkbOrderSettings(companyCodeId = selectedSettingsCompanyCodeId("mkb_orders")) {
  try {
    setMkbOrderSettingsLoading(true);
    const qs = companyCodeId
      ? `?company_code_id=${encodeURIComponent(companyCodeId)}`
      : "";

    const res = await fetch(`${API_BASE}/api/company-section-settings/mkb_orders${qs}`, {
      headers: authHeaders(),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || "Opdrachtinstellingen konden niet worden geladen.");

    setMkbOrderSettings(mkbReferenceTemplates({
      ...legacyOrderSettingsAsDefaults(),
      ...(data?.settings || {}),
    }));
  } catch (err) {
    console.log("Fout bij laden MKB-opdrachtinstellingen:", err);
    setMkbOrderSettings(mkbReferenceTemplates(legacyOrderSettingsAsDefaults()));
  } finally {
    setMkbOrderSettingsLoading(false);
  }
}

async function saveMkbOrderSettings() {
  if (!isAdmin) return;
  if (loadedWorkOrdersRef.current === null) {
    alert("Werkbonnen-instelling kon niet worden geladen. Vernieuw de pagina en probeer opnieuw.");
    return;
  }

  try {
    await saveMkbLetterheadSettings("mkb_orders");
    const companyCodeId = selectedSettingsCompanyCodeId("mkb_orders");
    const res = await fetch(`${API_BASE}/api/company-section-settings/mkb_orders`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify({
        company_code_id: companyCodeId ? Number(companyCodeId) : null,
        settings: mkbReferenceTemplates(mkbOrderSettings),
      }),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || "Opdrachtinstellingen opslaan mislukt.");

    // vINS-084: Werkbonnen is een tenantbrede instelling.
    // Schrijf uitsluitend een bewust gewijzigd vinkje weg, zodat Opslaan van
    // alleen opdrachtteksten een recentere Beheer-wijziging niet terugdraait.
    const desiredWorkOrders = orderSettings.use_work_orders === true;
    if (loadedWorkOrdersRef.current !== null &&
        desiredWorkOrders !== loadedWorkOrdersRef.current) {
      const workOrderRes = await fetch(`${API_BASE}/api/order-settings`, {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify({ use_work_orders: desiredWorkOrders }),
      });
      const workOrderData = await workOrderRes.json().catch(() => ({}));
      if (!workOrderRes.ok) {
        throw new Error(
          `Opdrachtgegevens opgeslagen, maar Werkbonnen-instelling niet: ${workOrderData?.error || workOrderData?.message || "Opslaan mislukt."}`
        );
      }
      loadedWorkOrdersRef.current = workOrderData?.use_work_orders === true;
      setOrderSettings({ use_work_orders: loadedWorkOrdersRef.current });
    }

    positionSettingsTop();
    setMkbOrderFlash(
      companyCodeId
        ? "✅ Opdrachtinstellingen en Werkbonnen opgeslagen"
        : `✅ Standaard opgeslagen bij ${data?.copied_to_company_codes || 0} bedrijfscode(s); Werkbonnen-instelling opgeslagen`
    );
    setTimeout(() => setMkbOrderFlash(""), 2200);
  } catch (err) {
    alert(err?.message || "Opdrachtinstellingen opslaan mislukt.");
  }
}

function handleMkbOrderLogoUpload(e) {
  const file = e.target.files?.[0];
  if (!file) return;
  if (!file.type?.startsWith("image/")) {
    alert("Kies een afbeeldingsbestand.");
    return;
  }

  const reader = new FileReader();
  reader.onload = () => setMkbOrderSettings((prev) => ({
    ...prev,
    logo_url: String(reader.result || ""),
  }));
  reader.onerror = () => alert("Logo kon niet worden gelezen.");
  reader.readAsDataURL(file);
}

async function loadMkbWorkOrderSettings(companyCodeId = selectedSettingsCompanyCodeId("mkb_work_orders")) {
  try {
    setMkbWorkOrderSettingsLoading(true);
    const qs = companyCodeId
      ? `?company_code_id=${encodeURIComponent(companyCodeId)}`
      : "";

    const res = await fetch(`${API_BASE}/api/company-section-settings/mkb_work_orders${qs}`, {
      headers: authHeaders(),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || "Werkboninstellingen konden niet worden geladen.");

    setMkbWorkOrderSettings({
      ...emptyMkbWorkOrderSettings,
      ...(data?.settings || {}),
    });
  } catch (err) {
    console.log("Fout bij laden werkboninstellingen:", err);
    setMkbWorkOrderSettings(emptyMkbWorkOrderSettings);
  } finally {
    setMkbWorkOrderSettingsLoading(false);
  }
}

async function saveMkbWorkOrderSettings() {
  if (!isAdmin) return;

  try {
    await saveMkbLetterheadSettings("mkb_work_orders");
    const companyCodeId = selectedSettingsCompanyCodeId("mkb_work_orders");
    const res = await fetch(`${API_BASE}/api/company-section-settings/mkb_work_orders`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify({
        company_code_id: companyCodeId ? Number(companyCodeId) : null,
        settings: mkbWorkOrderSettings,
      }),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || "Werkboninstellingen opslaan mislukt.");

    positionSettingsTop();
    setMkbWorkOrderFlash(
      companyCodeId
        ? "✅ Werkboninstellingen voor bedrijfscode opgeslagen"
        : `✅ Standaard opgeslagen en ingevuld bij ${data?.copied_to_company_codes || 0} bedrijfscode(s)`
    );
    setTimeout(() => setMkbWorkOrderFlash(""), 2200);
  } catch (err) {
    alert(err?.message || "Werkboninstellingen opslaan mislukt.");
  }
}

function handleMkbWorkOrderLogoUpload(e) {
  const file = e.target.files?.[0];
  if (!file) return;
  if (!file.type?.startsWith("image/")) {
    alert("Kies een afbeeldingsbestand.");
    return;
  }

  const reader = new FileReader();
  reader.onload = () => setMkbWorkOrderSettings((prev) => ({
    ...prev,
    logo_url: String(reader.result || ""),
  }));
  reader.onerror = () => alert("Logo kon niet worden gelezen.");
  reader.readAsDataURL(file);
}


async function loadHrmSectionSettings(sectionKey, companyCodeId, defaults, setLoading, setSettings) {
  try {
    setLoading(true);
    const qs = companyCodeId ? `?company_code_id=${encodeURIComponent(companyCodeId)}` : "";
    const res = await fetch(`${API_BASE}/api/company-section-settings/${sectionKey}${qs}`, {
      headers: authHeaders(),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || "HRM-instellingen konden niet worden geladen.");
    setSettings({ ...defaults, ...(data?.settings || {}) });
  } catch (err) {
    console.log(`Fout bij laden ${sectionKey}:`, err);
    setSettings(defaults);
  } finally {
    setLoading(false);
  }
}

async function saveHrmSectionSettings(sectionKey, settings, flashSetter, label) {
  if (!isAdmin) return;
  try {
    const companyCodeId = selectedSettingsCompanyCodeId(sectionKey);
    const res = await fetch(`${API_BASE}/api/company-section-settings/${sectionKey}`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify({
        company_code_id: companyCodeId ? Number(companyCodeId) : null,
        settings,
      }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || `${label} opslaan mislukt.`);
    positionSettingsTop();
    flashSetter(
      companyCodeId
        ? `✅ ${label} voor bedrijfscode opgeslagen`
        : `✅ Standaard opgeslagen en ingevuld bij ${data?.copied_to_company_codes || 0} bedrijfscode(s)`
    );
    setTimeout(() => flashSetter(""), 2200);
  } catch (err) {
    alert(err?.message || `${label} opslaan mislukt.`);
  }
}

function loadHrmVacancySettings(companyCodeId = selectedSettingsCompanyCodeId("hrm_vacancies")) {
  return loadHrmSectionSettings("hrm_vacancies", companyCodeId, emptyHrmVacancySettings, setHrmVacancySettingsLoading, setHrmVacancySettings);
}
function loadHrmPlacementCustomerSettings(companyCodeId = selectedSettingsCompanyCodeId("hrm_placement_customer")) {
  return loadHrmSectionSettings("hrm_placement_customer", companyCodeId, emptyHrmPlacementCustomerSettings, setHrmPlacementCustomerSettingsLoading, setHrmPlacementCustomerSettings);
}
function loadHrmPlacementCandidateSettings(companyCodeId = selectedSettingsCompanyCodeId("hrm_placement_candidate")) {
  return loadHrmSectionSettings("hrm_placement_candidate", companyCodeId, emptyHrmPlacementCandidateSettings, setHrmPlacementCandidateSettingsLoading, setHrmPlacementCandidateSettings);
}
function saveHrmVacancySettings() {
  return saveHrmSectionSettings("hrm_vacancies", hrmVacancySettings, setHrmVacancyFlash, "Vacature-instellingen");
}
function saveHrmPlacementCustomerSettings() {
  return saveHrmSectionSettings("hrm_placement_customer", hrmPlacementCustomerSettings, setHrmPlacementCustomerFlash, "Plaatsingsbevestiging klant");
}
function saveHrmPlacementCandidateSettings() {
  return saveHrmSectionSettings("hrm_placement_candidate", hrmPlacementCandidateSettings, setHrmPlacementCandidateFlash, "Plaatsingsbevestiging kandidaat");
}
function loadHrmMatchingPersonnelInternalSettings(companyCodeId = selectedSettingsCompanyCodeId("hrm_matching_personnel_internal")) {
  return loadHrmSectionSettings("hrm_matching_personnel_internal", companyCodeId, emptyHrmMatchingPersonnelInternalSettings, setHrmMatchingPersonnelInternalLoading, setHrmMatchingPersonnelInternalSettings);
}
function loadHrmMatchingPersonnelExternalSettings(companyCodeId = selectedSettingsCompanyCodeId("hrm_matching_personnel_external")) {
  return loadHrmSectionSettings("hrm_matching_personnel_external", companyCodeId, emptyHrmMatchingPersonnelExternalSettings, setHrmMatchingPersonnelExternalLoading, setHrmMatchingPersonnelExternalSettings);
}
function loadHrmMatchingRelationsInternalSettings(companyCodeId = selectedSettingsCompanyCodeId("hrm_matching_relations_internal")) {
  return loadHrmSectionSettings("hrm_matching_relations_internal", companyCodeId, emptyHrmMatchingRelationsInternalSettings, setHrmMatchingRelationsInternalLoading, setHrmMatchingRelationsInternalSettings);
}
function loadHrmMatchingRelationsExternalSettings(companyCodeId = selectedSettingsCompanyCodeId("hrm_matching_relations_external")) {
  return loadHrmSectionSettings("hrm_matching_relations_external", companyCodeId, emptyHrmMatchingRelationsExternalSettings, setHrmMatchingRelationsExternalLoading, setHrmMatchingRelationsExternalSettings);
}
function saveHrmMatchingPersonnelInternalSettings() {
  return saveHrmSectionSettings("hrm_matching_personnel_internal", hrmMatchingPersonnelInternalSettings, setHrmMatchingPersonnelInternalFlash, "Matching Personeel - Printen intern");
}
function saveHrmMatchingPersonnelExternalSettings() {
  return saveHrmSectionSettings("hrm_matching_personnel_external", hrmMatchingPersonnelExternalSettings, setHrmMatchingPersonnelExternalFlash, "Matching Personeel - Printen extern");
}
function saveHrmMatchingRelationsInternalSettings() {
  return saveHrmSectionSettings("hrm_matching_relations_internal", hrmMatchingRelationsInternalSettings, setHrmMatchingRelationsInternalFlash, "Matching Relaties - Printen intern");
}
function saveHrmMatchingRelationsExternalSettings() {
  return saveHrmSectionSettings("hrm_matching_relations_external", hrmMatchingRelationsExternalSettings, setHrmMatchingRelationsExternalFlash, "Matching Relaties - Printen extern");
}

function handleHrmLogoUpload(e, setter) {
  const file = e.target.files?.[0];
  if (!file) return;
  if (!file.type?.startsWith("image/")) {
    alert("Kies een afbeeldingsbestand.");
    return;
  }
  const reader = new FileReader();
  reader.onload = () => setter((prev) => ({ ...prev, logo_url: String(reader.result || "") }));
  reader.onerror = () => alert("Logo kon niet worden gelezen.");
  reader.readAsDataURL(file);
}

function renderVariableInfo(groups = []) {
  const visibleGroups = (groups || []).filter((group) => Array.isArray(group?.variables) && group.variables.length > 0);

  return (
    <div
      style={{
        marginTop: 12,
        padding: 14,
        border: "1px solid #cfdbe6",
        borderRadius: 8,
        background: "#f7fbff",
        fontSize: 12,
        lineHeight: 1.6,
        boxSizing: "border-box",
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 8 }}>Beschikbare variabelen</div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile
            ? "minmax(0, 1fr)"
            : `repeat(${Math.min(visibleGroups.length || 1, 3)}, minmax(0, 1fr))`,
          gap: 12,
          minWidth: 0,
        }}
      >
        {visibleGroups.map((group) => (
          <div key={group.title} style={{ minWidth: 0, overflowWrap: "anywhere" }}>
            <div style={{ fontWeight: 700, color: "#17384d", marginBottom: 4 }}>{group.title}</div>
            <div style={{ color: "#405466" }}>
              {group.variables.map((variable) => (
                <div key={variable}><code>{variable}</code></div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


function renderVariableDescriptions(groups = []) {
  const visibleGroups = (groups || []).filter(
    (group) => Array.isArray(group?.variables) && group.variables.length > 0
  );

  return (
    <div
      style={{
        marginTop: 16,
        padding: 14,
        border: "1px solid #cfdbe6",
        borderRadius: 8,
        background: "#f7fbff",
        fontSize: 12,
        lineHeight: 1.55,
        width: "100%",
        maxWidth: 980,
        minWidth: 0,
        boxSizing: "border-box",
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 9 }}>
        Beschikbare variabelen
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile
            ? "minmax(0, 1fr)"
            : `repeat(${Math.min(visibleGroups.length || 1, 3)}, minmax(0, 1fr))`,
          gap: 14,
          minWidth: 0,
        }}
      >
        {visibleGroups.map((group) => (
          <div
            key={group.title}
            style={{ minWidth: 0, overflowWrap: "anywhere" }}
          >
            <div
              style={{
                fontWeight: 700,
                color: "#17384d",
                marginBottom: 6,
              }}
            >
              {group.title}
            </div>

            <div style={{ display: "grid", gap: 7 }}>
              {group.variables.map((variable) => {
                const name =
                  typeof variable === "string"
                    ? variable
                    : variable?.name || "";

                const description =
                  typeof variable === "string"
                    ? ""
                    : variable?.description || "";

                return (
                  <div key={name} style={{ minWidth: 0 }}>
                    <code style={{ fontWeight: 700 }}>{name}</code>
                    {description ? (
                      <div
                        style={{
                          marginTop: 1,
                          color: "#5d6b78",
                          lineHeight: 1.45,
                        }}
                      >
                        {description}
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function renderHrmMatchingCardSettings({
  title,
  sectionKey,
  settings,
  setSettings,
  loading,
  flash,
  save,
  type,
}) {
  const update = (key, value) => setSettings((prev) => ({ ...prev, [key]: value }));
  const groups = type === "personnel"
    ? [
        {
          title: "Naam en HRM",
          fields: [
            ["show_search_name", "Zoeknaam"],
            ["show_name", "Naam"],
            ["show_status", "Status"],
            ["show_function", "Functie"],
            ["show_gender", "Geslacht"],
            ["show_birth_date", "Geboortedatum"],
            ["show_experience", "Ervaring"],
          ],
        },
        {
          title: "Contact en adres",
          fields: [
            ["show_phone", "Telefoon"],
            ["show_mobile", "Mobiel"],
            ["show_email", "E-mail"],
            ["show_website", "Website"],
            ["show_visit_address", "Bezoekadres"],
            ["show_photo", "Pasfoto"],
          ],
        },
        {
          title: "Werk en vertrouwelijk",
          fields: [
            ["show_driving_license", "Rijbewijs"],
            ["show_own_transport", "Eigen vervoer"],
            ["show_zzp", "ZZP"],
            ["show_hourly_wage", "Uurloon"],
            ["show_sales_rate", "Verkooptarief"],
            ["show_monthly_wage", "Maandloon"],
            ["show_id_document", "ID-document"],
            ["show_note", "Opmerking"],
            ["show_matching", "Matchinggegevens"],
          ],
        },
      ]
    : [
        {
          title: "Relatiegegevens",
          fields: [
            ["show_search_name", "Zoeknaam"],
            ["show_relation_form", "Relatievorm"],
            ["show_name", "Naam"],
            ["show_first_name", "Voornaam"],
            ["show_initials", "Voorletters"],
            ["show_name_prefix", "Tussenvoegsel"],
            ["show_last_name", "Achternaam"],
            ["show_gender", "Geslacht"],
            ["show_birth_date", "Geboortedatum"],
          ],
        },
        {
          title: "Administratie en contact",
          fields: [
            ["show_relation_type", "Soort relatie"],
            ["show_administration", "Administratie"],
            ["show_first_contact_date", "Datum eerste contact"],
            ["show_phone", "Telefoon"],
            ["show_mobile", "Mobiel"],
            ["show_email", "E-mail"],
            ["show_website", "Website"],
          ],
        },
        {
          title: "Adres en vertrouwelijk",
          fields: [
            ["show_visit_address", "Bezoekadres"],
            ["show_correspondence_address", "Correspondentieadres"],
            ["show_kvk", "KvK"],
            ["show_vat_number", "BTW-nummer"],
            ["show_payment_term", "Betaaltermijn"],
            ["show_payment_method", "Betaalwijze"],
            ["show_active", "Actief"],
            ["show_note", "Opmerking"],
            ["show_matching", "Matchinggegevens"],
          ],
        },
      ];

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 980,
        minWidth: 0,
        padding: 16,
        border: "1px solid #d9e2ec",
        borderRadius: 8,
        background: "#fafafa",
        boxSizing: "border-box",
      }}
    >
      <h4 style={{ margin: "0 0 6px 0" }}>{title}</h4>
      <div style={{ marginBottom: 14, fontSize: 12, color: "#5d6b78", lineHeight: 1.5 }}>
        Bepaal welke gegevens op deze kaart worden afgedrukt. De keuzes gelden per bedrijfscode.
      </div>
      {renderSettingsCompanyCodeSelector(sectionKey)}
      {loading && <div style={{ marginBottom: 12 }}>Laden...</div>}
      {flash && (
        <div style={{ marginBottom: 12, padding: "10px 12px", background: "#eaf7ea", color: "#1f6b1f", border: "1px solid #b7dfb7", borderRadius: 6 }}>
          {flash}
        </div>
      )}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "minmax(0, 1fr)" : "repeat(3, minmax(0, 1fr))",
          gap: 18,
          minWidth: 0,
        }}
      >
        {groups.map((group) => (
          <div key={group.title}>
            <div style={{ fontWeight: 700, marginBottom: 8 }}>{group.title}</div>
            <div style={{ display: "grid", gap: 7 }}>
              {group.fields.map(([key, label]) => (
                <label key={key} style={{ display: "flex", alignItems: "center", gap: 8, cursor: isAdmin ? "pointer" : "not-allowed" }}>
                  <input
                    type="checkbox"
                    checked={settings[key] !== false}
                    disabled={!isAdmin}
                    onChange={(e) => update(key, e.target.checked)}
                  />
                  <span>{label}</span>
                </label>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div style={{ marginTop: 18 }}>
        <button type="button" onClick={save} disabled={!isAdmin} style={{ padding: "10px", background: "#1f4e79", color: "white", border: "none", borderRadius: 6, cursor: isAdmin ? "pointer" : "not-allowed", opacity: isAdmin ? 1 : 0.5 }}>
          Opslaan {title.toLowerCase()}
        </button>
      </div>
    </div>
  );
}

function renderHrmMatchingSettings({ type }) {
  const personnel = type === "personnel";
  return (
    <div style={{ width: "100%", maxWidth: "100%", minWidth: 0, overflowX: "hidden", boxSizing: "border-box" }}>
      <h3>
        HRM - {personnel ? "Matching Personeel" : "Matching Relaties"}{" "}
        <span style={{ fontSize: 13, color: "#777" }}>{VERSION}</span>
      </h3>
      <div style={{ marginBottom: 16, padding: 14, border: "1px solid #d9e2ec", borderRadius: 8, background: "#f7fbff", lineHeight: 1.6, maxWidth: 980 }}>
        Stel afzonderlijk vast welke gegevens op de interne en externe kaart worden afgedrukt.
      </div>
      {personnel ? (
        <>
          {renderHrmMatchingCardSettings({
            title: "Printen intern",
            sectionKey: "hrm_matching_personnel_internal",
            settings: hrmMatchingPersonnelInternalSettings,
            setSettings: setHrmMatchingPersonnelInternalSettings,
            loading: hrmMatchingPersonnelInternalLoading,
            flash: hrmMatchingPersonnelInternalFlash,
            save: saveHrmMatchingPersonnelInternalSettings,
            type: "personnel",
          })}
          <hr style={{ margin: "24px 0 18px" }} />
          {renderHrmMatchingCardSettings({
            title: "Printen extern",
            sectionKey: "hrm_matching_personnel_external",
            settings: hrmMatchingPersonnelExternalSettings,
            setSettings: setHrmMatchingPersonnelExternalSettings,
            loading: hrmMatchingPersonnelExternalLoading,
            flash: hrmMatchingPersonnelExternalFlash,
            save: saveHrmMatchingPersonnelExternalSettings,
            type: "personnel",
          })}
        </>
      ) : (
        <>
          {renderHrmMatchingCardSettings({
            title: "Printen intern",
            sectionKey: "hrm_matching_relations_internal",
            settings: hrmMatchingRelationsInternalSettings,
            setSettings: setHrmMatchingRelationsInternalSettings,
            loading: hrmMatchingRelationsInternalLoading,
            flash: hrmMatchingRelationsInternalFlash,
            save: saveHrmMatchingRelationsInternalSettings,
            type: "relations",
          })}
          <hr style={{ margin: "24px 0 18px" }} />
          {renderHrmMatchingCardSettings({
            title: "Printen extern",
            sectionKey: "hrm_matching_relations_external",
            settings: hrmMatchingRelationsExternalSettings,
            setSettings: setHrmMatchingRelationsExternalSettings,
            loading: hrmMatchingRelationsExternalLoading,
            flash: hrmMatchingRelationsExternalFlash,
            save: saveHrmMatchingRelationsExternalSettings,
            type: "relations",
          })}
        </>
      )}
    </div>
  );
}

function renderHrmDocumentSettings({
  title,
  sectionKey,
  settings,
  setSettings,
  loading,
  flash,
  save,
  placement = false,
  candidate = false,
  vacancy = false,
}) {
  const update = (key, value) => setSettings((prev) => ({ ...prev, [key]: value }));
  return (
    <div
      className="staffiq-hrm-settings"
      style={{ width: "100%", maxWidth: "100%", minWidth: 0, overflowX: "hidden", boxSizing: "border-box" }}
    >
      <h3>{title} <span style={{ fontSize: 13, color: "#777" }}>{VERSION}</span></h3>
      <style>{`
        .staffiq-hrm-settings input:not([type="checkbox"]):not([type="file"]),
        .staffiq-hrm-settings select,
        .staffiq-hrm-settings textarea {
          width: 100%;
          max-width: 100%;
          min-width: 0;
          box-sizing: border-box;
        }
        .staffiq-hrm-settings .rich-text-toolbar {
          max-width: 100%;
        }
      `}</style>
      {renderSettingsCompanyCodeSelector(sectionKey)}
      {loading && <div style={{ marginBottom: 12 }}>Laden...</div>}
      {flash && (
        <div style={{ marginBottom: 12, padding: "10px 12px", background: "#eaf7ea", color: "#1f6b1f", border: "1px solid #b7dfb7", borderRadius: 6, maxWidth: 900 }}>
          {flash}
        </div>
      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "minmax(0, 1fr)" : "repeat(2, minmax(0, 1fr))",
          gap: 18,
          width: "100%",
          maxWidth: 980,
          minWidth: 0,
          boxSizing: "border-box",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 8, minWidth: 0 }}>
          <h4 style={{ marginBottom: 2 }}>Bedrijfs- en documentgegevens</h4>
          <label>Documenttitel</label><input value={settings.document_title || ""} disabled={!isAdmin} onChange={(e) => update("document_title", e.target.value)} />
          <label>Bedrijfsnaam</label><input value={settings.company_name || ""} disabled={!isAdmin} onChange={(e) => update("company_name", e.target.value)} />
          <label>Adresregel 1</label><input value={settings.company_address_1 || ""} disabled={!isAdmin} onChange={(e) => update("company_address_1", e.target.value)} />
          <label>Adresregel 2</label><input value={settings.company_address_2 || ""} disabled={!isAdmin} onChange={(e) => update("company_address_2", e.target.value)} />
          <label>Postcode</label><input value={settings.company_postcode || ""} disabled={!isAdmin} onChange={(e) => update("company_postcode", e.target.value)} />
          <label>Plaats</label><input value={settings.company_city || ""} disabled={!isAdmin} onChange={(e) => update("company_city", e.target.value)} />
          <label>Land</label><input value={settings.company_country || ""} disabled={!isAdmin} onChange={(e) => update("company_country", e.target.value)} />
          <label>E-mail</label><input value={settings.company_email || ""} disabled={!isAdmin} onChange={(e) => update("company_email", e.target.value)} />
          <label>Website</label><input value={settings.company_website || ""} disabled={!isAdmin} onChange={(e) => update("company_website", e.target.value)} />
          <label>Telefoon</label><input value={settings.company_phone || ""} disabled={!isAdmin} onChange={(e) => update("company_phone", e.target.value)} />
          <label>KvK</label><input value={settings.company_kvk || ""} disabled={!isAdmin} onChange={(e) => update("company_kvk", e.target.value)} />
          <label>BTW-nummer</label><input value={settings.company_vat || ""} disabled={!isAdmin} onChange={(e) => update("company_vat", e.target.value)} />
          <label>IBAN</label><input value={settings.company_iban || ""} disabled={!isAdmin} onChange={(e) => update("company_iban", e.target.value)} />
          <label>G-rekening</label><input value={settings.company_g_iban || ""} disabled={!isAdmin} onChange={(e) => update("company_g_iban", e.target.value)} />
          <label>Logo upload</label><input type="file" accept="image/*" disabled={!isAdmin} onChange={(e) => handleHrmLogoUpload(e, setSettings)} />
          {settings.logo_url ? (
            <>
              <img src={settings.logo_url} alt="HRM logo" style={{ maxWidth: 220, maxHeight: 100, objectFit: "contain", border: "1px solid #ddd", padding: 6 }} />
              <button type="button" disabled={!isAdmin} onClick={() => update("logo_url", "")} style={{ padding: "8px 10px", background: "#b02a37", color: "white", border: "none", borderRadius: 6, width: "fit-content" }}>Logo verwijderen</button>
            </>
          ) : null}
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 8, minWidth: 0 }}>
          <h4 style={{ marginBottom: 2 }}>Documentteksten</h4>
          <label>Introductietekst</label>
          <RichTextEditor value={settings.intro_text || ""} disabled={!isAdmin} minHeight={120} onChange={(value) => update("intro_text", value)} />
          <label>Footer tekst</label>
          <RichTextEditor value={settings.footer_text || ""} disabled={!isAdmin} minHeight={90} onChange={(value) => update("footer_text", value)} />
          {renderVariableInfo([
            { title: "Document", variables: ["{document_nummer}", "{bedrijfscode}"] },
            { title: "Relatie en persoon", variables: ["{relatie}", "{contactpersoon}", "{kandidaat}", "{functie}"] },
            { title: "Planning", variables: ["{startdatum}", "{einddatum}"] },
          ])}
        </div>
      </div>

      {vacancy ? (
        <>
          <hr style={{ margin: "24px 0 18px" }} />
          <div style={{ width:"100%", maxWidth:980, padding:16, border:"1px solid #d9e2ec", borderRadius:8, background:"#fafafa", boxSizing:"border-box" }}>
            <h4 style={{ margin:"0 0 6px 0" }}>Documentinhoud</h4>
            <div style={{ marginBottom:14, fontSize:12, color:"#5d6b78" }}>Bepaal welke gegevens op het externe vacaturedocument worden afgedrukt. De keuzes gelden per bedrijfscode.</div>
            <div style={{ display:"grid", gridTemplateColumns:isMobile?"1fr":"repeat(3, minmax(0, 1fr))", gap:18 }}>
              {[
                {title:"Algemene gegevens",fields:[["show_relation","Relatie"],["show_contact","Contactpersoon"],["show_function","Functie"],["show_vacancy_title","Vacaturetitel"],["show_number_requested","Aantal gevraagd"],["show_period","Start- en einddatum"],["show_notice_period","Opzegtermijn"],["show_hours_per_week","Uren per week"],["show_weekends","Doorplannen in weekend"],["show_schedule","Werktijden / rooster"],["show_location","Locatie / bezoekadres"],["show_location_contact","Contact op locatie"],["show_registration_procedure","Aanmeldprocedure"],["show_priority","Prioriteit"]]},
                {title:"Profiel en voorwaarden",fields:[["show_work_description","Omschrijving werkzaamheden"],["show_requirements","Functie-eisen"],["show_offer","Aanbod / voorwaarden"],["show_education","Opleiding"],["show_experience","Werkervaring"],["show_certificates","Certificaten"],["show_driving_license","Rijbewijs"],["show_transport","Vervoer"],["show_employment_types","Toegestane inzetvorm"],["show_languages","Talen"],["show_cao","CAO"],["show_rate_indication","Salarisindicatie"]]},
                {title:"Teksten en interne gegevens",fields:[["show_external_text","Externe vacaturetekst"],["show_external_note","Externe opmerking"],["show_factor","Factor"],["show_min_rate","Minimaal tarief"],["show_invoice_agreement","Factuurafspraak"],["show_internal_description","Interne omschrijving"],["show_internal_note","Interne opmerking"]]}
              ].map((group)=>(
                <div key={group.title}><div style={{fontWeight:700,marginBottom:8}}>{group.title}</div><div style={{display:"grid",gap:7}}>
                  {group.fields.map(([key,label])=><label key={key} style={{display:"flex",alignItems:"center",gap:8}}><input type="checkbox" checked={settings[key]===true} disabled={!isAdmin} onChange={(e)=>update(key,e.target.checked)}/><span>{label}</span></label>)}
                </div></div>
              ))}
            </div>
          </div>
        </>
      ) : null}

      {placement ? (
        <>
          <hr style={{ margin: "24px 0 18px" }} />

          <div
            style={{
              width: "100%",
              maxWidth: 980,
              minWidth: 0,
              padding: 16,
              border: "1px solid #d9e2ec",
              borderRadius: 8,
              background: "#fafafa",
              boxSizing: "border-box",
            }}
          >
            <h4 style={{ margin: "0 0 6px 0" }}>Documentinhoud</h4>
            <div style={{ marginBottom: 14, fontSize: 12, color: "#5d6b78", lineHeight: 1.5 }}>
              Bepaal welke gegevens op de plaatsingsbevestiging voor {candidate ? "de kandidaat" : "de klant"} worden afgedrukt.
              De keuzes gelden per bedrijfscode.
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: isMobile ? "minmax(0, 1fr)" : "repeat(3, minmax(0, 1fr))",
                gap: 18,
                minWidth: 0,
              }}
            >
              {[
                {
                  title: "Algemene gegevens",
                  fields: [
                    ["show_function", "Functie"],
                    ["show_relation", "Relatie"],
                    ["show_contact", "Contactpersoon"],
                    ["show_candidate", "Kandidaat"],
                    ["show_start_date", "Startdatum"],
                    ["show_end_date", "Einddatum"],
                    ["show_notice_period", "Opzegtermijn"],
                    ["show_hours_per_week", "Uren per week"],
                    ["show_weekends", "Doorplannen in weekend"],
                    ["show_schedule", "Werktijden / rooster"],
                    ["show_location", "Locatie / bezoekadres"],
                    ["show_location_contact", "Contact op locatie"],
                    ["show_registration_procedure", "Aanmeldprocedure"],
                    ["show_employment_type", "Inzetvorm"],
                  ],
                },
                {
                  title: candidate ? "Loongegevens" : "Loon- en tariefgegevens",
                  fields: candidate
                    ? [
                        ["show_cao", "CAO"],
                        ["show_wage_period", "Loonperiode"],
                        ["show_hourly_wage", "Uurloon kandidaat"],
                        ["show_transport", "Vervoer (Eigen / Vd Zaak)"],
                        ["show_travel_costs", "Reiskostenvergoeding"],
                        ["show_allowances", "Toeslagen"],
                      ]
                    : [
                        ["show_cao", "CAO"],
                        ["show_wage_period", "Loonperiode"],
                        ["show_hourly_wage", "Uurloon kandidaat"],
                        ["show_invoice_period", "Factuurperiode"],
                        ["show_sales_rate", "Verkooptarief"],
                        ["show_factor", "Factor"],
                        ["show_transport", "Vervoer kandidaat"],
                        ["show_customer_travel_costs", "Reiskosten klant / doorberekening"],
                        ["show_allowances", "Toeslagen"],
                      ],
                },
                {
                  title: "Overige afspraken",
                  fields: candidate
                    ? [["show_external_note", "Externe opmerking"]]
                    : [
                        ["show_invoice_agreement", "Factuurafspraak"],
                        ["show_external_note", "Externe opmerking"],
                      ],
                },
              ].map((group) => (
                <div key={group.title}>
                  <div style={{ fontWeight: 700, marginBottom: 8 }}>{group.title}</div>
                  <div style={{ display: "grid", gap: 7 }}>
                    {group.fields.map(([key, label]) => (
                      <label
                        key={key}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          cursor: isAdmin ? "pointer" : "not-allowed",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={settings[key] !== false}
                          disabled={!isAdmin}
                          onChange={(e) => update(key, e.target.checked)}
                        />
                        <span>{label}</span>
                      </label>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      ) : null}

      <hr style={{ margin: "24px 0 18px" }} />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "minmax(0, 1fr)" : "repeat(2, minmax(0, 1fr))",
          gap: 18,
          width: "100%",
          maxWidth: 980,
          minWidth: 0,
          boxSizing: "border-box",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 8, minWidth: 0 }}>
          <h4 style={{ marginBottom: 2 }}>E-mail</h4>
          <div style={{ fontSize: 12, color: "#5d6b78", lineHeight: 1.5, marginBottom: 4 }}>
            StaffIQ vult de geadresseerde, documentgegevens en verzender automatisch in.
          </div>
          <label>Onderwerp</label><input value={settings.email_subject || ""} disabled={!isAdmin} onChange={(e) => update("email_subject", e.target.value)} />
          <label>Bericht</label><textarea rows={11} value={settings.email_text || ""} disabled={!isAdmin} onChange={(e) => update("email_text", e.target.value)} style={{ resize: "vertical" }} />
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 8, minWidth: 0 }}>
          <h4 style={{ marginBottom: 2 }}>{placement ? "WhatsApp en digitale accordering" : "WhatsApp"}</h4>
          <div style={{ fontSize: 12, color: "#5d6b78", lineHeight: 1.5, marginBottom: 4 }}>
            StaffIQ vult de aanhef, documentgegevens, akkoordlink en verzender automatisch in.
          </div>
          <label>WhatsApp-bericht</label><textarea rows={11} value={settings.whatsapp_text || ""} disabled={!isAdmin} onChange={(e) => update("whatsapp_text", e.target.value)} style={{ resize: "vertical" }} />
          {placement ? (
            <>
              <label>Verklaring bij akkoord</label><textarea rows={3} value={settings.approval_text || ""} disabled={!isAdmin} onChange={(e) => update("approval_text", e.target.value)} />
              <label>Tekst na akkoord</label><textarea rows={3} value={settings.approved_page_text || ""} disabled={!isAdmin} onChange={(e) => update("approved_page_text", e.target.value)} />
              <label>Tekst na niet akkoord</label><textarea rows={3} value={settings.rejected_page_text || ""} disabled={!isAdmin} onChange={(e) => update("rejected_page_text", e.target.value)} />
              {candidate ? <div style={{ fontSize: 12, color: "#5d6b78" }}>Bij de kandidaat wordt geen verklaring namens een organisatie gebruikt.</div> : null}
            </>
          ) : null}
        </div>
      </div>

      {renderVariableInfo([
        { title: "Document", variables: ["{document_nummer}", "{bedrijfscode}"] },
        { title: "Relatie en persoon", variables: ["{relatie}", "{contactpersoon}", "{kandidaat}", "{functie}"] },
        { title: "Workflow", variables: placement ? ["{beknopte_inhoud}", "{akkoordlink}"] : [] },
        { title: "Afzender", variables: ["{verzender_naam}", "{verzender_email}"] },
      ])}

      <div style={{ marginTop: 18 }}>
        <button type="button" onClick={save} disabled={!isAdmin} style={{ padding: "10px", background: "#1f4e79", color: "white", border: "none", borderRadius: 6, cursor: isAdmin ? "pointer" : "not-allowed", opacity: isAdmin ? 1 : 0.5 }}>
          Opslaan {title.toLowerCase()}
        </button>
      </div>
    </div>
  );
}

async function loadInvoiceTemplates() {
  try {
    const res = await fetch(`${API_BASE}/api/invoice-templates`, {
      headers: authHeaders(),
    });

    const data = await res.json().catch(() => []);

    if (!res.ok) {
      console.log("Fout bij laden factuursjablonen:", data);
      setInvoiceTemplates([]);
      setSelectedInvoiceTemplate(emptyInvoiceTemplate);
      return;
    }

    const list = Array.isArray(data) ? data : [];
    setInvoiceTemplates(list);

    setSelectedInvoiceTemplate((prev) => {
      if (prev?.id) {
        const stillExists = list.find((x) => String(x.id) === String(prev.id));
        if (stillExists) return stillExists;
      }

      return emptyInvoiceTemplate;
    });
  } catch (err) {
    console.log("Fout bij laden factuursjablonen:", err);
    setInvoiceTemplates([]);
    setSelectedInvoiceTemplate(emptyInvoiceTemplate);
  }
}

function newInvoiceTemplate() {
  setSelectedInvoiceTemplate({ ...emptyInvoiceTemplate });
  setInvoiceTemplateFlash("");
}

async function saveInvoiceTemplate() {
  if (!isAdmin) {
    alert("Alleen de administrator mag factuursjablonen wijzigen.");
    return;
  }

  const name = String(selectedInvoiceTemplate?.name || "").trim();

  if (!name) {
    alert("Vul eerst een naam voor het factuursjabloon in.");
    return;
  }

  try {
    const isUpdate = !!selectedInvoiceTemplate?.id;
    const res = await fetch(
      isUpdate
        ? `${API_BASE}/api/invoice-templates/${encodeURIComponent(selectedInvoiceTemplate.id)}`
        : `${API_BASE}/api/invoice-templates`,
      {
        method: isUpdate ? "PUT" : "POST",
        headers: authHeaders(),
        body: JSON.stringify({
          ...selectedInvoiceTemplate,
          name,
        }),
      }
    );

    const rawText = await res.text();
    let data = {};

    try {
      data = rawText ? JSON.parse(rawText) : {};
    } catch {
      data = { error: rawText || "" };
    }

    if (!res.ok) {
      alert(data?.error || data?.message || rawText || "Opslaan van factuursjabloon is mislukt.");
      return;
    }

    setSelectedInvoiceTemplate(emptyInvoiceTemplate);
    await loadInvoiceTemplates();

    setInvoiceTemplateFlash("✅ Factuursjabloon opgeslagen");
    positionSettingsTop();
    setTimeout(() => setInvoiceTemplateFlash(""), 1800);
  } catch (err) {
    console.log("Fout bij opslaan factuursjabloon:", err);
    alert(`Opslaan van factuursjabloon is mislukt.\n\n${err?.message || err}`);
  }
}

async function deleteInvoiceTemplate() {
  if (!isAdmin || !selectedInvoiceTemplate?.id) return;
  if (!window.confirm("Factuursjabloon verwijderen?")) return;

  try {
    const token =
      sessionStorage.getItem("token") ||
      localStorage.getItem("token") ||
      "";

    const res = await fetch(
      `${API_BASE}/api/invoice-templates/${encodeURIComponent(selectedInvoiceTemplate.id)}`,
      {
        method: "DELETE",
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    );

    const rawText = await res.text();
    let data = {};

    try {
      data = rawText ? JSON.parse(rawText) : {};
    } catch {
      data = { error: rawText || "" };
    }

    if (!res.ok) {
      alert(data?.error || data?.message || rawText || "Verwijderen van factuursjabloon is mislukt.");
      return;
    }

    setSelectedInvoiceTemplate(emptyInvoiceTemplate);
    await loadInvoiceTemplates();

    setInvoiceTemplateFlash("✅ Factuursjabloon verwijderd");
    setTimeout(() => setInvoiceTemplateFlash(""), 1800);
  } catch (err) {
    console.log("Fout bij verwijderen factuursjabloon:", err);
    alert(`Verwijderen van factuursjabloon is mislukt.\n\n${err?.message || err}`);
  }
}

async function loadOfferTemplates(companyCodeId = selectedSettingsCompanyCodeId("mkb_offers")) {
  try {
    const qs = new URLSearchParams();
    qs.set("scope", "exact");
    if (companyCodeId) qs.set("company_code_id", String(companyCodeId));

    const res = await fetch(`${API_BASE}/api/offer-templates?${qs.toString()}`, {
      headers: authHeaders(),
    });

    const data = await res.json().catch(() => []);

    if (!res.ok) {
      console.log("Fout bij laden offerte-/opdrachtsjablonen:", data);
      setOfferTemplates([]);
      setSelectedOfferTemplate(emptyOfferTemplate);
      return;
    }

    const list = Array.isArray(data) ? data : [];
    setOfferTemplates(list);

    setSelectedOfferTemplate((prev) => {
      if (prev?.id) {
        const stillExists = list.find((x) => String(x.id) === String(prev.id));
        if (stillExists) return stillExists;
      }

      return emptyOfferTemplate;
    });
  } catch (err) {
    console.log("Fout bij laden offerte-/opdrachtsjablonen:", err);
    setOfferTemplates([]);
    setSelectedOfferTemplate(emptyOfferTemplate);
  }
}

function newOfferTemplate() {
  setSelectedOfferTemplate({ ...emptyOfferTemplate });
  setTemplateFlash("");
}
function renderOfferTemplateShowLabel(label, field) {
  return (
    <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <span>{label}</span>
      <input type="checkbox" checked={selectedOfferTemplate?.[field] !== false} disabled={!isAdmin}
        onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, [field]: e.target.checked })} />
      <span style={{ fontWeight: 400 }}>Tonen</span>
    </label>
  );
}

async function saveOfferTemplate() {
  if (!isAdmin) {
    alert("Alleen de administrator mag sjablonen wijzigen.");
    return;
  }

  const name = String(selectedOfferTemplate?.name || "").trim();

  if (!name) {
    alert("Vul eerst een naam voor het sjabloon in.");
    return;
  }

  try {
    const isUpdate = !!selectedOfferTemplate?.id;
    const res = await fetch(
      isUpdate
        ? `${API_BASE}/api/offer-templates/${encodeURIComponent(selectedOfferTemplate.id)}`
        : `${API_BASE}/api/offer-templates`,
      {
        method: isUpdate ? "PUT" : "POST",
        headers: authHeaders(),
        body: JSON.stringify({
          ...selectedOfferTemplate,
          name,
          // Een lege Aanhef blijft niet stilzwijgend blanco in de klantofferte.
          salutation: richTextPlainText(selectedOfferTemplate.salutation || "")
            ? selectedOfferTemplate.salutation
            : "{aanhef}",
          company_code_id: selectedSettingsCompanyCodeId("mkb_offers")
            ? Number(selectedSettingsCompanyCodeId("mkb_offers"))
            : null,
        }),
      }
    );

    const rawText = await res.text();
    let data = {};

    try {
      data = rawText ? JSON.parse(rawText) : {};
    } catch {
      data = { error: rawText || "" };
    }

    if (!res.ok) {
      const message =
        data?.error ||
        data?.message ||
        data?.detail ||
        rawText ||
        `Opslaan van sjabloon is mislukt (${res.status}).`;

      alert(
        `Opslaan van sjabloon is mislukt.\n\n` +
        `Status: ${res.status}\n` +
        `Melding: ${message}`
      );
      return;
    }

    setSelectedOfferTemplate(emptyOfferTemplate);
    await loadOfferTemplates(selectedSettingsCompanyCodeId("mkb_offers"));

    setTemplateFlash("✅ Sjabloon opgeslagen");
    positionOfferTemplatesTop();

    setTimeout(() => setTemplateFlash(""), 1800);
  } catch (err) {
    console.log("Fout bij opslaan sjabloon:", err);
    alert(`Opslaan van sjabloon is mislukt.\n\n${err?.message || err}`);
  }
}

async function deleteOfferTemplate() {
  if (!isAdmin || !selectedOfferTemplate?.id) return;
  if (!window.confirm("Sjabloon verwijderen?")) return;

  try {
    const token =
      sessionStorage.getItem("token") ||
      localStorage.getItem("token") ||
      "";

    const res = await fetch(
      `${API_BASE}/api/offer-templates/${encodeURIComponent(selectedOfferTemplate.id)}`,
      {
        method: "DELETE",
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    );

    const rawText = await res.text();
    let data = {};

    try {
      data = rawText ? JSON.parse(rawText) : {};
    } catch {
      data = { error: rawText || "" };
    }

    if (!res.ok) {
      const message =
        data?.error ||
        data?.message ||
        data?.detail ||
        rawText ||
        `Verwijderen van sjabloon is mislukt (${res.status}).`;

      alert(
        `Verwijderen van sjabloon is mislukt.\n\n` +
        `Status: ${res.status}\n` +
        `Melding: ${message}\n` +
        `Detail: ${data?.detail || "-"}\n` +
        `Code: ${data?.code || "-"}\n` +
        `Tabel: ${data?.table || "-"}\n` +
        `Constraint: ${data?.constraint || "-"}`
      );
      return;
    }

    setSelectedOfferTemplate(emptyOfferTemplate);
    await loadOfferTemplates(selectedSettingsCompanyCodeId("mkb_offers"));

    setTemplateFlash("✅ Sjabloon verwijderd");
    positionOfferTemplatesTop();

    setTimeout(() => setTemplateFlash(""), 1800);
  } catch (err) {
    console.log("Fout bij verwijderen sjabloon:", err);
    alert(`Verwijderen van sjabloon is mislukt.\n\n${err?.message || err}`);
  }
}

async function saveInvoiceSettings() {
    if (!isAdmin) {
      alert("Alleen de administrator mag instellingen wijzigen.");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/api/invoice-settings`, {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify(invoiceSettings),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        console.log("Opslaan instellingen mislukt:", data);
        alert(data?.error || data?.message || "Opslaan van instellingen is mislukt.");
        return;
      }

      setInvoiceSettings((prev) => ({
        ...prev,
        ...(data || {}),
      }));

      setInvoiceFlash("✅ Instellingen opgeslagen");
      positionSettingsTop();
      setTimeout(() => setInvoiceFlash(""), 2000);
    } catch (err) {
      console.log("Fout bij opslaan instellingen:", err);
      alert("Opslaan van instellingen is mislukt.");
    }
  }

// -------------------- GEBRUIKERSLOGBOEK --------------------

function formatActivityDate(value) {
  const raw = String(value || "");
  if (!raw) return "";

  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return raw;

  return d.toLocaleString("nl-NL", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

function formatDurationSeconds(seconds) {
  const n = Number(seconds || 0);
  if (!Number.isFinite(n) || n <= 0) return "";

  const h = Math.floor(n / 3600);
  const m = Math.floor((n % 3600) / 60);
  const s = Math.floor(n % 60);

  if (h > 0) return `${h}u ${m}m ${s}s`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}

function isTechnicalActivityRow(row) {
  const module = String(row?.module || "").toLowerCase().trim();
  const action = String(row?.action || "").toLowerCase().trim();

  return module === "sessie" && action === "heartbeat";
}

function getVisibleActivityLogRows() {
  const rows = Array.isArray(activityLog) ? activityLog : [];

  if (showTechnicalActivity) return rows;

  return rows.filter((row) => !isTechnicalActivityRow(row));
}

function safePrintText(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function printActivityView() {
  const title =
    activityTab === "sessions"
      ? "StaffIQ gebruikerssessies"
      : "StaffIQ gebruikerslogboek";

  const printedAt = new Date().toLocaleString("nl-NL");

  let rowsHtml = "";

  if (activityTab === "sessions") {
    rowsHtml = (Array.isArray(activitySessions) ? activitySessions : [])
      .map((row) => `
        <tr>
          <td>${safePrintText(row.user_name || row.user_email || "-")}</td>
          <td>${safePrintText(formatActivityDate(row.started_at))}</td>
          <td>${safePrintText(formatActivityDate(row.last_seen_at))}</td>
          <td>${safePrintText(formatActivityDate(row.ended_at))}</td>
          <td>${safePrintText(formatDurationSeconds(row.duration_seconds))}</td>
          <td>${safePrintText(row.logout_reason || "-")}</td>
        </tr>
      `)
      .join("");
  } else {
    rowsHtml = getVisibleActivityLogRows()
      .map((row) => `
        <tr>
          <td>${safePrintText(formatActivityDate(row.created_at))}</td>
          <td>${safePrintText(row.user_name || row.user_email || "-")}</td>
          <td>${safePrintText(row.module || "-")}</td>
          <td>${safePrintText(row.action || "-")}</td>
          <td>${safePrintText(row.status || "-")}</td>
          <td>${safePrintText(row.description || row.error_message || "-")}</td>
        </tr>
      `)
      .join("");
  }

  const headerHtml =
    activityTab === "sessions"
      ? `
        <tr>
          <th>Gebruiker</th>
          <th>Start</th>
          <th>Laatste activiteit</th>
          <th>Einde</th>
          <th>Duur</th>
          <th>Reden</th>
        </tr>
      `
      : `
        <tr>
          <th>Datum/tijd</th>
          <th>Gebruiker</th>
          <th>Module</th>
          <th>Actie</th>
          <th>Status</th>
          <th>Omschrijving</th>
        </tr>
      `;

  const html = `
    <html>
      <head>
        <title>${safePrintText(title)}</title>
        <style>
          body {
            font-family: Calibri, Carlito, Arial, sans-serif;
            font-size: 12px;
            color: #222;
            margin: 24px;
          }

          h1 {
            font-size: 20px;
            margin: 0 0 8px 0;
          }

          .meta {
            font-size: 11px;
            color: #666;
            margin-bottom: 16px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }

          th {
            text-align: left;
            background: #f0f4f8;
            border-bottom: 1px solid #999;
            padding: 6px;
          }

          td {
            border-bottom: 1px solid #ddd;
            padding: 6px;
            vertical-align: top;
          }

          @media print {
            body {
              margin: 12mm;
            }
          }
        </style>
      </head>
      <body>
        <h1>${safePrintText(title)}</h1>
        <div class="meta">
          Afgedrukt op: ${safePrintText(printedAt)}
          ${activitySearch ? `<br />Zoektekst: ${safePrintText(activitySearch)}` : ""}
          ${activityModule ? `<br />Module: ${safePrintText(activityModule)}` : ""}
          ${activityStatus ? `<br />Status: ${safePrintText(activityStatus)}` : ""}
          ${activityDateFrom ? `<br />Vanaf: ${safePrintText(activityDateFrom)}` : ""}
          ${activityDateTo ? `<br />Tot: ${safePrintText(activityDateTo)}` : ""}
        </div>

        <table>
          <thead>
            ${headerHtml}
          </thead>
          <tbody>
            ${rowsHtml || `<tr><td colspan="6">Geen regels gevonden.</td></tr>`}
          </tbody>
        </table>
      </body>
    </html>
  `;

  const win = window.open("", "_blank", "width=1100,height=800");
  if (!win) {
    alert("Printvenster kon niet worden geopend.");
    return;
  }

  win.document.open();
  win.document.write(html);
  win.document.close();

  setTimeout(() => {
    try {
      win.focus();
      win.print();
    } catch {}
  }, 300);
}

async function cleanupActivityLog() {
  if (!isAdmin) {
    alert("Alleen de administrator mag het logboek opschonen.");
    return;
  }

  const labels = {
    technical_30_days: "technische Heartbeat-regels ouder dan 30 dagen",
    technical_all: "alle technische Heartbeat-regels",
    all_12_months: "alle logboekregels en sessies ouder dan 12 maanden",
    all_24_months: "alle logboekregels en sessies ouder dan 24 maanden",
  };

  const label = labels[cleanupMode] || cleanupMode;

  const ok = window.confirm(
    `Weet je zeker dat je ${label} wilt verwijderen?\n\nDeze actie kan niet ongedaan worden gemaakt.`
  );

  if (!ok) return;

  try {
    setCleanupBusy(true);

    const res = await fetch(`${API_BASE}/api/activity-log/cleanup`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({
        mode: cleanupMode,
      }),
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      console.log("Opschonen logboek mislukt:", data);
      alert(data?.error || data?.message || "Opschonen logboek mislukt.");
      return;
    }

    alert(
      `Logboek opgeschoond.\n\nActiviteiten verwijderd: ${data.activityDeleted || 0}\nSessies verwijderd: ${data.sessionsDeleted || 0}`
    );

    await refreshActivityView();
  } catch (err) {
    console.log("Fout bij opschonen logboek:", err);
    alert("Opschonen logboek mislukt.");
  } finally {
    setCleanupBusy(false);
  }
}

async function loadActivityLog() {
  try {
    setActivityLoading(true);

    const params = new URLSearchParams();
    params.set("limit", "300");

    if (activitySearch.trim()) params.set("search", activitySearch.trim());
    if (activityModule.trim()) params.set("module", activityModule.trim());
    if (activityStatus.trim()) params.set("status", activityStatus.trim());
    if (activityDateFrom.trim()) params.set("date_from", activityDateFrom.trim());
    if (activityDateTo.trim()) params.set("date_to", activityDateTo.trim());

    const res = await fetch(`${API_BASE}/api/activity-log?${params.toString()}`, {
      headers: authHeaders(),
    });

    const data = await res.json().catch(() => []);

    if (!res.ok) {
      console.log("Fout bij laden logboek:", data);
      alert(data?.error || data?.message || "Logboek kon niet worden geladen.");
      setActivityLog([]);
      return;
    }

    setActivityLog(Array.isArray(data) ? data : []);
  } catch (err) {
    console.log("Fout bij laden logboek:", err);
    alert("Logboek kon niet worden geladen.");
    setActivityLog([]);
  } finally {
    setActivityLoading(false);
  }
}

async function loadActivitySessions() {
  try {
    setActivityLoading(true);

    const params = new URLSearchParams();
    params.set("limit", "300");

    if (activitySearch.trim()) params.set("user_email", activitySearch.trim());
    if (activityDateFrom.trim()) params.set("date_from", activityDateFrom.trim());
    if (activityDateTo.trim()) params.set("date_to", activityDateTo.trim());

    const res = await fetch(`${API_BASE}/api/activity-log/sessions?${params.toString()}`, {
      headers: authHeaders(),
    });

    const data = await res.json().catch(() => []);

    if (!res.ok) {
      console.log("Fout bij laden sessies:", data);
      alert(data?.error || data?.message || "Gebruikerssessies konden niet worden geladen.");
      setActivitySessions([]);
      return;
    }

    setActivitySessions(Array.isArray(data) ? data : []);
  } catch (err) {
    console.log("Fout bij laden sessies:", err);
    alert("Gebruikerssessies konden niet worden geladen.");
    setActivitySessions([]);
  } finally {
    setActivityLoading(false);
  }
}

async function refreshActivityView() {
  if (activityTab === "sessions") {
    await loadActivitySessions();
  } else {
    await loadActivityLog();
  }
}

function openActivityLog() {
  setView("activity");
  setActivityTab("log");
  scrollToDetailMobile();

  setTimeout(() => {
    loadActivityLog();
  }, 50);
}

function renderActivityLogView() {
  return (
    <>
      <h3>Gebruikerslogboek <span style={{ fontSize: 13, color: "#777" }}>{VERSION}</span></h3>

      <div
        style={{
          marginBottom: 12,
          padding: "10px 12px",
          background: "#f7fbff",
          border: "1px solid #d9e2ec",
          borderRadius: 6,
          lineHeight: 1.5,
          maxWidth: 1100,
        }}
      >
        Hier zie je de gebruikershandelingen en sessies. GET-verzoeken worden bewust niet gelogd,
        zodat het systeem niet onnodig zwaar wordt.
      </div>

      <div
        style={{
          display: "flex",
          gap: 8,
          flexWrap: "wrap",
          marginBottom: 12,
        }}
      >
        <button
          type="button"
          onClick={() => {
            setActivityTab("log");
            setTimeout(() => loadActivityLog(), 50);
          }}
          style={{
            padding: "8px 12px",
            background: activityTab === "log" ? "#1f4e79" : "white",
            color: activityTab === "log" ? "white" : "#111",
            border: "1px solid #d9e2ec",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          Activiteiten
        </button>

        <button
          type="button"
          onClick={() => {
            setActivityTab("sessions");
            setTimeout(() => loadActivitySessions(), 50);
          }}
          style={{
            padding: "8px 12px",
            background: activityTab === "sessions" ? "#1f4e79" : "white",
            color: activityTab === "sessions" ? "white" : "#111",
            border: "1px solid #d9e2ec",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          Sessies
        </button>

        <button
          type="button"
          onClick={refreshActivityView}
          style={{
            padding: "8px 12px",
            background: "#2e7d32",
            color: "white",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          Vernieuw
        </button>

        <button
          type="button"
          onClick={printActivityView}
          style={{
            padding: "8px 12px",
            background: "#1f4e79",
            color: "white",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          Print
        </button>

        {activityTab === "log" && (
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "8px 10px",
              border: "1px solid #d9e2ec",
              borderRadius: 6,
              background: "white",
              fontSize: 13,
            }}
          >
            <input
              type="checkbox"
              checked={showTechnicalActivity}
              onChange={(e) => setShowTechnicalActivity(e.target.checked)}
            />
            Toon technische regels
          </label>
        )}
      </div>

      <div
        style={{
          display: "flex",
          gap: 8,
          flexWrap: "wrap",
          alignItems: "center",
          marginBottom: 12,
          padding: "10px 12px",
          border: "1px solid #f0d0d0",
          borderRadius: 6,
          background: "#fff7f7",
          maxWidth: 1100,
        }}
      >
        <strong style={{ marginRight: 6 }}>Opschonen:</strong>

        <select
          value={cleanupMode}
          onChange={(e) => setCleanupMode(e.target.value)}
          disabled={!isAdmin || cleanupBusy}
          style={{ minWidth: 280 }}
        >
          <option value="technical_30_days">Heartbeat ouder dan 30 dagen</option>
          <option value="technical_all">Alle Heartbeat-regels</option>
          <option value="all_12_months">Alles ouder dan 12 maanden</option>
          <option value="all_24_months">Alles ouder dan 24 maanden</option>
        </select>

        <button
          type="button"
          onClick={cleanupActivityLog}
          disabled={!isAdmin || cleanupBusy}
          style={{
            padding: "8px 12px",
            background: "#b71c1c",
            color: "white",
            border: "none",
            borderRadius: 6,
            cursor: isAdmin && !cleanupBusy ? "pointer" : "not-allowed",
            opacity: isAdmin && !cleanupBusy ? 1 : 0.5,
          }}
        >
          {cleanupBusy ? "Opschonen..." : "Opschonen"}
        </button>

        <span style={{ fontSize: 12, color: "#777" }}>
          Alleen administrator. Verwijderen kan niet ongedaan worden gemaakt.
        </span>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "2fr 1fr 1fr 1fr 1fr",
          gap: 8,
          marginBottom: 12,
          maxWidth: 1100,
        }}
      >
        <input
          value={activitySearch}
          onChange={(e) => setActivitySearch(e.target.value)}
          placeholder={activityTab === "sessions" ? "Zoek gebruiker/e-mail" : "Zoek in logboek"}
        />

        <select
          value={activityModule}
          disabled={activityTab === "sessions"}
          onChange={(e) => setActivityModule(e.target.value)}
        >
          <option value="">Alle modules</option>
          <option value="Login">Login</option>
          <option value="Sessie">Sessie</option>
          <option value="Gebruikers">Gebruikers</option>
          <option value="Organisaties">Organisaties</option>
          <option value="Contactpersonen">Contactpersonen</option>
          <option value="Personeel">Personeel</option>
          <option value="Offertes">Offertes</option>
          <option value="Facturen">Facturen</option>
          <option value="Projectbeheer">Projectbeheer</option>
          <option value="Documenten">Documenten</option>
          <option value="Communicatie">Communicatie</option>
          <option value="Instellingen">Instellingen</option>
        </select>

        <select
          value={activityStatus}
          disabled={activityTab === "sessions"}
          onChange={(e) => setActivityStatus(e.target.value)}
        >
          <option value="">Alle statussen</option>
          <option value="ok">Ok</option>
          <option value="fout">Fout</option>
        </select>

        <input
          type="date"
          value={activityDateFrom}
          onChange={(e) => setActivityDateFrom(e.target.value)}
        />

        <input
          type="date"
          value={activityDateTo}
          onChange={(e) => setActivityDateTo(e.target.value)}
        />
      </div>

      {activityLoading && (
        <div style={{ marginBottom: 10, color: "#555" }}>
          Laden...
        </div>
      )}

{activityTab === "log" ? (
        <div
          style={{
            overflow: "auto",
            maxWidth: "100%",
            height: isMobile ? "58dvh" : "calc(100dvh - 365px)",
            maxHeight: isMobile ? "58dvh" : "calc(100dvh - 365px)",
            minHeight: 220,
            border: "1px solid #e5e7eb",
            borderRadius: 6,
            scrollbarGutter: "stable",
          }}
        >
          <table
            style={{
              borderCollapse: "collapse",
              width: "100%",
              minWidth: 1100,
              fontSize: 13,
            }}
          >
            <thead>
              <tr style={{ background: "#f0f4f8" }}>
                <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #d9e2ec", position: "sticky", top: 0, background: "#f0f4f8", zIndex: 1 }}>Datum/tijd</th>
                <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #d9e2ec", position: "sticky", top: 0, background: "#f0f4f8", zIndex: 1 }}>Gebruiker</th>
                <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #d9e2ec", position: "sticky", top: 0, background: "#f0f4f8", zIndex: 1 }}>Module</th>
                <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #d9e2ec", position: "sticky", top: 0, background: "#f0f4f8", zIndex: 1 }}>Omschrijving</th>
                <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #d9e2ec", position: "sticky", top: 0, background: "#f0f4f8", zIndex: 1 }}>Actie</th>
                <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #d9e2ec", position: "sticky", top: 0, background: "#f0f4f8", zIndex: 1 }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {getVisibleActivityLogRows().length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ padding: 10, color: "#777" }}>
                    Geen logboekregels gevonden.
                  </td>
                </tr>
              ) : (
                getVisibleActivityLogRows().map((row) => (
                  <tr key={row.id}>
                    <td style={{ padding: 8, borderBottom: "1px solid #eee", whiteSpace: "nowrap" }}>
                      {formatActivityDate(row.created_at)}
                    </td>
                    <td style={{ padding: 8, borderBottom: "1px solid #eee", whiteSpace: "nowrap" }}>
                      {row.user_name || row.user_email || "-"}
                    </td>
                    <td style={{ padding: 8, borderBottom: "1px solid #eee", whiteSpace: "nowrap" }}>
                      {row.module || "-"}
                    </td>
                    <td style={{ padding: 8, borderBottom: "1px solid #eee", minWidth: 360 }}>
                      {row.description || row.error_message || "-"}
                    </td>
                    <td style={{ padding: 8, borderBottom: "1px solid #eee", whiteSpace: "nowrap" }}>
                      {row.action || "-"}
                    </td>
                    <td
                      style={{
                        padding: 8,
                        borderBottom: "1px solid #eee",
                        color: row.status === "fout" ? "crimson" : "#1f6b1f",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {row.status || "-"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      ) : (
        <div
          style={{
            overflow: "auto",
            maxWidth: "100%",
            height: isMobile ? "58dvh" : "calc(100dvh - 365px)",
            maxHeight: isMobile ? "58dvh" : "calc(100dvh - 365px)",
            minHeight: 220,
            border: "1px solid #e5e7eb",
            borderRadius: 6,
            scrollbarGutter: "stable",
          }}
        >
          <table
            style={{
              borderCollapse: "collapse",
              width: "100%",
              minWidth: 900,
              fontSize: 13,
            }}
          >
            <thead>
              <tr style={{ background: "#f0f4f8" }}>
                <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #d9e2ec", position: "sticky", top: 0, background: "#f0f4f8", zIndex: 1 }}>Gebruiker</th>
                <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #d9e2ec", position: "sticky", top: 0, background: "#f0f4f8", zIndex: 1 }}>Start</th>
                <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #d9e2ec", position: "sticky", top: 0, background: "#f0f4f8", zIndex: 1 }}>Laatste activiteit</th>
                <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #d9e2ec", position: "sticky", top: 0, background: "#f0f4f8", zIndex: 1 }}>Einde</th>
                <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #d9e2ec", position: "sticky", top: 0, background: "#f0f4f8", zIndex: 1 }}>Duur</th>
                <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #d9e2ec", position: "sticky", top: 0, background: "#f0f4f8", zIndex: 1 }}>Reden</th>
              </tr>
            </thead>
            <tbody>
              {activitySessions.length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ padding: 10, color: "#777" }}>
                    Geen sessies gevonden.
                  </td>
                </tr>
              ) : (
                activitySessions.map((row) => (
                  <tr key={row.id}>
                    <td style={{ padding: 8, borderBottom: "1px solid #eee", whiteSpace: "nowrap" }}>
                      {row.user_name || row.user_email || "-"}
                    </td>
                    <td style={{ padding: 8, borderBottom: "1px solid #eee", whiteSpace: "nowrap" }}>
                      {formatActivityDate(row.started_at)}
                    </td>
                    <td style={{ padding: 8, borderBottom: "1px solid #eee", whiteSpace: "nowrap" }}>
                      {formatActivityDate(row.last_seen_at)}
                    </td>
                    <td style={{ padding: 8, borderBottom: "1px solid #eee", whiteSpace: "nowrap" }}>
                      {formatActivityDate(row.ended_at)}
                    </td>
                    <td style={{ padding: 8, borderBottom: "1px solid #eee", whiteSpace: "nowrap" }}>
                      {formatDurationSeconds(row.duration_seconds)}
                    </td>
                    <td style={{ padding: 8, borderBottom: "1px solid #eee", whiteSpace: "nowrap" }}>
                      {row.logout_reason || "-"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}

if (!isAdmin) {
  return (
    <div style={{ padding: 20 }}>
      <h2>Geen toegang</h2>
      <p>Alleen de administrator mag instellingen gebruiken.</p>
    </div>
  );
}

return (
  <div
    ref={settingsTopRef}
    style={{
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      overflowX: "hidden",
      boxSizing: "border-box",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginTop: 0,
        marginBottom: 10,
      }}
    >
      <h1 style={{ margin: 0 }}>
        Instellingen <span style={{ fontSize: 12, opacity: 0.5 }}>{VERSION}</span>
      </h1>

      <HelpButton
        topic="instellingen"
        title="Help over Instellingen"
      />
    </div>

    <div
  style={{
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "320px minmax(0, 1fr)",
    columnGap: 20,
    rowGap: isMobile ? 20 : 0,
    alignItems: "start",
    minWidth: 0,
    width: "100%",
    maxWidth: "100%",
    overflowX: "hidden",
    boxSizing: "border-box",
  }}
>

{/* LINKS - LIJST */}
      <div
        style={{
          width: isMobile ? "100%" : 320,
          minWidth: isMobile ? 0 : 320,
          maxWidth: isMobile ? "100%" : 320,
          background: "white",
          padding: 10,
          boxSizing: "border-box",
        }}
      >
        {settingsGroupTitle("Algemeen")}
        {settingsMenuButton(
          "general",
          "StaffIQ-profiel en Relaties",
          "Doelgroep, menustructuur en Relatiekaart"
        )}
        {settingsMenuButton(
          "relation_choices",
          "Keuzelijsten Relaties",
          "Relatiesoorten, regio's, landen en betalingskeuzes"
        )}
        {settingsMenuButton(
          "documents",
          "Documentlocatie",
          "Basispad voor opgeslagen documenten"
        )}
        {settingsMenuButton(
          "document_master",
          "Documentsoorten en sets",
          "Documenttypen, geldigheid en documentpakketten"
        )}
        {settingsMenuButton(
          "communication",
          "Communicatiekanalen",
          "E-mail, WhatsApp, bellen en SMS"
        )}

        {showCrmSettings && (
          <>
            {settingsGroupTitle("CRM")}
            {settingsMenuButton(
              "crm_messages",
              "App- en mailteksten",
              "Algemene CRM-communicatie, taken en documenten"
            )}
          </>
        )}

        {showMkbSettings && (
          <>
            {settingsGroupTitle("MKB")}
            {settingsMenuButton(
              "offers",
              "Offertes",
              "Bedrijfsgegevens, teksten en offertesjablonen"
            )}
            {settingsMenuButton(
              "order_settings",
              "Opdrachten",
              "Opdrachtinstellingen en gebruik van werkbonnen"
            )}
            {settingsMenuButton(
              "mkb_work_orders",
              "Werkbonnen",
              "Werkbon- en opleverinstellingen"
            )}
            {settingsMenuButton(
              "invoice",
              "Facturen",
              "Nummering, bedrijfsgegevens en factuursjablonen"
            )}
          </>
        )}

        {showHrmSettings && (
          <>
            {settingsGroupTitle("HRM")}
            {settingsMenuButton(
              "hrm_vacancies",
              "Vacatures",
              "Vacaturedocument en begeleidende teksten"
            )}
            {settingsMenuButton(
              "hrm_placement_customer",
              "Plaatsingsbevestiging klant",
              "Document, e-mail, WhatsApp en digitale accordering"
            )}
            {settingsMenuButton(
              "hrm_placement_candidate",
              "Plaatsingsbevestiging kandidaat",
              "Document, e-mail, WhatsApp en digitale accordering"
            )}
            {settingsMenuButton(
              "hrm_matching_personnel",
              "Matching Personeel",
              "Documentinhoud voor Printen intern en Printen extern"
            )}
            {settingsMenuButton(
              "hrm_matching_relations",
              "Matching Relaties",
              "Documentinhoud voor Printen intern en Printen extern"
            )}
          </>
        )}

        {settingsGroupTitle("Beheer")}
        {settingsMenuButton(
          "companycodes",
          "Bedrijfscodes",
          "Vestigingen, business units en gebruikersrechten"
        )}
        <button
          type="button"
          onClick={newCompanyCode}
          disabled={!isAdmin}
          style={{
            marginTop: 8,
            padding: "8px 10px",
            background: "#1f4e79",
            color: "white",
            border: "none",
            borderRadius: 6,
            cursor: isAdmin ? "pointer" : "not-allowed",
            opacity: isAdmin ? 1 : 0.5,
            width: "100%",
            textAlign: "left",
          }}
        >
          + Nieuwe bedrijfscode
        </button>

        {settingsMenuButton(
          "activity",
          "Gebruikerslogboek",
          "Activiteiten, sessies en foutmeldingen"
        )}

        {settingsGroupTitle("Gebruikers")}
        <button
          type="button"
          onClick={() => {
            newUser();
            scrollToDetailMobile();
          }}
          disabled={!isAdmin}
          style={{
            marginBottom: 12,
            padding: "8px 10px",
            background: "#1f4e79",
            color: "white",
            border: "none",
            borderRadius: 6,
            cursor: isAdmin ? "pointer" : "not-allowed",
            opacity: isAdmin ? 1 : 0.5,
            width: "100%",
            textAlign: "left",
          }}
        >
          + Nieuwe gebruiker
        </button>

        {Array.isArray(users) &&
          users
            .filter((u) => {
              const email = String(u?.email || "").toLowerCase().trim();
              const name = String(u?.display_name || "").toLowerCase().trim();

              if (email === "admin@staffiq.nl") return false;
              if (name === "administrator" && email.includes("@staffiq.nl")) return false;

              return true;
            })
            .map((u) => (
              <div
                key={u.id}
                onClick={() => {
                  setView("user");
                  setSelected({ ...u, password: "" });
                  setShowPassword(false);
                  setUserCompanyCodesFlash("");
                  loadUserCompanyCodes(u.id);
                  scrollToDetailMobile();
                }}
                style={{
                  padding: "8px",
                  cursor: "pointer",
                  background:
                    view === "user" && selected?.id === u.id
                      ? "#e6f0ff"
                      : "transparent",
                  borderBottom: "1px solid #eee",
                }}
              >
                <b>{u.display_name}</b>
                <br />
                <span style={{ fontSize: 12 }}>{u.email}</span>
              </div>
            ))}
      </div>

{/* RECHTS - DETAIL */}
      <div
  ref={detailRef}
  style={{
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    background: "white",
    padding: isMobile ? 14 : 20,
    boxSizing: "border-box",
    overflowX: "hidden",
  }}
>
{view === "general" ? (
          <>
<h3>StaffIQ-profiel en Relaties</h3>

            {flash && (
              <div
                style={{
                  marginBottom: 12,
                  padding: "10px 12px",
                  background: "#eaf7ea",
                  color: "#1f6b1f",
                  border: "1px solid #b7dfb7",
                  borderRadius: 6,
                  maxWidth: 700,
                }}
              >
                {flash}
              </div>
            )}

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 14,
                maxWidth: 700,
              }}
            >
              <div
                style={{
                  padding: 12,
                  border: "1px solid #d9e2ec",
                  borderRadius: 6,
                  background: "#fafafa",
                  lineHeight: 1.6,
                }}
              >
                Kies eerst voor welke doelgroep deze StaffIQ-omgeving wordt gebruikt.
                De database en bestaande gegevens blijven altijd hetzelfde.
                <br /><br />
                <b>CRM</b>: eenvoudig relatiebeheer.
                <br />
                <b>MKB</b>: projectmatig werkende bedrijven.
                <br />
                <b>HRM</b>: personele dienstverlening.
                <br />
                <b>ERP</b>: gereserveerd voor de toekomstige uitgebreide ERP-versie.
                <br />
                <b>ALL</b>: alle huidige menu&apos;s beschikbaar.
              </div>

              <label style={{ fontWeight: 700 }}>StaffIQ-configuratie</label>
              <select
                value={generalSettings.staffiq_profile || "ALL"}
                disabled={!isAdmin}
                onChange={(e) =>
                  setGeneralSettings((prev) => ({
                    ...prev,
                    staffiq_profile: e.target.value,
                  }))
                }
                style={{ maxWidth: 320 }}
              >
                <option value="CRM">CRM - eenvoudig relatiebeheer</option>
                <option value="MKB">MKB - projecten en opdrachten</option>
                <option value="HRM">HRM - personele dienstverlening</option>
                <option value="ERP">ERP - toekomstige uitgebreide versie</option>
                <option value="ALL">ALL - alle programma&apos;s</option>
              </select>

              {generalSettings.staffiq_profile === "ERP" && (
                <div
                  style={{
                    padding: 10,
                    border: "1px solid #f0cf84",
                    borderRadius: 6,
                    background: "#fff8e8",
                    color: "#7a5600",
                  }}
                >
                  ERP is technisch beschikbaar als profielkeuze, maar het ERP-menu
                  wordt in deze fase nog niet opgebouwd.
                </div>
              )}

              <hr style={{ width: "100%", border: 0, borderTop: "1px solid #e5e5e5" }} />

              <div style={{ fontWeight: 700 }}>Relaties bestaan uit</div>

              <label
                style={{
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                  cursor: isAdmin ? "pointer" : "not-allowed",
                }}
              >
                <input
                  type="checkbox"
                  checked={generalSettings.use_organisations === true}
                  disabled={!isAdmin}
                  onChange={(e) => {
                    const checked = e.target.checked;

                    if (!checked && !generalSettings.use_particulieren) {
                      alert("Minimaal één keuze is verplicht.");
                      return;
                    }

                    setGeneralSettings((prev) => ({
                      ...prev,
                      use_organisations: checked,
                    }));
                  }}
                />
                <span>Organisaties</span>
              </label>

              <label
                style={{
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                  cursor: isAdmin ? "pointer" : "not-allowed",
                }}
              >
                <input
                  type="checkbox"
                  checked={generalSettings.use_particulieren === true}
                  disabled={!isAdmin}
                  onChange={(e) => {
                    const checked = e.target.checked;

                    if (!checked && !generalSettings.use_organisations) {
                      alert("Minimaal één keuze is verplicht.");
                      return;
                    }

                    setGeneralSettings((prev) => ({
                      ...prev,
                      use_particulieren: checked,
                    }));
                  }}
                />
                <span>Particulieren</span>
              </label>

              <hr style={{ width: "100%", border: 0, borderTop: "1px solid #e5e5e5" }} />

              <div style={{ fontWeight: 700 }}>Bedragen op Offerte/Opdracht</div>

              <label
                style={{
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                  cursor: isAdmin ? "pointer" : "not-allowed",
                }}
              >
                <input
                  type="checkbox"
                  checked={generalSettings.offer_prices_include_vat !== true}
                  disabled={!isAdmin}
                  onChange={() =>
                    setGeneralSettings((prev) => ({
                      ...prev,
                      offer_prices_include_vat: false,
                    }))
                  }
                />
                <span>Exclusief BTW</span>
              </label>

              <label
                style={{
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                  cursor: isAdmin ? "pointer" : "not-allowed",
                }}
              >
                <input
                  type="checkbox"
                  checked={generalSettings.offer_prices_include_vat === true}
                  disabled={!isAdmin}
                  onChange={() =>
                    setGeneralSettings((prev) => ({
                      ...prev,
                      offer_prices_include_vat: true,
                    }))
                  }
                />
                <span>Inclusief BTW</span>
              </label>

              <div style={{ fontSize: 12, color: "#666", lineHeight: 1.5 }}>
                Bij inclusief BTW worden de bedragen per offerteregel inclusief BTW ingevoerd en getoond.
                De subtotalen en BTW onderaan blijven afzonderlijk zichtbaar.
              </div>

              <button
                style={{
                  marginTop: 10,
                  padding: "10px",
                  background: "#1f4e79",
                  color: "white",
                  border: "none",
                  cursor: isAdmin ? "pointer" : "not-allowed",
                  borderRadius: 6,
                  width: "fit-content",
                  opacity: isAdmin ? 1 : 0.5,
                }}
                disabled={!isAdmin}
                onClick={saveGeneralSettings}
              >
                Opslaan algemene instellingen
              </button>
            </div>
          </>


) : view === "relation_choices" ? (
  <>
    <h3>
      Keuzelijsten Relaties{" "}
      <span style={{ fontSize: 13, color: "#777" }}>{VERSION}</span>
    </h3>

    {relationChoiceFlash && (
      <div
        style={{
          marginBottom: 12,
          padding: "10px 12px",
          background: "#eaf7ea",
          color: "#1f6b1f",
          border: "1px solid #b7dfb7",
          borderRadius: 6,
          maxWidth: 800,
        }}
      >
        {relationChoiceFlash}
      </div>
    )}

    <div
      style={{
        marginBottom: 14,
        padding: 12,
        border: "1px solid #d9e2ec",
        borderRadius: 6,
        background: "#fafafa",
        lineHeight: 1.6,
        width: "100%",
        maxWidth: 900,
        boxSizing: "border-box",
      }}
    >
      Deze keuzelijsten worden centraal per StaffIQ-omgeving gebruikt in Relaties.
      De rubrieken en waarden staan alfabetisch. Een verwijderde waarde verdwijnt
      uit de keuzelijst, maar blijft bij bestaande relaties zichtbaar.
    </div>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobile
          ? "minmax(0, 1fr)"
          : "190px 220px minmax(240px, 1fr)",
        gap: isMobile ? 14 : 12,
        alignItems: "start",
        width: "100%",
        maxWidth: 900,
        minWidth: 0,
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          border: "1px solid #d9e2ec",
          borderRadius: 8,
          padding: 10,
          background: "#fff",
          minWidth: 0,
          boxSizing: "border-box",
        }}
      >
        <div style={{ fontWeight: 700, marginBottom: 8 }}>Rubrieken</div>

        <div style={{ display: "grid", gap: 6 }}>
          {RELATION_CHOICE_CATEGORIES.map((category) => (
            <button
              key={category.key}
              type="button"
              onClick={() => selectRelationChoiceCategory(category.key)}
              style={{
                width: "100%",
                minWidth: 0,
                textAlign: "left",
                padding: "8px 9px",
                border: "1px solid #d9e2ec",
                borderRadius: 6,
                background:
                  selectedRelationChoiceCategory === category.key
                    ? "#e6f0ff"
                    : "#fff",
                cursor: "pointer",
                overflowWrap: "anywhere",
              }}
            >
              {category.label}
            </button>
          ))}
        </div>
      </div>

      <div
        style={{
          border: "1px solid #d9e2ec",
          borderRadius: 8,
          padding: 10,
          background: "#fff",
          minWidth: 0,
          boxSizing: "border-box",
        }}
      >
        <div style={{ fontWeight: 700, marginBottom: 8 }}>
          {relationChoiceCategoryLabel(selectedRelationChoiceCategory)}
        </div>

        <div style={{ display: "grid", gap: 6 }}>
          {visibleRelationChoices().length === 0 ? (
            <div style={{ fontSize: 13, opacity: 0.7 }}>
              Nog geen waarden.
            </div>
          ) : (
            visibleRelationChoices().map((row) => (
              <button
                key={row.id}
                type="button"
                onClick={() =>
                  setSelectedRelationChoice({
                    ...row,
                    active: row.active !== false,
                  })
                }
                style={{
                  width: "100%",
                  minWidth: 0,
                  textAlign: "left",
                  padding: "8px 9px",
                  border: "1px solid #d9e2ec",
                  borderRadius: 6,
                  background:
                    String(selectedRelationChoice?.id || "") ===
                    String(row.id || "")
                      ? "#e6f0ff"
                      : "#fff",
                  cursor: "pointer",
                  overflowWrap: "anywhere",
                }}
              >
                <div style={{ fontWeight: 600 }}>
                  {row.value || "(zonder waarde)"}
                </div>
                <div style={{ fontSize: 12, opacity: 0.7 }}>
                  {row.active === false ? "inactief" : "actief"}
                </div>
              </button>
            ))
          )}
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          minWidth: 0,
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <button
          type="button"
          onClick={newRelationChoice}
          disabled={!isAdmin}
          style={{
            width: "100%",
            padding: "9px 10px",
            background: "#1f4e79",
            color: "white",
            border: "none",
            borderRadius: 6,
            cursor: isAdmin ? "pointer" : "not-allowed",
            opacity: isAdmin ? 1 : 0.5,
          }}
        >
          + Nieuwe waarde
        </button>

        <label>Rubriek</label>
        <input
          value={relationChoiceCategoryLabel(selectedRelationChoiceCategory)}
          readOnly
          style={{
            width: "100%",
            minWidth: 0,
            boxSizing: "border-box",
            background: "#f7f7f7",
          }}
        />

        <label>Waarde</label>
        <input
          value={selectedRelationChoice.value || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setSelectedRelationChoice({
              ...selectedRelationChoice,
              list_key: selectedRelationChoiceCategory,
              value: e.target.value,
            })
          }
          placeholder="Vul een waarde in"
          style={{
            width: "100%",
            minWidth: 0,
            boxSizing: "border-box",
          }}
        />

        <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <input
            type="checkbox"
            checked={selectedRelationChoice.active !== false}
            disabled={!isAdmin}
            onChange={(e) =>
              setSelectedRelationChoice({
                ...selectedRelationChoice,
                active: e.target.checked,
              })
            }
          />
          Actief
        </label>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr 1fr" : "auto auto",
            gap: 10,
            marginTop: 8,
            justifyContent: isMobile ? "stretch" : "start",
          }}
        >
          <button
            type="button"
            onClick={saveRelationChoice}
            disabled={!isAdmin}
            style={{
              padding: "10px",
              background: "#1f4e79",
              color: "white",
              border: "none",
              cursor: isAdmin ? "pointer" : "not-allowed",
              borderRadius: 6,
              opacity: isAdmin ? 1 : 0.5,
            }}
          >
            Opslaan
          </button>

          <button
            type="button"
            onClick={deleteRelationChoice}
            disabled={!isAdmin || !selectedRelationChoice?.id}
            style={{
              padding: "10px",
              background: "#b02a37",
              color: "white",
              border: "none",
              cursor:
                isAdmin && selectedRelationChoice?.id
                  ? "pointer"
                  : "not-allowed",
              borderRadius: 6,
              opacity:
                isAdmin && selectedRelationChoice?.id ? 1 : 0.5,
            }}
          >
            Verwijderen
          </button>
        </div>
      </div>
    </div>
  </>

) : view === "documents" ? (
          <>
<h3>Documentlocatie</h3>

            {flash && (
              <div
                style={{
                  marginBottom: 12,
                  padding: "10px 12px",
                  background: "#eaf7ea",
                  color: "#1f6b1f",
                  border: "1px solid #b7dfb7",
                  borderRadius: 6,
                  maxWidth: 500,
                }}
              >
                {flash}
              </div>
            )}

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                maxWidth: 700,
              }}
            >
              <label>Basispad documenten</label>
              <input
                value={documentLocation}
                onChange={(e) => setDocumentLocation(e.target.value)}
                placeholder="bijvoorbeeld C:/StaffIQ/Documenten"
              />

              <div
                style={{
                  fontSize: 12,
                  opacity: 0.75,
                  lineHeight: 1.6,
                }}
              >
                Nieuwe documenten worden straks opgeslagen onder dit basispad.
                <br />
                Bijvoorbeeld:
                <br />
                <b>{documentLocation || "C:/StaffIQ/Documenten"}</b>
                <br />
                └── Organisaties
                <br />
                └── Algemeen
              </div>

              <button
                style={{
                  marginTop: 10,
                  padding: "10px",
                  background: "#1f4e79",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                  borderRadius: 6,
                  width: "fit-content",
                }}
                onClick={saveDocumentSettings}
              >
                Opslaan documentlocatie
              </button>
            </div>
          </>


) : view === "document_master" ? (
  <>
    <h3>
      Documentsoorten en sets{" "}
      <span style={{ fontSize: 13, color: "#777" }}>{VERSION}</span>
    </h3>

    <div
      style={{
        display: "flex",
        gap: 8,
        marginBottom: 16,
        flexWrap: "wrap",
      }}
    >
      <button
        type="button"
        onClick={() => setDocumentMasterTab("types")}
        style={{
          padding: "9px 12px",
          border: "1px solid #cfd8e3",
          borderRadius: 6,
          background: documentMasterTab === "types" ? "#e6f0ff" : "#fff",
          cursor: "pointer",
          fontWeight: documentMasterTab === "types" ? 700 : 400,
        }}
      >
        Documentsoorten
      </button>

      <button
        type="button"
        onClick={() => setDocumentMasterTab("sets")}
        style={{
          padding: "9px 12px",
          border: "1px solid #cfd8e3",
          borderRadius: 6,
          background: documentMasterTab === "sets" ? "#e6f0ff" : "#fff",
          cursor: "pointer",
          fontWeight: documentMasterTab === "sets" ? 700 : 400,
        }}
      >
        Documentsets / actiepakketten
      </button>
    </div>

    {documentMasterTab === "types" ? (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile
            ? "1fr"
            : "minmax(210px, 260px) minmax(0, 1fr)",
          gap: 14,
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
        }}
      >
        <div>
          <button
            type="button"
            onClick={newDocumentType}
            disabled={!isAdmin}
            style={{
              width: "100%",
              padding: "9px 10px",
              marginBottom: 8,
              background: "#1f4e79",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              cursor: isAdmin ? "pointer" : "not-allowed",
            }}
          >
            Nieuw
          </button>

          <div style={{ border: "1px solid #d9e2ec", borderRadius: 6, overflow: "hidden" }}>
            {(documentTypes || []).map((item) => (
              <div
                key={item.id}
                onClick={() => setSelectedDocumentType({ ...emptyDocumentType, ...item })}
                style={{
                  padding: "9px 10px",
                  cursor: "pointer",
                  borderBottom: "1px solid #eee",
                  background:
                    String(selectedDocumentType?.id || "") === String(item.id)
                      ? "#e6f0ff"
                      : "#fff",
                  opacity: item.active === false ? 0.55 : 1,
                }}
              >
                <b>{item.name}</b>
                <div style={{ fontSize: 12, color: "#667085", marginTop: 2 }}>
                  {item.category} ·{" "}
                  {item.applies_to === "personnel"
                    ? "Personeel"
                    : item.applies_to === "organisation"
                      ? "Relatie"
                      : "Personeel en Relatie"}
                </div>
              </div>
            ))}

            {!documentTypes.length && (
              <div style={{ padding: 12, color: "#667085" }}>
                Nog geen documentsoorten vastgelegd.
              </div>
            )}
          </div>
        </div>

        <div style={{ minWidth: 0, overflow: "hidden" }}>
          {documentTypeFlash && (
            <div style={{ marginBottom: 8, color: "green" }}>
              {documentTypeFlash}
            </div>
          )}

          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile
                ? "1fr"
                : "minmax(150px, 180px) minmax(0, 1fr)",
              gap: "10px 10px",
              alignItems: "center",
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
            }}
          >
            <label>Naam</label>
            <input
              style={{ width: "100%", boxSizing: "border-box", minWidth: 0 }}
              value={selectedDocumentType.name || ""}
              disabled={!isAdmin}
              onChange={(e) =>
                setSelectedDocumentType((prev) => ({ ...prev, name: e.target.value }))
              }
            />

            <label>Categorie</label>
            <div style={{ minWidth: 0 }}>
              <input
                list="document-category-list"
                style={{ width: "100%", boxSizing: "border-box", minWidth: 0 }}
                value={selectedDocumentType.category ?? ""}
                disabled={!isAdmin}
                onChange={(e) => {
                  const category = e.target.value;
                  setSelectedDocumentType((prev) => ({
                    ...prev,
                    category,
                  }));
                }}
              />
              <datalist id="document-category-list">
                {DOCUMENT_CATEGORIES.map((category) => (
                  <option key={category} value={category} />
                ))}
              </datalist>
            </div>

            <label>Van toepassing op</label>
            <select
              style={{ width: "100%", boxSizing: "border-box", minWidth: 0 }}
              value={selectedDocumentType.applies_to || "both"}
              disabled={!isAdmin}
              onChange={(e) =>
                setSelectedDocumentType((prev) => ({ ...prev, applies_to: e.target.value }))
              }
            >
              <option value="personnel">Personeel</option>
              <option value="organisation">Relatie</option>
              <option value="request">Aanvraag</option>
              <option value="vacancy">Vacature</option>
              <option value="placement">Plaatsing</option>
              <option value="project">Project</option>
              <option value="offer">Offerte</option>
              <option value="order">Opdracht</option>
              <option value="work_order">Werkbon / Oplevering</option>
              <option value="invoice">Factuur</option>
              <option value="both">Personeel en Relatie</option>
            </select>

            <label>Documentnummer gebruiken</label>
            <input
              type="checkbox"
              checked={selectedDocumentType.use_document_number === true}
              disabled={!isAdmin}
              onChange={(e) =>
                setSelectedDocumentType((prev) => ({
                  ...prev,
                  use_document_number: e.target.checked,
                }))
              }
            />

            <label>Geldig vanaf gebruiken</label>
            <input
              type="checkbox"
              checked={selectedDocumentType.use_valid_from === true}
              disabled={!isAdmin}
              onChange={(e) =>
                setSelectedDocumentType((prev) => ({
                  ...prev,
                  use_valid_from: e.target.checked,
                }))
              }
            />

            <label>Geldig t/m gebruiken</label>
            <input
              type="checkbox"
              checked={selectedDocumentType.use_valid_until === true}
              disabled={!isAdmin}
              onChange={(e) =>
                setSelectedDocumentType((prev) => ({
                  ...prev,
                  use_valid_until: e.target.checked,
                }))
              }
            />

            <label>Geldigheid bewaken</label>
            <input
              type="checkbox"
              checked={selectedDocumentType.monitor_validity === true}
              disabled={!isAdmin}
              onChange={(e) =>
                setSelectedDocumentType((prev) => ({
                  ...prev,
                  monitor_validity: e.target.checked,
                  use_valid_until: e.target.checked
                    ? true
                    : prev.use_valid_until,
                }))
              }
            />

            <label>Standaard geldigheid (maanden)</label>
            <input
              style={{ width: "100%", boxSizing: "border-box", minWidth: 0 }}
              type="number"
              min="0"
              value={selectedDocumentType.default_validity_months ?? ""}
              disabled={!isAdmin}
              placeholder="leeg = geen standaard"
              onChange={(e) =>
                setSelectedDocumentType((prev) => ({
                  ...prev,
                  default_validity_months: e.target.value,
                }))
              }
            />

            <label>Sortering</label>
            <input
              style={{ width: "100%", boxSizing: "border-box", minWidth: 0 }}
              type="number"
              min="0"
              value={selectedDocumentType.sort_order ?? 0}
              disabled={!isAdmin}
              onChange={(e) =>
                setSelectedDocumentType((prev) => ({
                  ...prev,
                  sort_order: Number(e.target.value || 0),
                }))
              }
            />

            <label>Actief</label>
            <input
              type="checkbox"
              checked={selectedDocumentType.active !== false}
              disabled={!isAdmin}
              onChange={(e) =>
                setSelectedDocumentType((prev) => ({ ...prev, active: e.target.checked }))
              }
            />
          </div>

          <div style={{ display: "flex", gap: 8, marginTop: 18 }}>
            <button
              type="button"
              onClick={saveDocumentType}
              disabled={!isAdmin}
              style={{
                padding: "10px 14px",
                background: "#1f4e79",
                color: "white",
                border: "none",
                borderRadius: 6,
                cursor: isAdmin ? "pointer" : "not-allowed",
              }}
            >
              Opslaan
            </button>

            <button
              type="button"
              onClick={deleteDocumentType}
              disabled={!isAdmin || !selectedDocumentType?.id}
              style={{
                padding: "10px 14px",
                background: "#b02a37",
                color: "white",
                border: "none",
                borderRadius: 6,
                cursor:
                  isAdmin && selectedDocumentType?.id
                    ? "pointer"
                    : "not-allowed",
                opacity: isAdmin && selectedDocumentType?.id ? 1 : 0.5,
              }}
            >
              Verwijderen
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile
            ? "1fr"
            : "minmax(210px, 260px) minmax(0, 1fr)",
          gap: 14,
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
        }}
      >
        <div>
          <button
            type="button"
            onClick={newDocumentSet}
            disabled={!isAdmin}
            style={{
              width: "100%",
              padding: "9px 10px",
              marginBottom: 8,
              background: "#1f4e79",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              cursor: isAdmin ? "pointer" : "not-allowed",
            }}
          >
            Nieuw
          </button>

          <div style={{ border: "1px solid #d9e2ec", borderRadius: 6, overflow: "hidden" }}>
            {(documentSets || []).map((item) => (
              <div
                key={item.id}
                onClick={() =>
                  setSelectedDocumentSet({
                    ...emptyDocumentSet,
                    ...item,
                    items: item.items || [],
                  })
                }
                style={{
                  padding: "9px 10px",
                  cursor: "pointer",
                  borderBottom: "1px solid #eee",
                  background:
                    String(selectedDocumentSet?.id || "") === String(item.id)
                      ? "#e6f0ff"
                      : "#fff",
                  opacity: item.active === false ? 0.55 : 1,
                }}
              >
                <b>{item.name}</b>
                <div style={{ fontSize: 12, color: "#667085", marginTop: 2 }}>
                  {(item.items || []).length} {(item.items || []).length === 1 ? "onderdeel" : "onderdelen"}
                </div>
              </div>
            ))}

            {!documentSets.length && (
              <div style={{ padding: 12, color: "#667085" }}>
                Nog geen documentsets vastgelegd.
              </div>
            )}
          </div>
        </div>

        <div>
          {documentSetFlash && (
            <div style={{ marginBottom: 8, color: "green" }}>
              {documentSetFlash}
            </div>
          )}

          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "190px minmax(0, 1fr)",
              gap: "10px 12px",
              alignItems: "center",
              maxWidth: 760,
            }}
          >
            <label>Naam set</label>
            <input
              id="staffiq-document-set-name"
              value={selectedDocumentSet.name || ""}
              disabled={!isAdmin}
              placeholder="bijvoorbeeld Aanstelling nieuwe medewerker"
              onChange={(e) =>
                setSelectedDocumentSet((prev) => ({ ...prev, name: e.target.value }))
              }
            />

            <label>Van toepassing op</label>
            <select
              value={selectedDocumentSet.source_type || "personnel"}
              disabled={!isAdmin}
              onChange={(e) =>
                setSelectedDocumentSet((prev) => ({ ...prev, source_type: e.target.value }))
              }
            >
              <option value="personnel">Personeel</option>
              <option value="organisation">Relatie</option>
              <option value="placement">Plaatsing</option>
              <option value="project">Project</option>
              <option value="offer">Offerte</option>
              <option value="order">Opdracht</option>
              <option value="work_order">Werkbon / Oplevering</option>
              <option value="invoice">Factuur</option>
              <option value="both">Personeel en Relatie</option>
            </select>

            <label>Omschrijving</label>
            <textarea
              rows={3}
              value={selectedDocumentSet.description || ""}
              disabled={!isAdmin}
              onChange={(e) =>
                setSelectedDocumentSet((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
            />

            <label>Actief</label>
            <input
              type="checkbox"
              checked={selectedDocumentSet.active !== false}
              disabled={!isAdmin}
              onChange={(e) =>
                setSelectedDocumentSet((prev) => ({ ...prev, active: e.target.checked }))
              }
            />
          </div>

          <hr style={{ margin: "20px 0 14px" }} />

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10 }}>
            <h4 style={{ margin: 0 }}>Onderdelen van de set</h4>
            <button
              type="button"
              onClick={addDocumentSetItem}
              disabled={!isAdmin || !documentTypes.some((x) => x.active !== false)}
              style={{
                padding: "8px 10px",
                background: "#1f4e79",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                cursor: isAdmin ? "pointer" : "not-allowed",
              }}
            >
              + Document toevoegen
            </button>
          </div>

          <div style={{ marginTop: 10 }}>
            {(selectedDocumentSet.items || []).map((item, index) => (
              <div
                key={`${item.id || "new"}-${index}`}
                data-document-set-item="true"
                style={{
                  border: "1px solid #d9e2ec",
                  borderRadius: 7,
                  padding: 12,
                  marginBottom: 10,
                  background: "#fff",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: isMobile
                      ? "1fr"
                      : "160px minmax(0, 1fr)",
                    gap: "8px 10px",
                    alignItems: "center",
                  }}
                >
                  <label>Documentsoort</label>
                  <select
                    value={item.document_type_id || ""}
                    disabled={!isAdmin}
                    onChange={(e) => {
                      const documentTypeId = Number(e.target.value || 0);
                      const dt = documentTypes.find(
                        (x) => Number(x.id) === documentTypeId
                      );

                      updateDocumentSetItem(index, {
                        document_type_id: documentTypeId || "",
                        title: dt?.name || item.title || "",
                      });
                    }}
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      minWidth: 0,
                    }}
                  >
                    <option value="">Kies documentsoort</option>
                    {(documentTypes || [])
                      .filter((x) => x.active !== false)
                      .map((dt) => (
                        <option key={dt.id} value={dt.id}>
                          {dt.name}
                        </option>
                      ))}
                  </select>

                  <label>Document zoeken bij</label>
                  <select
                    value={item.lookup_scope || ""}
                    disabled={!isAdmin}
                    onChange={(e) =>
                      updateDocumentSetItem(index, {
                        lookup_scope: e.target.value,
                      })
                    }
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      minWidth: 0,
                    }}
                  >
                    <option value="">Kies dossier</option>
                    <option value="current">Huidig dossier</option>
                    {selectedDocumentSet.source_type === "placement" ? (
                      <option value="personnel">Personeelsdossier</option>
                    ) : null}
                  </select>

                  <label>Verplicht</label>
                  <input
                    type="checkbox"
                    checked={item.required !== false}
                    disabled={!isAdmin}
                    onChange={(e) =>
                      updateDocumentSetItem(index, {
                        required: e.target.checked,
                      })
                    }
                  />

                  <label>Retour document</label>
                  <input
                    type="checkbox"
                    checked={item.document_required !== false}
                    disabled={!isAdmin}
                    onChange={(e) =>
                      updateDocumentSetItem(index, {
                        document_required: e.target.checked,
                      })
                    }
                  />

                  <label>Ondertekening</label>
                  <input
                    type="checkbox"
                    checked={item.signature_required === true}
                    disabled={!isAdmin}
                    onChange={(e) =>
                      updateDocumentSetItem(index, {
                        signature_required: e.target.checked,
                      })
                    }
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 10,
                  }}
                >
                  <button
                    type="button"
                    onClick={() => removeDocumentSetItem(index)}
                    disabled={!isAdmin}
                    style={{
                      padding: "7px 10px",
                      background: "#b02a37",
                      color: "#fff",
                      border: "none",
                      borderRadius: 5,
                      cursor: isAdmin ? "pointer" : "not-allowed",
                    }}
                  >
                    Verwijder
                  </button>
                </div>
              </div>
            ))}

            {!selectedDocumentSet.items?.length && (
              <div
                style={{
                  padding: 12,
                  color: "#667085",
                  border: "1px solid #d9e2ec",
                  borderRadius: 7,
                }}
              >
                Nog geen documenten in deze set.
              </div>
            )}
          </div>

          <div
            style={{
              marginTop: 12,
              padding: 12,
              background: "#f7fbff",
              border: "1px solid #cfdbe6",
              borderRadius: 6,
              fontSize: 12,
              lineHeight: 1.55,
              maxWidth: 820,
            }}
          >
            <b>Werking straks:</b> de set wordt één hoofdactie in het Actiecentrum.
            De onderdelen worden als checklist bewaakt. Een verplicht onderdeel kan
            pas gereed zijn zodra het benodigde document is terugontvangen en,
            indien aangevinkt, is ondertekend.
          </div>

          <div style={{ display: "flex", gap: 8, marginTop: 18 }}>
            <button
              type="button"
              onClick={saveDocumentSet}
              disabled={!isAdmin}
              style={{
                padding: "10px 14px",
                background: "#1f4e79",
                color: "white",
                border: "none",
                borderRadius: 6,
                cursor: isAdmin ? "pointer" : "not-allowed",
              }}
            >
              Opslaan
            </button>

            <button
              type="button"
              onClick={deleteDocumentSet}
              disabled={!isAdmin || !selectedDocumentSet?.id}
              style={{
                padding: "10px 14px",
                background: "#b02a37",
                color: "white",
                border: "none",
                borderRadius: 6,
                cursor:
                  isAdmin && selectedDocumentSet?.id
                    ? "pointer"
                    : "not-allowed",
                opacity: isAdmin && selectedDocumentSet?.id ? 1 : 0.5,
              }}
            >
              Verwijderen
            </button>
          </div>
        </div>
      </div>
    )}
  </>

) : view === "communication" ? (
  <>
    <h3>
      Communicatiekanalen{" "}
      <span style={{ fontSize: 13, color: "#777" }}>{VERSION}</span>
    </h3>

    {communicationFlash && (
      <div
        style={{
          marginBottom: 12,
          padding: "10px 12px",
          background: "#eaf7ea",
          color: "#1f6b1f",
          border: "1px solid #b7dfb7",
          borderRadius: 6,
          maxWidth: 980,
        }}
      >
        {communicationFlash}
      </div>
    )}

    <div
      style={{
        marginBottom: 16,
        padding: 14,
        border: "1px solid #d9e2ec",
        borderRadius: 8,
        background: "#f7fbff",
        lineHeight: 1.6,
        maxWidth: 980,
        boxSizing: "border-box",
      }}
    >
      Hier bepaal je welke communicatiekanalen binnen StaffIQ beschikbaar zijn.
      De inhoudelijke e-mail- en WhatsApp-teksten worden per onderdeel beheerd
      bij CRM, MKB en HRM.
    </div>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobile
          ? "1fr"
          : "repeat(2, minmax(320px, 480px))",
        gap: 18,
        maxWidth: 980,
        alignItems: "start",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 12,
          padding: 16,
          border: "1px solid #d9e2ec",
          borderRadius: 8,
          background: "#fafafa",
          boxSizing: "border-box",
        }}
      >
        <h4 style={{ margin: "0 0 2px 0" }}>Beschikbare kanalen</h4>
        <div style={{ fontSize: 12, color: "#5d6b78", lineHeight: 1.5 }}>
          Alleen geactiveerde kanalen worden aangeboden vanuit de programma&apos;s.
        </div>

        <label style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <input
            type="checkbox"
            checked={communicationSettings.email_enabled === true}
            disabled={!isAdmin}
            onChange={(e) =>
              setCommunicationSettings((prev) => ({
                ...prev,
                email_enabled: e.target.checked,
              }))
            }
          />
          <span>E-mail actief</span>
        </label>

        <label style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <input
            type="checkbox"
            checked={communicationSettings.whatsapp_enabled === true}
            disabled={!isAdmin}
            onChange={(e) =>
              setCommunicationSettings((prev) => ({
                ...prev,
                whatsapp_enabled: e.target.checked,
              }))
            }
          />
          <span>WhatsApp actief</span>
        </label>

        <label style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <input
            type="checkbox"
            checked={communicationSettings.sms_enabled === true}
            disabled={!isAdmin}
            onChange={(e) =>
              setCommunicationSettings((prev) => ({
                ...prev,
                sms_enabled: e.target.checked,
              }))
            }
          />
          <span>SMS actief via Bird / MessageBird</span>
        </label>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          padding: 16,
          border: "1px solid #d9e2ec",
          borderRadius: 8,
          background: "#fafafa",
          boxSizing: "border-box",
        }}
      >
        <h4 style={{ margin: "0 0 2px 0" }}>Telefoonnummers</h4>

        <label>Standaard landcode</label>
        <input
          value={communicationSettings.default_country_code || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setCommunicationSettings((prev) => ({
              ...prev,
              default_country_code: e.target.value,
            }))
          }
          placeholder="+31"
        />

        <div style={{ fontSize: 12, color: "#5d6b78", lineHeight: 1.5 }}>
          Een Nederlands nummer zoals 0612345678 wordt automatisch omgezet naar
          +31612345678.
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          padding: 16,
          border: "1px solid #d9e2ec",
          borderRadius: 8,
          background: "#fafafa",
          boxSizing: "border-box",
        }}
      >
        <h4 style={{ margin: "0 0 2px 0" }}>SMS via Bird / MessageBird</h4>
        <div style={{ fontSize: 12, color: "#5d6b78", lineHeight: 1.5 }}>
          Deze technische gegevens zijn alleen nodig wanneer SMS is geactiveerd.
        </div>

        <label>Bird API key</label>
        <input
          type="password"
          value={communicationSettings.messagebird_api_key || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setCommunicationSettings((prev) => ({
              ...prev,
              messagebird_api_key: e.target.value,
            }))
          }
          placeholder="Access key van Bird / MessageBird"
        />

        <label>Bird Workspace ID</label>
        <input
          value={communicationSettings.bird_workspace_id || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setCommunicationSettings((prev) => ({
              ...prev,
              bird_workspace_id: e.target.value,
            }))
          }
          placeholder="Bijv. b182ef56-39ac-42f2-84db-d3d6216a0ad2"
        />

        <label>Bird SMS Channel ID</label>
        <input
          value={communicationSettings.bird_sms_channel_id || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setCommunicationSettings((prev) => ({
              ...prev,
              bird_sms_channel_id: e.target.value,
            }))
          }
          placeholder="Channel ID van het SMS-kanaal"
        />

        <label>Afzender / herkenbaar label</label>
        <input
          value={communicationSettings.messagebird_originator || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setCommunicationSettings((prev) => ({
              ...prev,
              messagebird_originator: e.target.value,
            }))
          }
          placeholder="Optioneel, bijv. StaffIQ"
        />

        <label>Standaard SMS-tekst</label>
        <textarea
          value={communicationSettings.default_sms_text || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setCommunicationSettings((prev) => ({
              ...prev,
              default_sms_text: e.target.value,
            }))
          }
          rows={5}
          style={{ resize: "vertical" }}
          placeholder="Bijv. Beste relatie, hierbij een bericht van StaffIQ."
        />
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          padding: 16,
          border: "1px solid #d9e2ec",
          borderRadius: 8,
          background: "#fafafa",
          boxSizing: "border-box",
        }}
      >
        <h4 style={{ margin: "0 0 2px 0" }}>Algemene WhatsApp-tekst</h4>
        <div style={{ fontSize: 12, color: "#5d6b78", lineHeight: 1.5 }}>
          Deze tekst blijft beschikbaar als algemene terugvaltekst. De specifieke
          CRM-, MKB- en HRM-teksten beheer je bij de betreffende onderdelen.
        </div>

        <label>Standaard WhatsApp-tekst</label>
        <textarea
          value={communicationSettings.default_whatsapp_text || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setCommunicationSettings((prev) => ({
              ...prev,
              default_whatsapp_text: e.target.value,
            }))
          }
          rows={8}
          style={{ resize: "vertical" }}
          placeholder="Bijv. Beste relatie, hierbij een bericht van StaffIQ."
        />
      </div>
    </div>

    <button
      type="button"
      style={{
        marginTop: 16,
        padding: "10px 16px",
        background: "#1f4e79",
        color: "white",
        border: "none",
        cursor: isAdmin ? "pointer" : "not-allowed",
        borderRadius: 6,
        width: "fit-content",
        opacity: isAdmin ? 1 : 0.5,
      }}
      disabled={!isAdmin}
      onClick={saveCommunicationSettings}
    >
      Opslaan communicatiekanalen
    </button>

    <div style={{ marginTop: 24, maxWidth: 980, padding: 16, border: "1px solid #d9e2ec", borderRadius: 8, background: "#fafafa" }}>
      <h4 style={{ margin: "0 0 6px" }}>E-mailafzender voor deze StaffIQ-klant</h4>
      <div style={{ fontSize: 13, color: "#526274", marginBottom: 12, lineHeight: 1.5 }}>
        Kies per klantomgeving tussen de bestaande centrale SMTP, eigen SMTP en Microsoft Graph (Microsoft 365).
        De keuze geldt voor offertes, opdrachten, facturen, akkoordverzoeken en de andere StaffIQ-mailfuncties.
        Microsoft Graph werkt met een servercertificaat en vraagt geen mailboxwachtwoord.
      </div>
      {emailSenderLoading ? <div>Instellingen laden...</div> : null}
      {emailSenderFlash ? <div role="status" style={{ marginBottom: 12, padding: 10, background: "#eef5ff", borderRadius: 5 }}>{emailSenderFlash}</div> : null}
      <label style={{ display: "flex", flexDirection: "column", gap: 5, marginBottom: 14, maxWidth: 430, fontSize: 13 }}>
        <b>Verzendmethode voor deze klant</b>
        <select disabled={!isAdmin || emailSenderLoading}
          value={emailSenderSettings.email_method || (emailSenderSettings.use_custom_smtp ? "smtp" : "central")}
          onChange={(e) => setEmailSenderSettings((prev) => ({
            ...prev, email_method: e.target.value, use_custom_smtp: e.target.value === "smtp",
          }))}
          style={{ background: "white", border: "1px solid #cbd5e1", borderRadius: 5, padding: "9px 10px" }}>
          <option value="central">Centrale StaffIQ-mailserver (SMTP)</option>
          <option value="smtp">Eigen SMTP-mailserver</option>
          <option value="graph">Microsoft 365 / Graph met certificaat</option>
        </select>
      </label>
      {emailSenderSettings.email_method === "graph" ? (
        <div style={{ marginBottom: 14, border: "1px solid #d5e1ed", padding: 12, borderRadius: 6 }}>
          <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 10 }}>Microsoft 365-koppeling (Graph)</div>
          <div style={{ fontSize: 12, marginBottom: 10 }}>
            Certificaat op deze server: <b>{emailSenderSettings.graph_certificate_ready ? "Beschikbaar" : "Nog niet beschikbaar of leesbaar"}</b>.
            De privésleutel wordt alleen op de server beheerd en nooit via dit scherm ingevoerd.
          </div>
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(2, minmax(240px, 1fr))", gap: 12 }}>
            {[
              ["from_name", "Naam afzender", "Bijv. StaffIQ"],
              ["from_email", "E-mailadres afzender", "Bijv. info@staffiq.nl"],
              ["reply_to", "Antwoordadres (optioneel)", "Bijv. info@staffiq.nl"],
              ["graph_mailbox", "Microsoft 365-mailbox", "Bijv. info@staffiq.nl"],
              ["graph_tenant_id", "Microsoft Tenant ID", "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"],
              ["graph_client_id", "Microsoft Client ID", "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"],
            ].map(([key, label, placeholder]) => (
              <label key={key} style={{ display: "flex", flexDirection: "column", gap: 5, fontSize: 13 }}>
                {label}
                <input disabled={!isAdmin} value={emailSenderSettings[key] || ""} placeholder={placeholder}
                  autoComplete="off" onChange={(e) => setEmailSenderSettings((prev) => ({ ...prev, [key]: e.target.value }))}
                  style={{ background: "white", border: "1px solid #cbd5e1", borderRadius: 5, padding: "9px 10px" }} />
              </label>
            ))}
          </div>
          <div style={{ fontSize: 12, marginTop: 10, color: "#526274" }}>
            Afzenderadres en Microsoft 365-mailbox moeten gelijk zijn. Zonder leesbaar certificaat kan Graph niet worden ingeschakeld.
            Als Graph faalt, verzendt StaffIQ niet stilzwijgend via de centrale mailserver.
          </div>
        </div>
      ) : null}
      {emailSenderSettings.email_method === "smtp" ? (
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(2, minmax(240px, 1fr))", gap: 12 }}>
        {[
          ["from_name", "Naam afzender", "Bijv. StaffIQ"],
          ["from_email", "E-mailadres afzender", "Bijv. info@staffiq.nl"],
          ["reply_to", "Antwoordadres (optioneel)", "Bijv. info@staffiq.nl"],
          ["smtp_host", "SMTP-server", "Bijv. smtp.provider.nl"],
          ["smtp_user", "SMTP-gebruikersnaam", "Bijv. info@staffiq.nl"],
        ].map(([key, label, placeholder]) => (
          <label key={key} style={{ display: "flex", flexDirection: "column", gap: 5, fontSize: 13 }}>
            {label}
            <input disabled={!isAdmin || !emailSenderSettings.use_custom_smtp} value={emailSenderSettings[key] || ""} placeholder={placeholder}
              autoComplete="off" onChange={(e) => setEmailSenderSettings((prev) => ({ ...prev, [key]: e.target.value }))}
              style={{ background: "white", border: "1px solid #cbd5e1", borderRadius: 5, padding: "9px 10px" }} />
          </label>
        ))}
        <label style={{ display: "flex", flexDirection: "column", gap: 5, fontSize: 13 }}>
          SMTP-poort
          <input type="number" min="1" max="65535" disabled={!isAdmin || !emailSenderSettings.use_custom_smtp}
            value={emailSenderSettings.smtp_port || 587}
            onChange={(e) => setEmailSenderSettings((prev) => ({ ...prev, smtp_port: Number(e.target.value) }))}
            style={{ background: "white", border: "1px solid #cbd5e1", borderRadius: 5, padding: "9px 10px" }} />
        </label>
        <label style={{ display: "flex", flexDirection: "column", gap: 5, fontSize: 13 }}>
          SMTP-wachtwoord {emailSenderSettings.has_password ? "(opgeslagen; leeg laten om te behouden)" : ""}
          <input type="password" disabled={!isAdmin || !emailSenderSettings.use_custom_smtp} value={emailSenderPassword}
            autoComplete="new-password" placeholder={emailSenderSettings.has_password ? "Wachtwoord blijft bewaard" : "SMTP-wachtwoord"}
            onChange={(e) => setEmailSenderPassword(e.target.value)}
            style={{ background: "white", border: "1px solid #cbd5e1", borderRadius: 5, padding: "9px 10px" }} />
        </label>
        <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13 }}>
          <input type="checkbox" disabled={!isAdmin || !emailSenderSettings.use_custom_smtp}
            checked={emailSenderSettings.smtp_secure === true}
            onChange={(e) => setEmailSenderSettings((prev) => ({ ...prev, smtp_secure: e.target.checked }))} />
          SSL/TLS directe verbinding (meestal poort 465). Bij poort 587 uit laten voor STARTTLS.
        </label>
      </div>
      ) : null}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 16, alignItems: "center" }}>
        <button type="button" disabled={!isAdmin || emailSenderSaving || emailSenderLoading}
          onClick={saveEmailSenderSettings}
          style={{ background: "#1f4e79", color: "white", padding: "9px 14px", borderRadius: 6, border: 0 }}>
          {emailSenderSaving ? "Opslaan..." : "Opslaan e-mailafzender"}
        </button>
        <input type="email" disabled={!isAdmin} placeholder="Testmail naar e-mailadres" value={emailSenderTestTo}
          onChange={(e) => setEmailSenderTestTo(e.target.value)}
          style={{ border: "1px solid #cbd5e1", background: "white", borderRadius: 5, padding: "9px 10px", minWidth: 230 }} />
        <button type="button" disabled={!isAdmin || emailSenderTesting || emailSenderSaving}
          onClick={testEmailSender} style={{ padding: "9px 14px", borderRadius: 6, border: "1px solid #cbd5e1", background: "white" }}>
          {emailSenderTesting ? "Versturen..." : "Testmail versturen"}
        </button>
      </div>
      <div style={{ fontSize: 12, color: "#657182", marginTop: 9 }}>
        Sla eerst op en verstuur daarna een testmail. Bij Graph betekent HTTP 202 uitsluitend dat Microsoft het verzoek heeft geaccepteerd; controleer de ontvangst.
        Grote PDF-bijlagen kunnen extra Microsoft-rechten vereisen.
      </div>
    </div>
  </>

) : view === "crm_messages" ? (
  <>
    <h3>CRM - Correspondentie en Notities/Taken <span style={{ fontSize: 13, color: "#777" }}>{VERSION}</span></h3>
    {renderSettingsCompanyCodeSelector("crm_messages")}

    {crmMessageSettingsLoading && <div style={{ marginBottom: 12 }}>Laden...</div>}
    {crmMessageFlash && (
      <div style={{ marginBottom: 12, padding: "10px 12px", background: "#eaf7ea", color: "#1f6b1f", border: "1px solid #b7dfb7", borderRadius: 6, maxWidth: 900 }}>
        {crmMessageFlash}
      </div>
    )}

    <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(2, minmax(320px, 460px))", gap: 18, maxWidth: 1020 }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 8, padding: 14, border: "1px solid #d9e2ec", borderRadius: 8, background: "#fafafa" }}>
        <h4 style={{ margin: "0 0 4px 0" }}>CRM Correspondentie</h4>
        <div style={{ fontSize: 12, color: "#5d6b78", lineHeight: 1.5, marginBottom: 4 }}>
          Voor Relaties en Contactpersonen. StaffIQ vult aanhef, geadresseerde, bedrijfsgegevens en verzender automatisch in.
        </div>

        <div style={{ fontSize: 12, color: "#5d6b78", lineHeight: 1.5 }}>
          StaffIQ vult de aanhef, geadresseerde, bedrijfsgegevens en verzender automatisch in.
        </div>
        <label>E-mail - Onderwerp</label>
        <input
          value={crmMessageSettings.email_subject || ""}
          disabled={!isAdmin}
          onChange={(e) => setCrmMessageSettings((p) => ({ ...p, email_subject: e.target.value }))}
        />

        <label>E-mail - Bericht</label>
        <textarea
          rows={9}
          value={crmMessageSettings.email_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setCrmMessageSettings((p) => ({ ...p, email_text: e.target.value }))}
          style={{ resize: "vertical" }}
        />

        <div style={{ fontSize: 12, color: "#5d6b78", lineHeight: 1.5, marginTop: 4 }}>
          Het bericht wordt voorbereid met de juiste contactpersoon en afzender.
        </div>
        <label>WhatsApp - Bericht</label>
        <textarea
          rows={8}
          value={crmMessageSettings.whatsapp_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setCrmMessageSettings((p) => ({ ...p, whatsapp_text: e.target.value }))}
          style={{ resize: "vertical" }}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8, padding: 14, border: "1px solid #d9e2ec", borderRadius: 8, background: "#fafafa" }}>
        <h4 style={{ margin: "0 0 4px 0" }}>Notities / Taken</h4>
        <div style={{ fontSize: 12, color: "#5d6b78", lineHeight: 1.5, marginBottom: 4 }}>
          StaffIQ vult de taakgegevens en namen van uitvoerder en aanmaker automatisch in.
        </div>

        <label>Nieuwe taak toegewezen - Onderwerp</label>
        <input
          value={crmMessageSettings.task_assigned_subject || ""}
          disabled={!isAdmin}
          onChange={(e) => setCrmMessageSettings((p) => ({ ...p, task_assigned_subject: e.target.value }))}
        />
        <label>Nieuwe taak toegewezen - Bericht</label>
        <textarea
          rows={8}
          value={crmMessageSettings.task_assigned_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setCrmMessageSettings((p) => ({ ...p, task_assigned_text: e.target.value }))}
          style={{ resize: "vertical" }}
        />

        <label>Herinnering openstaande taak - Onderwerp</label>
        <input
          value={crmMessageSettings.task_reminder_subject || ""}
          disabled={!isAdmin}
          onChange={(e) => setCrmMessageSettings((p) => ({ ...p, task_reminder_subject: e.target.value }))}
        />
        <label>Herinnering openstaande taak - Bericht</label>
        <textarea
          rows={8}
          value={crmMessageSettings.task_reminder_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setCrmMessageSettings((p) => ({ ...p, task_reminder_text: e.target.value }))}
          style={{ resize: "vertical" }}
        />

        <label>Taak afgerond - Onderwerp</label>
        <input
          value={crmMessageSettings.task_completed_subject || ""}
          disabled={!isAdmin}
          onChange={(e) => setCrmMessageSettings((p) => ({ ...p, task_completed_subject: e.target.value }))}
        />
        <label>Taak afgerond - Bericht</label>
        <textarea
          rows={8}
          value={crmMessageSettings.task_completed_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setCrmMessageSettings((p) => ({ ...p, task_completed_text: e.target.value }))}
          style={{ resize: "vertical" }}
        />
      </div>
    </div>

    <div style={{ maxWidth: 1020 }}>
      {renderVariableInfo([
        { title: "Correspondentie", variables: ["{bedrijfsnaam}", "{contactpersoon}", "{relatie}", "{bericht}", "{bedrijfscode}"] },
        { title: "Taken", variables: ["{uitvoerder}", "{aanmaker}", "{ontvanger}", "{personeel}", "{taak_titel}", "{taak_tekst}", "{vervaldatum}", "{vervaltijd}"] },
        { title: "Afzender", variables: ["{verzender_naam}"] },
      ])}
    </div>

    <button
      type="button"
      disabled={!isAdmin}
      onClick={saveCrmMessageSettings}
      style={{ marginTop: 14, padding: "10px 16px", background: "#1f4e79", color: "white", border: "none", borderRadius: 6, cursor: isAdmin ? "pointer" : "not-allowed", opacity: isAdmin ? 1 : 0.5 }}
    >
      Opslaan CRM-teksten
    </button>
  </>
) : view === "mkb_work_orders" ? (
  <>
    <h3>MKB - Werkbonnen <span style={{ fontSize: 13, color: "#777" }}>{VERSION}</span></h3>
    {renderSettingsCompanyCodeSelector("mkb_work_orders")}
    {renderMkbLetterheadSettings("mkb_work_orders")}

    {mkbWorkOrderSettingsLoading && <div style={{ marginBottom: 12 }}>Laden...</div>}
    {mkbWorkOrderFlash && (
      <div style={{ marginBottom: 12, padding: "10px 12px", background: "#eaf7ea", color: "#1f6b1f", border: "1px solid #b7dfb7", borderRadius: 6, maxWidth: 900 }}>
        {mkbWorkOrderFlash}
      </div>
    )}

    <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(2, minmax(300px, 440px))", gap: 18, maxWidth: 980 }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <h4 style={{ marginBottom: 2 }}>Bedrijfs- en documentgegevens</h4>
        <label>Documenttitel</label>
        <input value={mkbWorkOrderSettings.document_title || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, document_title: e.target.value }))} />
        <label>Bedrijfsnaam</label>
        <input value={mkbWorkOrderSettings.company_name || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, company_name: e.target.value }))} />
        <label>Adresregel 1</label>
        <input value={mkbWorkOrderSettings.company_address_1 || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, company_address_1: e.target.value }))} />
        <label>Adresregel 2</label>
        <input value={mkbWorkOrderSettings.company_address_2 || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, company_address_2: e.target.value }))} />
        <label>Postcode</label>
        <input value={mkbWorkOrderSettings.company_postcode || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, company_postcode: e.target.value }))} />
        <label>Plaats</label>
        <input value={mkbWorkOrderSettings.company_city || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, company_city: e.target.value }))} />
        <label>Land</label>
        <input value={mkbWorkOrderSettings.company_country || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, company_country: e.target.value }))} />
        <label>E-mail</label>
        <input value={mkbWorkOrderSettings.company_email || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, company_email: e.target.value }))} />
        <label>Website</label>
        <input value={mkbWorkOrderSettings.company_website || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, company_website: e.target.value }))} />
        <label>Telefoon</label>
        <input value={mkbWorkOrderSettings.company_phone || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, company_phone: e.target.value }))} />
        <label>KvK</label>
        <input value={mkbWorkOrderSettings.company_kvk || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, company_kvk: e.target.value }))} />
        <label>BTW-nummer</label>
        <input value={mkbWorkOrderSettings.company_vat || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, company_vat: e.target.value }))} />
        <label>IBAN</label>
        <input value={mkbWorkOrderSettings.company_iban || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, company_iban: e.target.value }))} />
        <label>G-rekening</label>
        <input value={mkbWorkOrderSettings.company_g_iban || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, company_g_iban: e.target.value }))} />
        <label>Logo upload</label>
        <input type="file" accept="image/*" disabled={!isAdmin} onChange={handleMkbWorkOrderLogoUpload} />
        {mkbWorkOrderSettings.logo_url ? (
          <>
            <img src={mkbWorkOrderSettings.logo_url} alt="Logo werkbon" style={{ maxWidth: 220, maxHeight: 100, objectFit: "contain", border: "1px solid #ddd", padding: 6 }} />
            <button type="button" disabled={!isAdmin} onClick={() => setMkbWorkOrderSettings((p) => ({ ...p, logo_url: "" }))} style={{ padding: "8px 10px", background: "#b02a37", color: "white", border: "none", borderRadius: 6, width: "fit-content" }}>Logo verwijderen</button>
          </>
        ) : null}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <h4 style={{ marginBottom: 2 }}>Documentteksten</h4>
        <label>Introductietekst</label>
        <textarea rows={4} value={mkbWorkOrderSettings.intro_text || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, intro_text: e.target.value }))} />
        <label>Titel blok Uitvoering</label>
        <input value={mkbWorkOrderSettings.execution_title || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, execution_title: e.target.value }))} />
        <label>Titel blok Oplevering</label>
        <input value={mkbWorkOrderSettings.completion_title || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, completion_title: e.target.value }))} />
        <label>Titel opdrachtwerkzaamheden</label>
        <input value={mkbWorkOrderSettings.work_title || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, work_title: e.target.value }))} />
        <label>Titel extra werkzaamheden</label>
        <input value={mkbWorkOrderSettings.extra_work_title || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, extra_work_title: e.target.value }))} />
        <label>Tekst akkoordblok</label>
        <textarea rows={3} value={mkbWorkOrderSettings.approval_block_text || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, approval_block_text: e.target.value }))} />
        <label>Footer tekst</label>
        <textarea rows={3} value={mkbWorkOrderSettings.footer_text || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, footer_text: e.target.value }))} />
      </div>
    </div>

    <hr style={{ margin: "24px 0 18px" }} />
    <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(2, minmax(300px, 460px))", gap: 18, maxWidth: 980 }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <h4 style={{ marginBottom: 2 }}>E-mail</h4>
        <div style={{ fontSize: 12, color: "#5d6b78", lineHeight: 1.5, marginBottom: 4 }}>
          StaffIQ vult documentnummer, relatie, contactpersoon en verzender automatisch in.
        </div>
        <label>Onderwerp</label>
        <input value={mkbWorkOrderSettings.email_subject || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, email_subject: e.target.value }))} />
        <label>Bericht</label>
        <textarea rows={9} value={mkbWorkOrderSettings.email_text || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, email_text: e.target.value }))} />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <h4 style={{ marginBottom: 2 }}>WhatsApp en digitale accordering</h4>
        <div style={{ fontSize: 12, color: "#5d6b78", lineHeight: 1.5, marginBottom: 4 }}>
          StaffIQ vult beknopte inhoud, akkoordlink en verzender automatisch in.
        </div>
        <label>WhatsApp-bericht</label>
        <textarea rows={9} value={mkbWorkOrderSettings.whatsapp_text || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, whatsapp_text: e.target.value }))} />
        <label>Verklaring bij akkoord</label>
        <textarea rows={3} value={mkbWorkOrderSettings.approval_text || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, approval_text: e.target.value }))} />
        <label>Tekst na akkoord</label>
        <textarea rows={3} value={mkbWorkOrderSettings.approved_page_text || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, approved_page_text: e.target.value }))} />
        <label>Tekst na niet akkoord</label>
        <textarea rows={3} value={mkbWorkOrderSettings.rejected_page_text || ""} disabled={!isAdmin} onChange={(e) => setMkbWorkOrderSettings((p) => ({ ...p, rejected_page_text: e.target.value }))} />
      </div>
    </div>

    {renderVariableInfo([
      { title: "Document", variables: ["{document_nummer}", "{bedrijfscode}"] },
      { title: "Relatie en persoon", variables: ["{relatie}", "{contactpersoon}"] },
      { title: "Workflow", variables: ["{beknopte_inhoud}", "{akkoordlink}"] },
      { title: "Afzender", variables: ["{verzender_naam}", "{verzender_email}"] },
    ])}

    <div style={{ marginTop: 18 }}>
      <button type="button" onClick={saveMkbWorkOrderSettings} disabled={!isAdmin} style={{ padding: "10px", background: "#1f4e79", color: "white", border: "none", borderRadius: 6, cursor: isAdmin ? "pointer" : "not-allowed", opacity: isAdmin ? 1 : 0.5 }}>
        Opslaan werkboninstellingen
      </button>
    </div>
  </>
 ) : view === "hrm_vacancies" ? (
  renderHrmDocumentSettings({
    title: "HRM - Vacatures",
    sectionKey: "hrm_vacancies",
    settings: hrmVacancySettings,
    setSettings: setHrmVacancySettings,
    loading: hrmVacancySettingsLoading,
    flash: hrmVacancyFlash,
    save: saveHrmVacancySettings,
    vacancy: true,
  })
) : view === "hrm_placement_customer" ? (
  renderHrmDocumentSettings({
    title: "HRM - Plaatsingsbevestiging klant",
    sectionKey: "hrm_placement_customer",
    settings: hrmPlacementCustomerSettings,
    setSettings: setHrmPlacementCustomerSettings,
    loading: hrmPlacementCustomerSettingsLoading,
    flash: hrmPlacementCustomerFlash,
    save: saveHrmPlacementCustomerSettings,
    placement: true,
  })
) : view === "hrm_placement_candidate" ? (
  renderHrmDocumentSettings({
    title: "HRM - Plaatsingsbevestiging kandidaat",
    sectionKey: "hrm_placement_candidate",
    settings: hrmPlacementCandidateSettings,
    setSettings: setHrmPlacementCandidateSettings,
    loading: hrmPlacementCandidateSettingsLoading,
    flash: hrmPlacementCandidateFlash,
    save: saveHrmPlacementCandidateSettings,
    placement: true,
    candidate: true,
  })
) : view === "hrm_matching_personnel" ? (
  renderHrmMatchingSettings({ type: "personnel" })
) : view === "hrm_matching_relations" ? (
  renderHrmMatchingSettings({ type: "relations" })
) : view === "offers" ? (
  <>
    <h3>Offerte-instellingen</h3>

    {renderSettingsCompanyCodeSelector("mkb_offers")}
    {renderMkbLetterheadSettings("mkb_offers")}

    {mkbOfferSettingsLoading && <div style={{ marginBottom: 12 }}>Laden...</div>}

    {invoiceFlash && (
      <div
        style={{
          marginBottom: 12,
          padding: "10px 12px",
          background: "#eaf7ea",
          color: "#1f6b1f",
          border: "1px solid #b7dfb7",
          borderRadius: 6,
          maxWidth: 700,
        }}
      >
        {invoiceFlash}
      </div>
    )}

    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobile
          ? "1fr"
          : "repeat(2, minmax(280px, 420px))",
        gap: 12,
        alignItems: "start",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
<label>E-mail</label>
        <input
          value={mkbOfferSettings.offer_company_email || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOfferSettings((prev) => ({ ...prev, offer_company_email: e.target.value }))
          }
        />

        <label>Website</label>
        <input
          value={mkbOfferSettings.offer_company_website || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOfferSettings((prev) => ({ ...prev, offer_company_website: e.target.value }))
          }
          placeholder="bijv. www.staffiq.nl"
        />

        <label>Telefoon</label>
        <input
          value={mkbOfferSettings.offer_company_phone || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOfferSettings((prev) => ({ ...prev, offer_company_phone: e.target.value }))
          }
        />

        <label>KvK</label>
        <input
          value={mkbOfferSettings.offer_company_kvk || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOfferSettings((prev) => ({ ...prev, offer_company_kvk: e.target.value }))
          }
        />

        <label>BTW-nummer</label>
        <input
          value={mkbOfferSettings.offer_company_vat || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOfferSettings((prev) => ({ ...prev, offer_company_vat: e.target.value }))
          }
        />

        <label>IBAN</label>
        <input
          value={mkbOfferSettings.offer_company_iban || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOfferSettings((prev) => ({ ...prev, offer_company_iban: e.target.value }))
          }
        />

        <label>G-rekening</label>
        <input
          value={mkbOfferSettings.offer_company_g_iban || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOfferSettings((prev) => ({ ...prev, offer_company_g_iban: e.target.value }))
          }
        />

        <label>Logo upload</label>
        <input
          type="file"
          accept="image/*"
          disabled={!isAdmin}
          onChange={handleMkbOfferLogoUpload}
        />

        <div style={{ fontSize: 12, opacity: 0.75 }}>
          Kies een png, jpg, jpeg of svg bestand vanaf je computer.
        </div>

        {mkbOfferSettings.logo_url ? (
          <>
            <div style={{ marginTop: 8 }}>
              <img
                src={mkbOfferSettings.logo_url}
                alt="Logo preview"
                style={{
                  maxWidth: 220,
                  maxHeight: 100,
                  objectFit: "contain",
                  display: "block",
                  border: "1px solid #ddd",
                  padding: 6,
                  background: "#fff",
                }}
              />
            </div>

            <button
              type="button"
              disabled={!isAdmin}
              onClick={() =>
                setMkbOfferSettings((prev) => ({ ...prev, logo_url: "" }))
              }
              style={{
                marginTop: 8,
                padding: "8px 10px",
                background: "#b02a37",
                color: "white",
                border: "none",
                borderRadius: 6,
                cursor: isAdmin ? "pointer" : "not-allowed",
                opacity: isAdmin ? 1 : 0.5,
                width: "fit-content",
              }}
            >
              Logo verwijderen
            </button>
          </>
        ) : (
          <div style={{ fontSize: 12, opacity: 0.7 }}>
            Nog geen logo gekozen.
          </div>
        )}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <label>Titel</label>
        <input
          value={mkbOfferSettings.offer_title || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOfferSettings((prev) => ({ ...prev, offer_title: e.target.value }))
          }
        />

        <label>Contactpersoon</label>
        <input
          value={mkbOfferSettings.offer_contact_person || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOfferSettings((prev) => ({ ...prev, offer_contact_person: e.target.value }))
          }
        />

        <label>Bedrijfsnaam</label>
        <input
          value={mkbOfferSettings.offer_company_name || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOfferSettings((prev) => ({ ...prev, offer_company_name: e.target.value }))
          }
        />

        <label>Adresregel 1</label>
        <input
          value={mkbOfferSettings.offer_company_address_1 || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOfferSettings((prev) => ({ ...prev, offer_company_address_1: e.target.value }))
          }
        />

        <label>Adresregel 2</label>
        <input
          value={mkbOfferSettings.offer_company_address_2 || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOfferSettings((prev) => ({ ...prev, offer_company_address_2: e.target.value }))
          }
        />

        <label>Postcode</label>
        <input
          value={mkbOfferSettings.offer_company_postcode || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOfferSettings((prev) => ({ ...prev, offer_company_postcode: e.target.value }))
          }
        />

        <label>Plaats</label>
        <input
          value={mkbOfferSettings.offer_company_city || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOfferSettings((prev) => ({ ...prev, offer_company_city: e.target.value }))
          }
        />

        <label>Land</label>
        <input
          value={mkbOfferSettings.offer_company_country || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOfferSettings((prev) => ({ ...prev, offer_company_country: e.target.value }))
          }
        />

        <label>Tekst</label>
        <textarea
          rows={4}
          value={mkbOfferSettings.offer_text || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOfferSettings((prev) => ({ ...prev, offer_text: e.target.value }))
          }
          style={{ resize: "vertical" }}
        />

        <label>Footer tekst</label>
        <textarea
          rows={4}
          value={mkbOfferSettings.offer_footer_text || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOfferSettings((prev) => ({ ...prev, offer_footer_text: e.target.value }))
          }
          style={{ resize: "vertical" }}
        />
      </div>
    </div>

    <hr style={{ margin: "24px 0 18px 0" }} />

    <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(2, minmax(300px, 460px))", gap: 18, maxWidth: 980 }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <h4 style={{ marginBottom: 2 }}>E-mail</h4>
        <label>Onderwerp</label>
        <input
          value={mkbOfferSettings.email_subject || ""}
          disabled={!isAdmin}
          onChange={(e) => setMkbOfferSettings((prev) => ({ ...prev, email_subject: e.target.value }))}
        />
        <label>Bericht</label>
        <textarea
          rows={8}
          value={mkbOfferSettings.email_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setMkbOfferSettings((prev) => ({ ...prev, email_text: e.target.value }))}
          style={{ resize: "vertical" }}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <h4 style={{ marginBottom: 2 }}>WhatsApp en digitale accordering</h4>
        <label>WhatsApp-bericht</label>
        <textarea
          rows={8}
          value={mkbOfferSettings.whatsapp_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setMkbOfferSettings((prev) => ({ ...prev, whatsapp_text: e.target.value }))}
          style={{ resize: "vertical" }}
        />
        <label>Verklaring bij akkoord</label>
        <textarea
          rows={3}
          value={mkbOfferSettings.approval_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setMkbOfferSettings((prev) => ({ ...prev, approval_text: e.target.value }))}
          style={{ resize: "vertical" }}
        />
        <label>Tekst na akkoord</label>
        <textarea
          rows={3}
          value={mkbOfferSettings.approved_page_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setMkbOfferSettings((prev) => ({ ...prev, approved_page_text: e.target.value }))}
          style={{ resize: "vertical" }}
        />
        <label>Tekst na niet akkoord</label>
        <textarea
          rows={3}
          value={mkbOfferSettings.rejected_page_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setMkbOfferSettings((prev) => ({ ...prev, rejected_page_text: e.target.value }))}
          style={{ resize: "vertical" }}
        />
      </div>
    </div>

    {renderVariableInfo([
      { title: "Document", variables: ["{referentie}", "{bedrijfscode}"] },
      { title: "Relatie en persoon", variables: ["{relatie}", "{contactpersoon}"] },
      { title: "Workflow", variables: ["{beknopte_inhoud}", "{akkoordlink}"] },
      { title: "Afzender", variables: ["{verzender_naam}", "{verzender_email}"] },
    ])}

    <div style={{ marginTop: 18, maxWidth: 320 }}>
      <label>Standaard geldigheid in dagen</label>
      <input
        type="number"
        min="1"
        max="365"
        value={mkbOfferSettings.validity_days || 14}
        disabled={!isAdmin}
        onChange={(e) => setMkbOfferSettings((prev) => ({ ...prev, validity_days: Number(e.target.value || 14) }))}
      />
    </div>

    <div
      style={{
        marginTop: 16,
        paddingTop: 10,
        borderTop: "1px solid #eee",
        display: "flex",
        gap: 10,
      }}
    >
      <button
        onClick={saveMkbOfferSettings}
        disabled={!isAdmin}
        style={{
          padding: "10px",
          background: "#1f4e79",
          color: "white",
          border: "none",
          cursor: isAdmin ? "pointer" : "not-allowed",
          borderRadius: 6,
          opacity: isAdmin ? 1 : 0.5,
        }}
      >
        Opslaan offerte-instellingen
      </button>
    </div>

    <hr style={{ margin: "26px 0 18px 0" }} />

    <h3 ref={offerTemplatesSectionRef}>Offerte-/opdrachtsjablonen</h3>

    {templateFlash && (
      <div
        style={{
          marginBottom: 12,
          padding: "10px 12px",
          background: "#eaf7ea",
          color: "#1f6b1f",
          border: "1px solid #b7dfb7",
          borderRadius: 6,
          maxWidth: 700,
        }}
      >
        {templateFlash}
      </div>
    )}

    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "260px minmax(0, 1fr)",
        gap: 16,
        alignItems: "start",
      }}
    >
      <div
        style={{
          border: "1px solid #d9e2ec",
          borderRadius: 8,
          padding: 10,
          background: "#fff",
        }}
      >
        <button
          type="button"
          onClick={newOfferTemplate}
          disabled={!isAdmin}
          style={{
            width: "100%",
            padding: "9px 10px",
            background: "#1f4e79",
            color: "white",
            border: "none",
            borderRadius: 6,
            cursor: isAdmin ? "pointer" : "not-allowed",
            opacity: isAdmin ? 1 : 0.5,
            marginBottom: 10,
          }}
        >
          + Nieuw sjabloon
        </button>

        <div style={{ display: "grid", gap: 6 }}>
          {offerTemplates.length === 0 ? (
            <div style={{ fontSize: 13, opacity: 0.7 }}>Nog geen sjablonen.</div>
          ) : (
            offerTemplates.map((tpl) => (
              <button
                key={tpl.id}
                type="button"
                onClick={() => setSelectedOfferTemplate({ ...emptyOfferTemplate, ...tpl })}
                style={{
                  textAlign: "left",
                  padding: "8px 9px",
                  border: "1px solid #d9e2ec",
                  borderRadius: 6,
                  background: String(selectedOfferTemplate?.id || "") === String(tpl.id || "") ? "#e6f0ff" : "#fff",
                  cursor: "pointer",
                }}
              >
                <div style={{ fontWeight: 600 }}>{tpl.name || "(zonder naam)"}</div>
                <div style={{ fontSize: 12, opacity: 0.7 }}>
                  {tpl.template_type === "order" ? "Opdracht" : tpl.template_type === "both" ? "Beide" : "Offerte"}
                  {tpl.active === false ? " · inactief" : ""}
                </div>
              </button>
            ))
          )}
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <label>Naam sjabloon</label>
        <input
          value={selectedOfferTemplate.name || ""}
          disabled={!isAdmin}
          onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, name: e.target.value })}
          placeholder="Bijv. Productie - Offerte PVC Click"
        />

        <label>Type</label>
        <select
          value={selectedOfferTemplate.template_type || "offer"}
          disabled={!isAdmin}
          onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, template_type: e.target.value })}
        >
          <option value="offer">Offerte</option>
          <option value="order">Opdrachtbevestiging</option>
          <option value="both">Beide</option>
        </select>

        {renderOfferTemplateShowLabel("Onderwerp", "show_subject")}
        <RichTextEditor
          value={selectedOfferTemplate.subject || ""}
          disabled={!isAdmin}
          minHeight={70}
          placeholder="Bijv. prijsopgave Click pvc-vloer"
          onChange={(value) =>
            setSelectedOfferTemplate((prev) => ({ ...prev, subject: value }))
          }
        />

        {renderOfferTemplateShowLabel("Aanhef", "show_salutation")}
        <div style={{ fontSize: 12, color: "#555", marginBottom: 5 }}>
          Automatisch uit Relaties: <b>{"{aanhef}"}</b>. Geen spaties binnen of na de accolades nodig. Een leeg veld wordt bij Opslaan automatisch aangevuld.
        </div>
        <RichTextEditor
          value={selectedOfferTemplate.salutation || "{aanhef}"}
          disabled={!isAdmin}
          minHeight={70}
          placeholder="{aanhef}"
          onChange={(value) =>
            setSelectedOfferTemplate({ ...selectedOfferTemplate, salutation: value })
          }
        />
        {renderOfferTemplateShowLabel("Introductietekst", "show_intro_text")}
        <RichTextEditor
          value={selectedOfferTemplate.intro_text || ""}
          disabled={!isAdmin}
          minHeight={120}
          onChange={(value) =>
            setSelectedOfferTemplate({ ...selectedOfferTemplate, intro_text: value })
          }
        />

        {renderOfferTemplateShowLabel("Hoofdtekst", "show_body_text")}
        <RichTextEditor
          value={selectedOfferTemplate.body_text || ""}
          disabled={!isAdmin}
          minHeight={180}
          onChange={(value) =>
            setSelectedOfferTemplate({ ...selectedOfferTemplate, body_text: value })
          }
        />

        {renderOfferTemplateShowLabel("Voorwaarden", "show_conditions_text")}
        <RichTextEditor
          value={selectedOfferTemplate.conditions_text || ""}
          disabled={!isAdmin}
          minHeight={150}
          onChange={(value) =>
            setSelectedOfferTemplate({ ...selectedOfferTemplate, conditions_text: value })
          }
        />

        {renderOfferTemplateShowLabel("Betaling", "show_payment_text")}
        <RichTextEditor
          value={selectedOfferTemplate.payment_text || ""}
          disabled={!isAdmin}
          minHeight={100}
          onChange={(value) =>
            setSelectedOfferTemplate({ ...selectedOfferTemplate, payment_text: value })
          }
        />

        {renderOfferTemplateShowLabel("Planning", "show_planning_text")}
        <RichTextEditor
          value={selectedOfferTemplate.planning_text || ""}
          disabled={!isAdmin}
          minHeight={100}
          onChange={(value) =>
            setSelectedOfferTemplate({ ...selectedOfferTemplate, planning_text: value })
          }
        />

        {renderOfferTemplateShowLabel("Opmerking", "show_remark_text")}
        <RichTextEditor
          value={selectedOfferTemplate.remark_text || ""}
          disabled={!isAdmin}
          minHeight={100}
          onChange={(value) =>
            setSelectedOfferTemplate({ ...selectedOfferTemplate, remark_text: value })
          }
        />

        {renderOfferTemplateShowLabel("Garantie", "show_warranty_text")}
        <RichTextEditor
          value={selectedOfferTemplate.warranty_text || ""}
          disabled={!isAdmin}
          minHeight={100}
          onChange={(value) =>
            setSelectedOfferTemplate({ ...selectedOfferTemplate, warranty_text: value })
          }
        />

        {renderOfferTemplateShowLabel("Afsluiting", "show_closing_text")}
        <RichTextEditor
          value={selectedOfferTemplate.closing_text || ""}
          disabled={!isAdmin}
          minHeight={100}
          onChange={(value) =>
            setSelectedOfferTemplate({ ...selectedOfferTemplate, closing_text: value })
          }
        />

        {renderOfferTemplateShowLabel("Akkoordtekst", "show_agreement_block")}
        <RichTextEditor
          value={selectedOfferTemplate.agreement_text || ""}
          disabled={!isAdmin}
          minHeight={100}
          onChange={(value) =>
            setSelectedOfferTemplate({ ...selectedOfferTemplate, agreement_text: value })
          }
        />

        <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <input
            type="checkbox"
            checked={selectedOfferTemplate.active !== false}
            disabled={!isAdmin}
            onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, active: e.target.checked })}
          />
          Actief
        </label>

        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 10 }}>
          <button
            type="button"
            onClick={saveOfferTemplate}
            disabled={!isAdmin}
            style={{
              padding: "10px",
              background: "#1f4e79",
              color: "white",
              border: "none",
              cursor: isAdmin ? "pointer" : "not-allowed",
              borderRadius: 6,
              opacity: isAdmin ? 1 : 0.5,
            }}
          >
            Opslaan sjabloon
          </button>

          <button
            type="button"
            onClick={deleteOfferTemplate}
            disabled={!isAdmin || !selectedOfferTemplate?.id}
            style={{
              padding: "10px",
              background: "#b02a37",
              color: "white",
              border: "none",
              cursor: isAdmin && selectedOfferTemplate?.id ? "pointer" : "not-allowed",
              borderRadius: 6,
              opacity: isAdmin && selectedOfferTemplate?.id ? 1 : 0.5,
            }}
          >
            Verwijderen
          </button>
        </div>
      </div>
    </div>
  </>

        ) : view === "order_settings" ? (
  <>
    <h3>Opdracht-instellingen</h3>

    {renderSettingsCompanyCodeSelector("mkb_orders")}
    {renderMkbLetterheadSettings("mkb_orders")}

    {mkbOrderSettingsLoading && <div style={{ marginBottom: 12 }}>Laden...</div>}

    {mkbOrderFlash && (
      <div
        style={{
          marginBottom: 12,
          padding: "10px 12px",
          background: "#eaf7ea",
          color: "#1f6b1f",
          border: "1px solid #b7dfb7",
          borderRadius: 6,
          maxWidth: 700,
        }}
      >
        {mkbOrderFlash}
      </div>
    )}

    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobile
          ? "1fr"
          : "repeat(2, minmax(280px, 420px))",
        gap: 12,
        alignItems: "start",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <label>E-mail</label>
        <input
          value={mkbOrderSettings.company_email || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              company_email: e.target.value,
            }))
          }
        />

        <label>Website</label>
        <input
          value={mkbOrderSettings.company_website || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              company_website: e.target.value,
            }))
          }
          placeholder="bijv. www.staffiq.nl"
        />

        <label>Telefoon</label>
        <input
          value={mkbOrderSettings.company_phone || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              company_phone: e.target.value,
            }))
          }
        />

        <label>KvK</label>
        <input
          value={mkbOrderSettings.company_kvk || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              company_kvk: e.target.value,
            }))
          }
        />

        <label>BTW-nummer</label>
        <input
          value={mkbOrderSettings.company_vat || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              company_vat: e.target.value,
            }))
          }
        />

        <label>IBAN</label>
        <input
          value={mkbOrderSettings.company_iban || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              company_iban: e.target.value,
            }))
          }
        />

        <label>G-rekening</label>
        <input
          value={mkbOrderSettings.company_g_iban || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              company_g_iban: e.target.value,
            }))
          }
        />

        <label>Logo upload</label>
        <input
          type="file"
          accept="image/*"
          disabled={!isAdmin}
          onChange={handleMkbOrderLogoUpload}
        />

        <div style={{ fontSize: 12, opacity: 0.75 }}>
          Kies een png, jpg, jpeg of svg bestand vanaf je computer.
        </div>

        {mkbOrderSettings.logo_url ? (
          <>
            <div style={{ marginTop: 8 }}>
              <img
                src={mkbOrderSettings.logo_url}
                alt="Logo opdracht"
                style={{
                  maxWidth: 220,
                  maxHeight: 100,
                  objectFit: "contain",
                  display: "block",
                  border: "1px solid #ddd",
                  padding: 6,
                  background: "#fff",
                }}
              />
            </div>

            <button
              type="button"
              disabled={!isAdmin}
              onClick={() =>
                setMkbOrderSettings((prev) => ({
                  ...prev,
                  logo_url: "",
                }))
              }
              style={{
                marginTop: 8,
                padding: "8px 10px",
                background: "#b02a37",
                color: "white",
                border: "none",
                borderRadius: 6,
                cursor: isAdmin ? "pointer" : "not-allowed",
                opacity: isAdmin ? 1 : 0.5,
                width: "fit-content",
              }}
            >
              Logo verwijderen
            </button>
          </>
        ) : (
          <div style={{ fontSize: 12, opacity: 0.7 }}>
            Nog geen logo gekozen.
          </div>
        )}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <label>Titel</label>
        <input
          value={mkbOrderSettings.document_title || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              document_title: e.target.value,
            }))
          }
        />

        <label>Contactpersoon</label>
        <input
          value={mkbOrderSettings.contact_person || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              contact_person: e.target.value,
            }))
          }
        />

        <label>Bedrijfsnaam</label>
        <input
          value={mkbOrderSettings.company_name || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              company_name: e.target.value,
            }))
          }
        />

        <label>Adresregel 1</label>
        <input
          value={mkbOrderSettings.company_address_1 || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              company_address_1: e.target.value,
            }))
          }
        />

        <label>Adresregel 2</label>
        <input
          value={mkbOrderSettings.company_address_2 || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              company_address_2: e.target.value,
            }))
          }
        />

        <label>Postcode</label>
        <input
          value={mkbOrderSettings.company_postcode || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              company_postcode: e.target.value,
            }))
          }
        />

        <label>Plaats</label>
        <input
          value={mkbOrderSettings.company_city || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              company_city: e.target.value,
            }))
          }
        />

        <label>Land</label>
        <input
          value={mkbOrderSettings.company_country || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              company_country: e.target.value,
            }))
          }
        />

        <label>Tekst</label>
        <textarea
          rows={4}
          value={mkbOrderSettings.intro_text || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              intro_text: e.target.value,
            }))
          }
          style={{ resize: "vertical" }}
        />

        <label>Footer tekst</label>
        <textarea
          rows={4}
          value={mkbOrderSettings.footer_text || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              footer_text: e.target.value,
            }))
          }
          style={{ resize: "vertical" }}
        />
      </div>
    </div>

    <hr style={{ margin: "24px 0 18px 0" }} />

    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobile
          ? "1fr"
          : "repeat(2, minmax(300px, 460px))",
        gap: 18,
        maxWidth: 980,
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <h4 style={{ marginBottom: 2 }}>E-mail</h4>

        <label>Onderwerp</label>
        <input
          value={mkbOrderSettings.email_subject || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              email_subject: e.target.value,
            }))
          }
        />

        <label>Bericht</label>
        <textarea
          rows={8}
          value={mkbOrderSettings.email_text || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              email_text: e.target.value,
            }))
          }
          style={{ resize: "vertical" }}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <h4 style={{ marginBottom: 2 }}>
          WhatsApp en digitale accordering
        </h4>

        <label>WhatsApp-bericht</label>
        <textarea
          rows={8}
          value={mkbOrderSettings.whatsapp_text || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              whatsapp_text: e.target.value,
            }))
          }
          style={{ resize: "vertical" }}
        />

        <label>Verklaring bij akkoord</label>
        <textarea
          rows={3}
          value={mkbOrderSettings.approval_text || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              approval_text: e.target.value,
            }))
          }
          style={{ resize: "vertical" }}
        />

        <label>Tekst na akkoord</label>
        <textarea
          rows={3}
          value={mkbOrderSettings.approved_page_text || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              approved_page_text: e.target.value,
            }))
          }
          style={{ resize: "vertical" }}
        />

        <label>Tekst na niet akkoord</label>
        <textarea
          rows={3}
          value={mkbOrderSettings.rejected_page_text || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setMkbOrderSettings((prev) => ({
              ...prev,
              rejected_page_text: e.target.value,
            }))
          }
          style={{ resize: "vertical" }}
        />
      </div>
    </div>

    {renderVariableInfo([
      { title: "Document", variables: ["{referentie}", "{bedrijfscode}"] },
      { title: "Relatie en persoon", variables: ["{relatie}", "{contactpersoon}"] },
      { title: "Workflow", variables: ["{beknopte_inhoud}", "{akkoordlink}"] },
      { title: "Afzender", variables: ["{verzender_naam}", "{verzender_email}"] },
    ])}

    <div
      style={{
        marginTop: 18,
        maxWidth: 700,
        padding: "12px 14px",
        border: "1px solid #d9e2ec",
        borderRadius: 6,
        background: "#fafafa",
      }}
    >
      <label
        style={{
          display: "flex",
          gap: 10,
          alignItems: "center",
          fontWeight: 700,
        }}
      >
        <input
          type="checkbox"
          checked={orderSettings.use_work_orders === true}
          disabled={!isAdmin}
          onChange={(e) =>
            setOrderSettings((prev) => ({
              ...prev,
              use_work_orders: e.target.checked,
            }))
          }
        />
        Werkbonnen en opleveringen gebruiken
      </label>

      <div
        style={{
          marginTop: 6,
          fontSize: 12,
          color: "#666",
          lineHeight: 1.5,
        }}
      >
        Bij Nee blijft de eenvoudige route Offerte → Opdracht → Factuur
        beschikbaar.
      </div>
    </div>

    <div
      style={{
        marginTop: 16,
        paddingTop: 10,
        borderTop: "1px solid #eee",
        display: "flex",
        gap: 10,
        flexWrap: "wrap",
      }}
    >
      <button
        onClick={saveMkbOrderSettings}
        disabled={!isAdmin}
        style={{
          padding: "10px",
          background: "#1f4e79",
          color: "white",
          border: "none",
          cursor: isAdmin ? "pointer" : "not-allowed",
          borderRadius: 6,
          opacity: isAdmin ? 1 : 0.5,
        }}
      >
        Opslaan opdrachtinstellingen
      </button>


    </div>
  </>

) : view === "invoice" ? (
  <>
    <h3>Factuurinstellingen <span style={{ fontSize: 13, color: "#777" }}>{VERSION}</span></h3>

    {invoiceFlash && (
      <div
        style={{
          marginBottom: 12,
          padding: "10px 12px",
          background: "#eaf7ea",
          color: "#1f6b1f",
          border: "1px solid #b7dfb7",
          borderRadius: 6,
          maxWidth: 700,
        }}
      >
        {invoiceFlash}
      </div>
    )}

    {!isAdmin && (
      <div
        style={{
          marginBottom: 12,
          padding: "10px 12px",
          background: "#fff7e6",
          color: "#8a5a00",
          border: "1px solid #f2d38a",
          borderRadius: 6,
          maxWidth: 700,
        }}
      >
        Alleen de administrator mag deze instellingen wijzigen.
      </div>
    )}

    <h4 style={{ margin: "8px 0 10px 0" }}>Factuurnummering</h4>
    <div style={{ fontSize: 13, color: "#666", marginBottom: 12, lineHeight: 1.5 }}>
      De nummerreeks geldt voor de volledige StaffIQ-omgeving en staat los van de bedrijfscode.
    </div>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "repeat(2, minmax(280px, 420px))",
        gap: 12,
        alignItems: "start",
        maxWidth: 860,
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <label>Startdatum nummerreeks</label>
        <input type="date" value={invoiceSettings.numbering_start_date || ""} disabled={!isAdmin}
          onChange={(e) => setInvoiceSettings((prev) => ({ ...prev, numbering_start_date: e.target.value }))} />
        <label>Prefix</label>
        <input value={invoiceSettings.numbering_prefix || ""} disabled={!isAdmin}
          onChange={(e) => setInvoiceSettings((prev) => ({ ...prev, numbering_prefix: e.target.value }))}
          placeholder="bijv. 2026- of SIQ26-" />
        <label>Volgend nummer</label>
        <input type="number" value={invoiceSettings.numbering_next || 1} disabled={!isAdmin}
          onChange={(e) => setInvoiceSettings((prev) => ({ ...prev, numbering_next: Number(e.target.value || 1) }))} />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <label>Aantal cijfers</label>
        <input type="number" value={invoiceSettings.numbering_padding || 4} disabled={!isAdmin}
          onChange={(e) => setInvoiceSettings((prev) => ({ ...prev, numbering_padding: Number(e.target.value || 4) }))} />
        <label>Patroon</label>
        <input value={invoiceSettings.numbering_pattern || ""} disabled={!isAdmin}
          onChange={(e) => setInvoiceSettings((prev) => ({ ...prev, numbering_pattern: e.target.value }))}
          placeholder="bijv. PREFIXNNNN" />
        <div style={{ marginTop: 6, fontSize: 12, opacity: 0.75, lineHeight: 1.5 }}>
          Voorbeeld: prefix <b>2026-</b>, vier cijfers en volgend nummer <b>1</b> wordt <b>2026-0001</b>.
        </div>
      </div>
    </div>

    <div style={{ marginTop: 16, paddingTop: 10, borderTop: "1px solid #eee" }}>
      <button onClick={saveInvoiceSettings} disabled={!isAdmin}
        style={{ padding: "10px", background: "#1f4e79", color: "white", border: "none", cursor: isAdmin ? "pointer" : "not-allowed", borderRadius: 6, opacity: isAdmin ? 1 : 0.5 }}>
        Opslaan nummering
      </button>
    </div>

    <hr style={{ margin: "26px 0 18px 0" }} />

    <h4 style={{ margin: "0 0 10px 0" }}>Bedrijfs- en documentgegevens</h4>
    {renderSettingsCompanyCodeSelector("mkb_invoices")}
    {renderMkbLetterheadSettings("mkb_invoices")}
    {mkbInvoiceSettingsLoading && <div style={{ marginBottom: 12 }}>Laden...</div>}

    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "repeat(2, minmax(280px, 420px))",
        gap: 12,
        alignItems: "start",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <label>E-mail</label>
        <input value={mkbInvoiceSettings.company_email || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, company_email: e.target.value }))} />
        <label>Website</label>
        <input value={mkbInvoiceSettings.company_website || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, company_website: e.target.value }))}
          placeholder="bijv. www.staffiq.nl" />
        <label>Telefoon</label>
        <input value={mkbInvoiceSettings.company_phone || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, company_phone: e.target.value }))} />
        <label>KvK</label>
        <input value={mkbInvoiceSettings.company_kvk || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, company_kvk: e.target.value }))} />
        <label>BTW-nummer</label>
        <input value={mkbInvoiceSettings.company_vat || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, company_vat: e.target.value }))} />
        <label>IBAN</label>
        <input value={mkbInvoiceSettings.company_iban || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, company_iban: e.target.value }))} />
        <label>G-rekening</label>
        <input value={mkbInvoiceSettings.company_g_iban || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, company_g_iban: e.target.value }))} />
        <label>Logo upload</label>
        <input type="file" accept="image/*" disabled={!isAdmin} onChange={handleMkbInvoiceLogoUpload} />
        <div style={{ fontSize: 12, opacity: 0.75 }}>Kies een png, jpg, jpeg of svg bestand vanaf je computer.</div>
        {mkbInvoiceSettings.logo_url ? (
          <>
            <div style={{ marginTop: 8 }}>
              <img src={mkbInvoiceSettings.logo_url} alt="Logo factuur"
                style={{ maxWidth: 220, maxHeight: 100, objectFit: "contain", display: "block", border: "1px solid #ddd", padding: 6, background: "#fff" }} />
            </div>
            <button type="button" disabled={!isAdmin}
              onClick={() => setMkbInvoiceSettings((prev) => ({ ...prev, logo_url: "" }))}
              style={{ marginTop: 8, padding: "8px 10px", background: "#b02a37", color: "white", border: "none", borderRadius: 6, cursor: isAdmin ? "pointer" : "not-allowed", opacity: isAdmin ? 1 : 0.5, width: "fit-content" }}>
              Logo verwijderen
            </button>
          </>
        ) : <div style={{ fontSize: 12, opacity: 0.7 }}>Nog geen logo gekozen.</div>}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <label>Titel</label>
        <input value={mkbInvoiceSettings.document_title || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, document_title: e.target.value }))} />
        <label>Contactpersoon</label>
        <input value={mkbInvoiceSettings.contact_person || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, contact_person: e.target.value }))} />
        <label>Bedrijfsnaam</label>
        <input value={mkbInvoiceSettings.company_name || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, company_name: e.target.value }))} />
        <label>Adresregel 1</label>
        <input value={mkbInvoiceSettings.company_address_1 || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, company_address_1: e.target.value }))} />
        <label>Adresregel 2</label>
        <input value={mkbInvoiceSettings.company_address_2 || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, company_address_2: e.target.value }))} />
        <label>Postcode</label>
        <input value={mkbInvoiceSettings.company_postcode || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, company_postcode: e.target.value }))} />
        <label>Plaats</label>
        <input value={mkbInvoiceSettings.company_city || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, company_city: e.target.value }))} />
        <label>Land</label>
        <input value={mkbInvoiceSettings.company_country || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, company_country: e.target.value }))} />
        <label>Introductietekst</label>
        <textarea rows={4} value={mkbInvoiceSettings.intro_text || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, intro_text: e.target.value }))}
          style={{ resize: "vertical" }} />
        <label>Betaaltekst</label>
        <textarea rows={4} value={mkbInvoiceSettings.payment_text || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, payment_text: e.target.value }))}
          style={{ resize: "vertical" }} />
        <label>Footer tekst</label>
        <textarea rows={4} value={mkbInvoiceSettings.footer_text || ""} disabled={!isAdmin}
          onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, footer_text: e.target.value }))}
          style={{ resize: "vertical" }} />
      </div>
    </div>

    <hr style={{ margin: "24px 0 18px 0" }} />

    <div style={{ maxWidth: 900, display: "flex", flexDirection: "column", gap: 8 }}>
      <h4 style={{ marginBottom: 2 }}>E-mail</h4>
      <label>Onderwerp</label>
      <input value={mkbInvoiceSettings.email_subject || ""} disabled={!isAdmin}
        onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, email_subject: e.target.value }))} />
      <label>BCC e-mailadres</label>
      <input
        type="email"
        value={mkbInvoiceSettings.email_bcc || ""}
        disabled={!isAdmin}
        onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, email_bcc: e.target.value }))}
        placeholder="bijv. administratie@kantoor.nl"
      />
      <div style={{ fontSize: 12, color: "#5d6b78", lineHeight: 1.5 }}>
        Indien ingevuld ontvangt dit adres automatisch een blinde kopie van iedere verzonden factuur.
      </div>
      <label>Bericht</label>
      <textarea rows={8} value={mkbInvoiceSettings.email_text || ""} disabled={!isAdmin}
        onChange={(e) => setMkbInvoiceSettings((prev) => ({ ...prev, email_text: e.target.value }))}
        style={{ resize: "vertical" }} />
      {renderVariableInfo([
        { title: "Document", variables: ["{document_nummer}", "{bedrijfscode}"] },
        { title: "Relatie en persoon", variables: ["{relatie}", "{contactpersoon}"] },
        { title: "Afzender", variables: ["{verzender_naam}", "{verzender_email}"] },
      ])}
    </div>

    <div style={{ marginTop: 16, paddingTop: 10, borderTop: "1px solid #eee" }}>
      <button onClick={saveMkbInvoiceSettings} disabled={!isAdmin}
        style={{ padding: "10px", background: "#1f4e79", color: "white", border: "none", cursor: isAdmin ? "pointer" : "not-allowed", borderRadius: 6, opacity: isAdmin ? 1 : 0.5 }}>
        Opslaan factuurinstellingen
      </button>
    </div>


<hr style={{ margin: "26px 0 18px 0" }} />

<h3>Factuursjablonen</h3>

<div style={{ fontSize: 13, color: "#666", lineHeight: 1.5, marginBottom: 12 }}>
  Factuursjablonen zijn bewust korter dan offertesjablonen. Gebruik ze voor een compacte introductie,
  betaaltekst en footer op de factuur.
</div>

{invoiceTemplateFlash && (
  <div
    style={{
      marginBottom: 12,
      padding: "10px 12px",
      background: "#eaf7ea",
      color: "#1f6b1f",
      border: "1px solid #b7dfb7",
      borderRadius: 6,
      maxWidth: 700,
    }}
  >
    {invoiceTemplateFlash}
  </div>
)}

<div
  style={{
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "260px minmax(0, 1fr)",
    gap: 16,
    alignItems: "start",
  }}
>
  <div
    style={{
      border: "1px solid #d9e2ec",
      borderRadius: 8,
      padding: 10,
      background: "#fff",
    }}
  >
    <button
      type="button"
      onClick={newInvoiceTemplate}
      disabled={!isAdmin}
      style={{
        width: "100%",
        padding: "9px 10px",
        background: "#1f4e79",
        color: "white",
        border: "none",
        borderRadius: 6,
        cursor: isAdmin ? "pointer" : "not-allowed",
        opacity: isAdmin ? 1 : 0.5,
        marginBottom: 10,
      }}
    >
      + Nieuw factuursjabloon
    </button>

    <div style={{ display: "grid", gap: 6 }}>
      {invoiceTemplates.length === 0 ? (
        <div style={{ fontSize: 13, opacity: 0.7 }}>Nog geen factuursjablonen.</div>
      ) : (
        invoiceTemplates.map((tpl) => (
          <button
            key={tpl.id}
            type="button"
            onClick={() => setSelectedInvoiceTemplate({ ...emptyInvoiceTemplate, ...tpl })}
            style={{
              textAlign: "left",
              padding: "8px 9px",
              border: "1px solid #d9e2ec",
              borderRadius: 6,
              background: String(selectedInvoiceTemplate?.id || "") === String(tpl.id || "") ? "#e6f0ff" : "#fff",
              cursor: "pointer",
            }}
          >
            <div style={{ fontWeight: 600 }}>{tpl.name || "(zonder naam)"}</div>
            <div style={{ fontSize: 12, opacity: 0.7 }}>
              {tpl.active === false ? "inactief" : "actief"}
            </div>
          </button>
        ))
      )}
    </div>
  </div>

  <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
    <label>Naam sjabloon</label>
    <input
      value={selectedInvoiceTemplate.name || ""}
      disabled={!isAdmin}
      onChange={(e) => setSelectedInvoiceTemplate({ ...selectedInvoiceTemplate, name: e.target.value })}
      placeholder="Bijv. Standaard factuur"
    />

    <label>Onderwerp / titel</label>
    <input
      value={selectedInvoiceTemplate.subject || ""}
      disabled={!isAdmin}
      onChange={(e) => setSelectedInvoiceTemplate({ ...selectedInvoiceTemplate, subject: e.target.value })}
      placeholder="Bijv. Factuur uitgevoerde werkzaamheden"
      style={{ fontFamily: "Calibri, Carlito, Arial, sans-serif", fontSize: "11pt" }}
    />

    <label>Introductietekst</label>
    <textarea
      rows={4}
      value={selectedInvoiceTemplate.intro_text || ""}
      disabled={!isAdmin}
      onChange={(e) => setSelectedInvoiceTemplate({ ...selectedInvoiceTemplate, intro_text: e.target.value })}
      style={{ resize: "vertical", fontFamily: "Calibri, Carlito, Arial, sans-serif", fontSize: "11pt" }}
    />

    <label>Betaaltekst</label>
    <textarea
      rows={4}
      value={selectedInvoiceTemplate.payment_text || ""}
      disabled={!isAdmin}
      onChange={(e) => setSelectedInvoiceTemplate({ ...selectedInvoiceTemplate, payment_text: e.target.value })}
      style={{ resize: "vertical", fontFamily: "Calibri, Carlito, Arial, sans-serif", fontSize: "11pt" }}
    />

    <label>Footer tekst</label>
    <textarea
      rows={4}
      value={selectedInvoiceTemplate.footer_text || ""}
      disabled={!isAdmin}
      onChange={(e) => setSelectedInvoiceTemplate({ ...selectedInvoiceTemplate, footer_text: e.target.value })}
      style={{ resize: "vertical", fontFamily: "Calibri, Carlito, Arial, sans-serif", fontSize: "11pt" }}
    />

    <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <input
        type="checkbox"
        checked={selectedInvoiceTemplate.active !== false}
        disabled={!isAdmin}
        onChange={(e) => setSelectedInvoiceTemplate({ ...selectedInvoiceTemplate, active: e.target.checked })}
      />
      Actief
    </label>

    <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 10 }}>
      <button
        type="button"
        onClick={saveInvoiceTemplate}
        disabled={!isAdmin}
        style={{
          padding: "10px",
          background: "#1f4e79",
          color: "white",
          border: "none",
          cursor: isAdmin ? "pointer" : "not-allowed",
          borderRadius: 6,
          opacity: isAdmin ? 1 : 0.5,
        }}
      >
        Opslaan factuursjabloon
      </button>

      <button
        type="button"
        onClick={deleteInvoiceTemplate}
        disabled={!isAdmin || !selectedInvoiceTemplate?.id}
        style={{
          padding: "10px",
          background: "#b02a37",
          color: "white",
          border: "none",
          cursor: isAdmin && selectedInvoiceTemplate?.id ? "pointer" : "not-allowed",
          borderRadius: 6,
          opacity: isAdmin && selectedInvoiceTemplate?.id ? 1 : 0.5,
        }}
      >
        Verwijderen
      </button>
    </div>
  </div>
</div>

          </>
        ) : view === "companycodes" ? (
          <>
            <h3>Bedrijfscodes <span style={{ fontSize: 13, color: "#777" }}>{VERSION}</span></h3>

            {companyCodeFlash && (
              <div
                style={{
                  marginBottom: 12,
                  padding: "10px 12px",
                  background: "#eaf7ea",
                  color: "#1f6b1f",
                  border: "1px solid #b7dfb7",
                  borderRadius: 6,
                  maxWidth: 700,
                }}
              >
                {companyCodeFlash}
              </div>
            )}

            <div
              style={{
                display: "grid",
                gridTemplateColumns: isMobile ? "1fr" : "280px minmax(0, 1fr)",
                gap: 16,
                maxWidth: 900,
              }}
            >
              <div style={{ border: "1px solid #e6e6e6", borderRadius: 6, overflow: "hidden" }}>
                {(companyCodes || []).map((code) => (
                  <div
                    key={code.id}
                    onClick={() => setSelectedCompanyCode(code)}
                    style={{
                      padding: "9px 10px",
                      cursor: "pointer",
                      background: String(selectedCompanyCode?.id || "") === String(code.id || "")
                        ? "#e6f0ff"
                        : "white",
                      borderBottom: "1px solid #eee",
                    }}
                  >
                    <b>{code.name || code.code}</b>
                    {!code.active && (
                      <span style={{ fontSize: 12, color: "#999" }}> · inactief</span>
                    )}
                  </div>
                ))}

                {!companyCodes.length && (
                  <div style={{ padding: 10, opacity: 0.75 }}>
                    Nog geen bedrijfscodes.
                  </div>
                )}
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                <label>Naam bedrijfscode</label>
                <input
                  value={selectedCompanyCode.name || ""}
                  disabled={!isAdmin}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedCompanyCode({
                      ...selectedCompanyCode,
                      name: value,
                      // Bij bestaande bedrijfscodes blijft de technische code gelijk.
                      // Anders zou een naamswijziging onbedoeld een nieuwe bedrijfscode kunnen maken.
                      code: selectedCompanyCode.id ? selectedCompanyCode.code : value,
                    });
                  }}
                  placeholder="Bijvoorbeeld Productie"
                />

                <label>Actief</label>
                <select
                  value={selectedCompanyCode.active === false ? "0" : "1"}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setSelectedCompanyCode({
                      ...selectedCompanyCode,
                      active: e.target.value === "1",
                    })
                  }
                >
                  <option value="1">Ja</option>
                  <option value="0">Nee</option>
                </select>

                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 10 }}>
                  <button
                    type="button"
                    onClick={saveCompanyCode}
                    disabled={!isAdmin}
                    style={{
                      padding: "10px",
                      background: "#1f4e79",
                      color: "white",
                      border: "none",
                      cursor: isAdmin ? "pointer" : "not-allowed",
                      borderRadius: 6,
                      opacity: isAdmin ? 1 : 0.5,
                      width: "fit-content",
                    }}
                  >
                    Opslaan bedrijfscode
                  </button>

                  {selectedCompanyCode?.id && (
                    <button
                      type="button"
                      onClick={deleteCompanyCode}
                      disabled={!isAdmin}
                      style={{
                        padding: "10px",
                        background: "#d64545",
                        color: "white",
                        border: "none",
                        cursor: isAdmin ? "pointer" : "not-allowed",
                        borderRadius: 6,
                        opacity: isAdmin ? 1 : 0.5,
                        width: "fit-content",
                      }}
                    >
                      Verwijderen
                    </button>
                  )}
                </div>

                <div style={{ marginTop: 10, fontSize: 12, opacity: 0.75, lineHeight: 1.5 }}>
                  De standaard bedrijfscode wordt automatisch aangemaakt op basis van de tenantnaam.
                  Zet een bedrijfscode op niet actief als deze niet meer gekozen mag worden.
                  Verwijderen kan alleen als er nog geen records aan gekoppeld zijn.
                </div>
              </div>
            </div>
          </>
        ) : view === "activity" ? (
          <>
            {renderActivityLogView()}
          </>
        ) : !selected ? (
          <p>Selecteer een gebruiker</p>
        ) : (
          <>
            <h3>{selected.display_name || "Nieuwe gebruiker"}</h3>

            {flash && (
              <div
                style={{
                  marginBottom: 12,
                  padding: "10px 12px",
                  background: "#eaf7ea",
                  color: "#1f6b1f",
                  border: "1px solid #b7dfb7",
                  borderRadius: 6,
                  maxWidth: 400,
                }}
              >
                {flash}
              </div>
            )}

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                maxWidth: 400,
              }}
            >
              <label>Naam</label>
              <input
                value={selected.display_name || ""}
                disabled={!isAdmin}
                onChange={(e) =>
                  setSelected({ ...selected, display_name: e.target.value })
                }
              />

              <label>Email</label>
              <input
                value={selected.email || ""}
                disabled={!isAdmin}
                onChange={(e) =>
                  setSelected({ ...selected, email: e.target.value })
                }
              />

              <label>Wachtwoord</label>
              <div style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  value={selected.password || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setSelected({ ...selected, password: e.target.value })
                  }
                  style={{ width: "100%", paddingRight: "40px" }}
                />

                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: 10,
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: 14,
                    color: "#666",
                  }}
                >
                  {showPassword ? "🙈" : "👁"}
                </span>
              </div>

              <label>Actief</label>
              <select
                value={selected.is_active ? "1" : "0"}
                disabled={!isAdmin}
                onChange={(e) =>
                  setSelected({
                    ...selected,
                    is_active: e.target.value === "1",
                  })
                }
              >
                <option value="1">Ja</option>
                <option value="0">Nee</option>
              </select>

              <label>Rol</label>
              <select
                value={selected.role_id || ""}
                disabled={!isAdmin}
                onChange={(e) =>
                  setSelected({ ...selected, role_id: e.target.value })
                }
              >
                {roles.map((r) => (
                  <option key={r.id} value={r.id}>
                    {r.name}
                  </option>
                ))}
              </select>

              {selected?.id && (
                <div
                  style={{
                    marginTop: 12,
                    padding: 12,
                    border: "1px solid #d9e2ec",
                    borderRadius: 6,
                    background: "#fafafa",
                  }}
                >
                  <h4 style={{ margin: "0 0 8px 0" }}>Bedrijfscodes gebruiker</h4>

                  {userCompanyCodesFlash && (
                    <div
                      style={{
                        marginBottom: 10,
                        padding: "8px 10px",
                        background: "#eaf7ea",
                        color: "#1f6b1f",
                        border: "1px solid #b7dfb7",
                        borderRadius: 6,
                      }}
                    >
                      {userCompanyCodesFlash}
                    </div>
                  )}

                  <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    {(userCompanyCodes || []).map((row) => (
                      <div
                        key={row.id}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "24px 1fr 120px",
                          gap: 8,
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={row.allowed === true}
                          disabled={!isAdmin}
                          onChange={(e) =>
                            updateUserCompanyCodeRow(row.id, {
                              allowed: e.target.checked,
                            })
                          }
                        />

                        <div>
                          <b>{row.code}</b>
                          <br />
                          <span style={{ fontSize: 12 }}>{row.name}</span>
                        </div>

                        <select
                          value={row.role || "user"}
                          disabled={!isAdmin || row.allowed !== true}
                          onChange={(e) =>
                            updateUserCompanyCodeRow(row.id, {
                              role: e.target.value,
                            })
                          }
                        >
                          <option value="admin">admin</option>
                          <option value="user">user</option>
                          <option value="readonly">readonly</option>
                        </select>
                      </div>
                    ))}
                  </div>

                  <button
                    type="button"
                    onClick={saveUserCompanyCodes}
                    disabled={!isAdmin}
                    style={{
                      marginTop: 12,
                      padding: "9px 10px",
                      background: "#1f4e79",
                      color: "white",
                      border: "none",
                      cursor: isAdmin ? "pointer" : "not-allowed",
                      borderRadius: 6,
                      opacity: isAdmin ? 1 : 0.5,
                    }}
                  >
                    Opslaan bedrijfscode-rechten
                  </button>
                </div>
              )}

<div style={{ display: "flex", gap: 10, marginTop: 10 }}>
  <button
    onClick={saveUser}
    disabled={!isAdmin}
    style={{
      padding: "10px",
      background: "#1f4e79",
      color: "white",
      border: "none",
      cursor: isAdmin ? "pointer" : "not-allowed",
      borderRadius: 6,
      opacity: isAdmin ? 1 : 0.5,
    }}
  >
    Opslaan
  </button>

{selected?.id && (
  <button
    onClick={async () => {
      if (!window.confirm("Weet je zeker dat je deze gebruiker wilt verwijderen?")) {
        return;
      }

      try {
const token =
  sessionStorage.getItem("token") ||
  localStorage.getItem("token") ||
  "";

const res = await fetch(`${API_BASE}/api/users/${selected.id}`, {
  method: "DELETE",
  headers: {
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  }
});

        const rawText = await res.text();
        let data = {};

        try {
          data = rawText ? JSON.parse(rawText) : {};
        } catch {
          data = { error: rawText || "" };
        }

if (!res.ok) {
  const message =
    data?.error ||
    data?.message ||
    data?.detail ||
    `Verwijderen mislukt (${res.status})`;

  console.log("Delete user fout status:", res.status);
  console.log("Delete user fout data:", data);
  console.log("Delete user fout rawText:", rawText);

  // Als de user al weg is, ook direct uit de lijst halen
  if (res.status === 404) {
    setUsers((prev) =>
      (prev || []).filter((u) => String(u.id) !== String(selected.id))
    );

    setSelected(null);

    setFlash("Gebruiker was al verwijderd ✅");
    setTimeout(() => setFlash(""), 2000);

    setTimeout(() => {
      loadUsers();
    }, 300);

    return;
  }

  alert(
    `Verwijderen mislukt.\n\n` +
    `Status: ${res.status}\n` +
    `Melding: ${message}\n` +
    `Detail: ${data?.detail || "-"}\n` +
    `Code: ${data?.code || "-"}\n` +
    `Tabel: ${data?.table || "-"}\n` +
    `Constraint: ${data?.constraint || "-"}`
  );
  return;
}

// direct uit lijst verwijderen (sneller en zeker)
setUsers((prev) =>
  (prev || []).filter((u) => String(u.id) !== String(selected.id))
);

setSelected(null);

setFlash("Gebruiker verwijderd ✅");
setTimeout(() => setFlash(""), 2000);

// extra zekerheid: daarna opnieuw laden
setTimeout(() => {
  loadUsers();
}, 300);
      } catch (err) {
        console.log("Delete user catch:", err);
        alert(`Fout bij verwijderen: ${err?.message || "onbekend"}`);
      }
    }}
    disabled={!isAdmin}
    style={{
      padding: "10px",
      background: "#b02a37",
      color: "white",
      border: "none",
      cursor: isAdmin ? "pointer" : "not-allowed",
      borderRadius: 6,
      opacity: isAdmin ? 1 : 0.5,
    }}
  >
    Verwijderen
  </button>
)}
</div>
            </div>
          </>
        )}
      </div>
    </div>
  </div>
  );
}